<template>
  <SidebarComponent />

  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">
        <div class="titolo-card">
          <h1>Ordini (Woo + Legacy + Manuali)</h1>
        </div>

        <!-- TOOLBAR FILTRI -->
        <section class="toolbar-card card-surface">
          <div class="filters-header staff-orders-heading-row">
            <button
              type="button"
              class="accordion-toggle staff-button-neutral"
              @click="filtersOpen = !filtersOpen"
              :aria-expanded="filtersOpen"
            >
              <div class="toggle-copy">
                <span class="toggle-title">Filtri e ricerca</span>
                <span class="toggle-subtitle">Affina gli ordini per email, cognome, date o stato</span>
              </div>
              <span class="material-icons" aria-hidden="true">
                {{ filtersOpen ? 'expand_less' : 'expand_more' }}
              </span>
            </button>

            <button class="btn primary staff-button-positive" @click="openCreateModal">
              <span class="material-icons">add</span>
              Nuovo ordine manuale
            </button>
            <router-link
              class="btn warning staff-button-neutral"
              :to="manualInstallmentsLink"
              aria-label="Apri rate manuali"
              title="Apri rate manuali"
            >
              <span class="material-icons" aria-hidden="true">request_quote</span>
              Rate manuali
            </router-link>
          </div>

          <transition name="accordion">
            <div v-show="filtersOpen" class="accordion-panel">
              <div class="toolbar">

                <div class="toolbar-group toolbar-group--lg">
                  <label class="toolbar-label" for="orders-email">Cerca email</label>
                  <input
                    id="orders-email"
                    type="search"
                    class="input"
                    v-model.trim="filters.email"
                    placeholder="es. utente@dominio.com"
                    @keyup.enter="reload"
                  />
                </div>

                <div class="toolbar-group toolbar-group--lg">
                  <label class="toolbar-label" for="orders-surname">Cerca cognome</label>
                  <input
                    id="orders-surname"
                    type="search"
                    class="input"
                    v-model.trim="filters.surname"
                    placeholder="es. Rossi"
                    @keyup.enter="reload"
                  />
                </div>


                <div class="toolbar-group toolbar-group--md">
                  <label class="toolbar-label" for="orders-from">Dal</label>
                  <input id="orders-from" type="date" class="input date-range-input" v-model="filters.fromDate" />
                </div>

                <div class="toolbar-group toolbar-group--md">
                  <label class="toolbar-label" for="orders-to">Al</label>
                  <input id="orders-to" type="date" class="input date-range-input" v-model="filters.toDate" />
                </div>


                <div class="toolbar-group toolbar-group--md">
                  <label class="toolbar-label" for="orders-source">Sorgente</label>
                  <select id="orders-source" v-model="filters.source" class="input" @change="reload">
                    <option value="">Tutte</option>
                    <option value="woocommerce">WooCommerce</option>
                    <option value="legacy">Legacy</option>
                    <option value="manuale">Manuale</option>
                    <option value="fuscofit">Fusco.fit</option>
                  </select>
                </div>

                <div class="toolbar-group toolbar-group--md">
                  <label class="toolbar-label" for="orders-status">Stato</label>
                  <select id="orders-status" v-model="filters.status" class="input" @change="reload">
                    <option value="">Tutti</option>
                    <option v-for="s in knownStatuses" :key="s" :value="s">{{ s }}</option>
                  </select>
                </div>



                <div class="toolbar-group toolbar-group--lg">
                  <label class="toolbar-label" for="orders-product">Prodotto</label>
                  <select
                    id="orders-product"
                    v-model="filters.product"
                    class="input"
                    :class="{ 'input--multi-open': productFilterOpen }"
                    multiple
                    :size="productFilterOpen ? 8 : 1"
                    @focus="productFilterOpen = true"
                    @blur="productFilterOpen = false"
                    @change="reload"
                  >
                    <option disabled value="">Seleziona uno o più prodotti</option>
                    <option v-for="p in productFilterOptions" :key="p.id" :value="p.id">
                      {{ p.name }}{{ p.sku ? ' (' + p.sku + ')' : '' }}
                    </option>
                  </select>
                </div>

                <div class="toolbar-group toolbar-group--md">
                  <label class="toolbar-label" for="orders-studio">Studio</label>
                  <select id="orders-studio" v-model="filters.studio" class="input" @change="reload">
                    <option value="">Tutti</option>
                    <option :value="noStudioFilterValue">NO STUDIO</option>
                    <option v-for="studio in studioOptions" :key="studio" :value="studio">{{ studio }}</option>
                  </select>
                </div>

                <div class="toolbar-group toolbar-group--xs checkbox-group">
                  <label class="checkbox-inline">
                    <input type="checkbox" v-model="filters.hideWelfare" @change="reload" />
                    Nascondi Welfare
                  </label>
                </div>


                <div class="toolbar-actions">
                  <button class="btn primary staff-button-neutral" @click="reload">Cerca</button>
                  <button class="btn ghost staff-button-neutral" :disabled="csvExporting" @click="exportCsv">
                    {{ csvExporting ? `Esporto… ${csvExportMatched} ordini` : 'Esporta CSV' }}
                  </button>
                  <button class="btn ghost staff-button-neutral" @click="resetFilters">Reset</button>
                </div>
              </div>
            </div>
          </transition>
        </section>

        <!-- TABELLA ORDINI -->
        <section class="orders-card card-surface" v-if="orders.length">
          <div class="table-wrap">
            <table class="orders-table">
            <thead>
              <tr>
                <th>Data</th>
                <th>Email</th>
                <th>Stato</th>
                <th>Pagamento</th>
                <th>Totale</th>
                <th>Prodotti</th>
                <th>Note</th>
                <th>Source</th>
                <th>Percorsi</th>
                <th class="actions-col">Azioni</th>
              </tr>
            </thead>

            <tbody>
  <template v-for="o in orders" :key="o._id">
    <!-- Riga principale -->
    <tr :class="['order-row', 'order-row--' + statusClass(o.status), { 'order-row--expanded': expanded[o._id] }]">
      <td class="order-date-cell" data-label="Data ordine">{{ formatDate(o.orderDate) }}</td>
      <td class="email-cell" data-label="Utente">
        <div class="email-cell__content">
          <div class="email-tooltip">
            <div class="table-email">
              {{ o.userEmail || '—' }}
            </div>
            <div v-if="emailTooltipName(o)" class="email-tooltip__content" role="tooltip">
              {{ emailTooltipName(o) }}
            </div>
          </div>
          <button
            type="button"
            class="email-profile-btn staff-button-neutral"
            :disabled="isUserLookupInFlight(o)"
            @click="openUserProfile(o)"
            title="Apri profilo utente"
            aria-label="Apri profilo utente"
          >
            <span class="material-icons" aria-hidden="true">visibility</span>
          </button>
        </div>
      </td>
      <td class="order-status-cell" data-label="Stato">
        <span :class="['status-badge', 'status-badge--' + statusClass(o.status)]">
          <span>{{ formatStatus(o.status) }}</span>
          <span
            v-if="hasNearbyPaidOrder(o)"
            class="status-badge__nearby-icon"
            :title="nearbyPaidOrdersLabel(o)"
            aria-label="Ordine pagato vicino nel tempo"
            role="button"
            tabindex="0"
            @click.stop="showNearbyPaidOrderReference(o)"
            @keyup.enter.stop.prevent="showNearbyPaidOrderReference(o)"
            @keyup.space.stop.prevent="showNearbyPaidOrderReference(o)"
          >
            <span class="material-icons" aria-hidden="true">paid</span>
          </span>
        </span>
      </td>
<td class="payment-cell order-secondary-cell" data-label="Pagamento">
  <div
    class="payment-summary"
    :class="{ 'payment-summary--manual': isManualOrder(o) }"
    :tabindex="isManualOrder(o) ? 0 : -1"
  >
    <span class="payment-pill">{{ formatLabel(o.paymentMethod) }}</span>

    <template v-if="isManualOrder(o)">
      <span class="material-icons payment-summary__icon" aria-hidden="true">info</span>
      <div class="payment-tooltip">
        <div class="payment-tooltip__line">
          <span class="payment-label">Metodo</span>
          <span class="payment-value">{{ formatLabel(o.paymentMethod) }}</span>
        </div>
        <div class="payment-tooltip__line">
          <span class="payment-label">Provider</span>
          <span class="payment-value">
            {{ formatLabel(o.paymentProvider) }}
            <span v-if="o.paymentStatus" class="payment-pill small">{{ formatLabel(o.paymentStatus) }}</span>
          </span>
        </div>
        <div class="payment-tooltip__line">
          <span class="payment-label">Totale</span>
          <span class="payment-value">{{ formatPrice(o.totalPrice) }}</span>
        </div>
        <div class="payment-tooltip__line" v-if="o.paymentProvider === 'alma' && o.almaInstallments">
          <span class="payment-label">Rate</span>
          <span class="payment-value">{{ o.almaInstallments }}</span>
        </div>
        <div class="payment-tooltip__line" v-if="o.paymentProvider === 'alma' && o.almaPaymentState">
          <span class="payment-label">Stato Alma</span>
          <span class="payment-value">{{ formatLabel(o.almaPaymentState) }}</span>
        </div>
        <div class="payment-tooltip__line" v-if="o.paymentProvider === 'alma' && (o.almaSmsStatus || o.almaSmsError)">
          <span class="payment-label">SMS</span>
          <span class="payment-value">
            {{ formatLabel(o.almaSmsStatus || (o.almaSmsError ? 'errore' : '—')) }}
            <small v-if="o.almaSmsError" class="payment-note">{{ o.almaSmsError }}</small>
          </span>
        </div>
        <div class="payment-tooltip__line" v-if="hasManualInstallments(o)">
          <span class="payment-label">Rate manuali</span>
          <span class="payment-value">{{ manualInstallmentsSummary(o.manualInstallments, o) }}</span>
        </div>
        <div v-if="hasManualInstallments(o)" class="manual-plan-tooltip">
          <div class="manual-plan-tooltip__row" v-for="(inst, idx) in o.manualInstallments" :key="inst.id || idx">
            <span>#{{ idx + 1 }}</span>
            <span>{{ formatPrice(inst.amount) }}</span>
            <span>{{ formatLabel(inst.method) }}</span>
            <span>{{ inst.scheduledDate ? formatDate(inst.scheduledDate) : '—' }}</span>
            <span class="plan-status" :class="'plan-status--' + statusClass(manualInstallmentDisplayStatus(inst, o))">
              {{ formatStatus(manualInstallmentDisplayStatus(inst, o)) }}
            </span>
          </div>
        </div>
        <div v-if="o.paypalApproveLink || canRegeneratePayPalLink(o) || (o.almaPaymentUrl && !isTerminalOrder(o)) || o.klarnaPaymentUrl" class="payment-tooltip__actions">
          <template v-if="o.paypalApproveLink">
            <a :href="o.paypalApproveLink" target="_blank" rel="noopener" class="btn tiny primary staff-button-neutral">Apri PayPal</a>
            <button class="btn tiny ghost staff-button-neutral" @click="copy(o.paypalApproveLink)">Copia link</button>
          </template>
          <button
            v-if="canRegeneratePayPalLink(o)"
            class="btn tiny warning staff-button-warning"
            :disabled="isPayPalRegenerating(o)"
            @click.stop="regeneratePayPalLink(o)"
          >
            {{ isPayPalRegenerating(o) ? 'Rigenero...' : 'Rigenera PayPal' }}
          </button>
          <template v-if="o.almaPaymentUrl && !isTerminalOrder(o)">
            <a :href="o.almaPaymentUrl" target="_blank" rel="noopener" class="btn tiny primary staff-button-neutral">Apri Alma</a>
            <button class="btn tiny ghost staff-button-neutral" @click="copy(o.almaPaymentUrl)">Copia link</button>
          </template>
          <template v-if="o.klarnaPaymentUrl">
            <a :href="o.klarnaPaymentUrl" target="_blank" rel="noopener" class="btn tiny primary staff-button-neutral">Apri Klarna</a>
            <button class="btn tiny ghost staff-button-neutral" @click="copy(o.klarnaPaymentUrl)">Copia link</button>
          </template>
        </div>
      </div>
    </template>
  </div>
</td>

<td class="order-total-cell" data-label="Totale">{{ formatPrice(o.totalPrice) }}</td>
      <td class="products-cell" data-label="Prodotti">
        <span :title="formatProductTooltip(o.products)">
          {{ formatProductList(o.products) }}
        </span>
      </td>
      <td class="order-note-cell order-secondary-cell" data-label="Note interne">
        <textarea
          class="order-note-input"
          :value="o.internalReminderNote || ''"
          rows="2"
          maxlength="2000"
          placeholder="Aggiungi nota…"
          aria-label="Note interne dell’ordine"
          title="La nota viene salvata quando esci dal campo"
          :disabled="isOrderNoteSaving(o)"
          @input="clearOrderNoteError(o)"
          @change="saveInternalReminderNote(o, $event)"
          @keydown.ctrl.enter.prevent="$event.target.blur()"
          @keydown.meta.enter.prevent="$event.target.blur()"
        ></textarea>
        <small v-if="isOrderNoteSaving(o)" class="order-note-feedback">Salvataggio…</small>
        <small v-else-if="orderNoteError(o)" class="order-note-feedback order-note-feedback--error">
          {{ orderNoteError(o) }}
        </small>
      </td>
      <td class="order-source-cell order-secondary-cell" data-label="Origine"><span class="badge-src" :data-src="o._source">{{ o._source }}</span></td>

      <!-- Stato percorsi -->
      <td class="order-paths-cell order-secondary-cell" data-label="Percorsi">
        <span v-if="isGiftCardOrder(o)" class="chip neutral">Gift card</span>
        <span v-else-if="percorsiLoading[o.orderId || o._id]" class="chip neutral">Verifico…</span>
        <span v-else-if="(percorsiCount[o.orderId || o._id] || 0) > 0" class="chip done">Creati {{ percorsiCount[o.orderId || o._id] }}</span>
        <span v-else-if="!isEligibleStatus(o)" class="chip neutral">Non idoneo</span>
        <span v-else class="chip warn">Da creare</span>
      </td>

      <!-- Azioni -->
      <td class="actions-cell">
        <button
          class="icon-toggle-btn staff-button-neutral"
          @click="toggleDetails(o)"
          :aria-expanded="!!expanded[o._id]"
          :aria-controls="`order-details-${o._id}`"
          :aria-label="expanded[o._id] ? 'Chiudi dettagli ordine' : 'Dettagli ordine'"
          :title="expanded[o._id] ? 'Nascondi dettagli' : 'Mostra dettagli'"
        >
          <span class="material-icons" aria-hidden="true">
            {{ expanded[o._id] ? 'expand_less' : 'expand_more' }}
          </span>
        </button>
      </td>
    </tr>

    <!-- Riga dettagli -->
    <tr v-show="expanded[o._id]" class="details-row" :id="`order-details-${o._id}`">
      <td colspan="10" class="details-cell">
        <div class="details">
          <div class="meta-grid">
            <div class="kv">
              <span class="k">Importato/Agg.</span>
              <span class="v">{{ formatDate(o.importedAt || o.updatedAt) }}</span>
            </div>
            <div class="kv">
              <span class="k">Order ID</span>
              <span class="v">{{ o.orderId ?? '—' }}</span>
            </div>
            <div class="kv">
              <span class="k">Provider</span>
              <span class="v">{{ o.paymentProvider || '—' }}</span>
            </div>
            <div class="kv">
              <span class="k">Stato pagamento</span>
              <span class="v">{{ o.paymentStatus || '—' }}</span>
            </div>
            <div class="kv" v-if="o.paymentProof?.url">
              <span class="k">Documento pagamento</span>
              <span class="v">
                <a :href="o.paymentProof.url" target="_blank" rel="noopener">
                  {{ proofDisplayLabel(o.paymentProof) }}
                </a>
                <small v-if="o.paymentProof?.uploadedAt" class="payment-note">
                  Caricato {{ formatDate(o.paymentProof.uploadedAt) }}
                </small>
              </span>
            </div>
            <div class="kv" v-if="o.notes">
              <span class="k">Note</span>
              <span class="v">{{ o.notes }}</span>
            </div>
            <div class="kv" v-if="o.gift?.fromEmail || o.gift?.fromUid">
              <span class="k">Gift pagato da</span>
              <span class="v">{{ o.gift?.fromEmail || o.gift?.fromUid || '—' }}</span>
            </div>
            <div class="kv" v-if="o.gift?.message">
              <span class="k">Messaggio regalo</span>
              <span class="v">{{ o.gift.message }}</span>
            </div>
            <div class="kv" v-if="isGiftCardOrder(o)">
              <span class="k">Credito gift card</span>
              <span class="v">{{ giftCardCreditLabel(o) }}</span>
            </div>
            <div class="kv" v-if="isGiftCardOrder(o)">
              <span class="k">Importo gift card</span>
              <span class="v">{{ formatPrice(o.giftCredit?.amount ?? o.gift?.amount ?? o.totalPrice) }}</span>
            </div>
            <div class="kv" v-if="o.paypalOrderId">
              <span class="k">PayPal order id</span>
              <span class="v">{{ o.paypalOrderId }}</span>
            </div>
            <div class="kv" v-if="o.paypalApproveLink">
              <span class="k">PayPal link</span>
              <span class="v"><a :href="o.paypalApproveLink" target="_blank" rel="noopener">{{ o.paypalApproveLink }}</a></span>
            </div>
            <div class="kv" v-if="canRegeneratePayPalLink(o)">
              <span class="k">PayPal azioni</span>
              <span class="v">
                <button
                  class="btn tiny warning staff-button-warning"
                  :disabled="isPayPalRegenerating(o)"
                  @click.stop="regeneratePayPalLink(o)"
                >
                  {{ isPayPalRegenerating(o) ? 'Rigenero...' : 'Rigenera link PayPal' }}
                </button>
              </span>
            </div>
            <div class="kv" v-if="o.almaPaymentId">
              <span class="k">Alma payment id</span>
              <span class="v">{{ o.almaPaymentId }}</span>
            </div>
            <div class="kv" v-if="o.almaPaymentUrl && !isTerminalOrder(o)">
              <span class="k">Alma link</span>
              <span class="v"><a :href="o.almaPaymentUrl" target="_blank" rel="noopener">{{ o.almaPaymentUrl }}</a></span>
            </div>
            <div class="kv" v-if="o.almaPaymentState">
              <span class="k">Stato Alma</span>
              <span class="v">{{ formatLabel(o.almaPaymentState) }}</span>
            </div>
            <div class="kv" v-if="o.almaInstallments">
              <span class="k">Rate Alma</span>
              <span class="v">{{ o.almaInstallments }}</span>
            </div>
            <div class="kv" v-if="o.almaProcessingStatus">
              <span class="k">Processo Alma</span>
              <span class="v">{{ formatLabel(o.almaProcessingStatus) }}</span>
            </div>
            <div class="kv" v-if="o.almaSmsStatus || o.almaSmsError">
              <span class="k">SMS Alma</span>
              <span class="v">
                {{ formatLabel(o.almaSmsStatus || (o.almaSmsError ? 'errore' : '—')) }}
                <small v-if="o.almaSmsError" class="payment-note">{{ o.almaSmsError }}</small>
              </span>
            </div>
            <div class="kv" v-if="o.almaLastSyncAt">
              <span class="k">Ultima sync Alma</span>
              <span class="v">{{ formatDate(o.almaLastSyncAt) }}</span>
            </div>
            <div class="kv" v-if="o.almaLastPaidAt">
              <span class="k">Ultimo pagamento rate</span>
              <span class="v">{{ formatDate(o.almaLastPaidAt) }}</span>
            </div>
            <div class="kv" v-if="o.almaCancelledAt">
              <span class="k">Annullato Alma</span>
              <span class="v">{{ formatDate(o.almaCancelledAt) }}</span>
            </div>
            <div class="kv" v-if="o.klarnaOrderId">
              <span class="k">Klarna order id</span>
              <span class="v">{{ o.klarnaOrderId }}</span>
            </div>
            <div class="kv" v-if="o.klarnaHppSessionId">
              <span class="k">Klarna HPP session</span>
              <span class="v">{{ o.klarnaHppSessionId }}</span>
            </div>
            <div class="kv" v-if="o.klarnaPaymentUrl">
              <span class="k">Klarna link</span>
              <span class="v"><a :href="o.klarnaPaymentUrl" target="_blank" rel="noopener">{{ o.klarnaPaymentUrl }}</a></span>
            </div>
            <div class="kv" v-if="o.klarnaHppStatus">
              <span class="k">Stato Klarna</span>
              <span class="v">{{ formatLabel(o.klarnaHppStatus) }}</span>
            </div>
            <div class="kv" v-if="o.klarnaLastSyncAt">
              <span class="k">Ultima sync Klarna</span>
              <span class="v">{{ formatDate(o.klarnaLastSyncAt) }}</span>
            </div>
            <div class="kv" v-if="o.klarnaCancelledAt">
              <span class="k">Annullato Klarna</span>
              <span class="v">{{ formatDate(o.klarnaCancelledAt) }}</span>
            </div>
          </div>
          <div v-if="hasManualInstallments(o)" class="manual-plan-details">
            <div class="manual-plan-details__title">Rate manuali</div>
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Importo</th>
                  <th>Metodo</th>
                  <th>Data</th>
                  <th>Stato</th>
                  <th>Note</th>
                  <th>Azioni</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(inst, idx) in o.manualInstallments"
                  :key="inst.id || idx"
                  :class="{ 'manual-installment-row--overdue': isManualInstallmentExpired(inst, o) }"
                >
                  <td data-label="Rata">{{ idx + 1 }}</td>
                  <td data-label="Importo">{{ formatPrice(inst.amount) }}</td>
                  <td data-label="Metodo">
                    <select
                      class="input inline-select"
                      :value="inst.method || ''"
                      :disabled="isManualInstallmentSaving(o, idx) || isInstallmentPaid(inst) || isTerminalOrder(o)"
                      @change="onManualInstallmentMethodChange(o, idx, $event.target.value)"
                    >
                      <option value="">—</option>
                      <option v-for="option in manualInstallmentMethods" :key="option" :value="option">
                        {{ formatLabel(option) }}
                      </option>
                    </select>
                    <div v-if="normalizeMethod(inst.method) === 'alma'" class="alma-installments-select">
                      <select
                        class="input inline-select"
                        :value="inst.almaInstallments || ''"
                        :disabled="isManualInstallmentSaving(o, idx) || isInstallmentPaid(inst) || isTerminalOrder(o)"
                        @change="onManualInstallmentAlmaInstallmentsChange(o, idx, $event.target.value)"
                      >
                        <option disabled value="">Rate Alma</option>
                        <option v-for="rate in almaInstallmentsOptionsForForm" :key="rate" :value="rate">
                          {{ rate }} rate
                        </option>
                      </select>
                    </div>
                    <div
                      v-if="shouldShowManualInstallmentProof(inst, o)"
                      class="manual-proof-row"
                    >
                      <input
                        :id="manualInstallmentProofInputId(o, idx)"
                        type="file"
                        class="hidden"
                        accept="application/pdf,image/*"
                        @change="onManualInstallmentProofSelected(o, idx, $event)"
                      />
                      <button
                        class="btn tiny ghost staff-button-positive"
                        :disabled="isManualInstallmentSaving(o, idx)"
                        @click="triggerManualInstallmentProofPicker(o, idx)"
                      >
                        {{ manualInstallmentProof(inst, o)?.url ? 'Sostituisci file' : 'Carica file' }}
                      </button>
                      <a
                        v-if="manualInstallmentProof(inst, o)?.url"
                        :href="manualInstallmentProof(inst, o).url"
                        target="_blank"
                        rel="noopener"
                        class="manual-proof-link"
                      >
                        {{ proofDisplayLabel(manualInstallmentProof(inst, o)) }}
                      </a>
                    </div>
                  </td>
                  <td data-label="Data">{{ inst.scheduledDate ? formatDate(inst.scheduledDate) : '—' }}</td>
                  <td data-label="Stato">
                    <span class="status-chip" :class="'status-chip--' + statusClass(manualInstallmentDisplayStatus(inst, o))">
                      {{ formatStatus(manualInstallmentDisplayStatus(inst, o)) }}
                    </span>
                  </td>
                  <td data-label="Note">
                    <input
                      type="text"
                      class="input manual-note-input"
                      :value="inst.note || ''"
                      :disabled="isManualInstallmentSaving(o, idx)"
                      @change="onManualInstallmentNoteChange(o, idx, $event.target.value)"
                      placeholder="Nota"
                    />
                  </td>
                  <td data-label="Azioni">
                    <div class="manual-installment-actions">
                      <template v-if="!isInstallmentPaid(inst)">
                        <button
                          class="btn tiny primary staff-button-positive"
                          :disabled="isManualInstallmentSaving(o, idx)"
                          @click="markManualInstallmentPaid(o, idx)"
                        >
                          {{ isManualInstallmentSaving(o, idx) ? 'Aggiorno…' : 'Segna pagato' }}
                        </button>
                        <button
                          v-if="canCreateAlmaInstallmentLink(o, inst)"
                          class="btn tiny ghost staff-button-positive"
                          :disabled="isManualInstallmentSaving(o, idx)"
                          @click="createAlmaInstallmentLink(o, idx)"
                        >
                          Genera link
                        </button>
                        <div v-if="inst.almaPaymentUrl && !isTerminalOrder(o)" class="manual-alma-actions">
                          <a :href="inst.almaPaymentUrl" target="_blank" rel="noopener" class="btn tiny ghost staff-button-neutral">
                            Apri Alma
                          </a>
                          <button class="btn tiny ghost staff-button-neutral" @click="copy(inst.almaPaymentUrl)">Copia link</button>
                        </div>
                      </template>
                      <span v-else class="installment-paid-note">
                        Pagata {{ inst.paidAt ? formatDate(inst.paidAt) : '' }}
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="products">
            <div class="products-title">Prodotti</div>
            <ul class="products-list">
              <li v-for="p in (o.products || [])" :key="p.id ?? p.sku ?? p.name">
                <div class="product-name">{{ p.name }}</div>
                <div class="product-meta">
                  <span>SKU/ID: {{ p.sku || p.id || '—' }}</span>
                  <span>Qtà: {{ p.quantity }}</span>
                  <span>{{ formatPrice(p.price) }}</span>
                </div>
              </li>
            </ul>
          </div>

      <div class="order-management">
        <div class="management-section">
          <div class="section-header">
            <h4>Gestione ordine</h4>
            <span class="status-chip" :class="'status-chip--' + statusClass(o.status)">
              Stato attuale: {{ formatStatus(o.status) }}
            </span>
          </div>

          <div class="management-actions">
            <button
              v-if="isGiftOrder(o) && !isGiftCardOrder(o) && !o.userUid"
              class="btn tiny primary staff-button-positive"
              :disabled="isGiftUserCreation(o)"
              @click="confirmGiftUserCreation(o)"
            >
              {{ isGiftUserCreation(o) ? 'Creazione…' : 'Crea/aggancia utente gift' }}
            </button>

            <button class="btn tiny ghost staff-button-positive" :disabled="isManagedGiftCardOrder(o)" @click="openEditOrderModal(o)">
              Modifica ordine
            </button>
            <button
              class="btn tiny ghost staff-button-neutral"
              :disabled="receiptExporting"
              @click="downloadReceipt(o)"
            >
              {{ receiptExporting ? 'Genero ricevuta…' : 'Scarica ricevuta' }}
            </button>

                <button
                  class="btn tiny ghost staff-button-warning"
                  :disabled="isManagedGiftCardOrder(o) || ['rimborsato', 'rimborsato parzialmente'].includes((o.status || '').toLowerCase())"
                  @click="openRefundModal(o)"
                >
                  Segna rimborsato
                </button>

                <button
                  class="btn tiny ghost staff-button-cancel"
                  :disabled="isManagedGiftCardOrder(o) || (o.status || '').toLowerCase() === 'cancellato'"
                  @click="applyManualStatus(o, 'cancellato')"
                >
                  Segna cancellato
                </button>

                <button
                  v-if="isManualOrder(o) && (o.paymentProvider || '').toLowerCase() === 'alma'"
                  class="btn tiny ghost staff-button-neutral"
                  :disabled="almaSyncing[o._id]"
                  @click="syncAlmaPayment(o, { silent: false })"
                >
                  {{ almaSyncing[o._id] ? 'Aggiorno stato…' : 'Aggiorna stato Alma' }}
                </button>

                <button
                  v-if="isManualOrder(o) && (o.paymentProvider || '').toLowerCase() === 'klarna'"
                  class="btn tiny ghost staff-button-neutral"
                  :disabled="klarnaSyncing[o._id]"
                  @click="syncKlarnaPayment(o, { silent: false })"
                >
                  {{ klarnaSyncing[o._id] ? 'Aggiorno stato…' : 'Aggiorna stato Klarna' }}
                </button>

                <button
                  v-if="!isGiftCardOrder(o)"
                  class="btn tiny staff-button-positive"
                  :class="(percorsiCount[o.orderId || o._id] || 0) > 0 ? 'danger' : 'primary'"
                  @click="processOrder(o)"
                  :disabled="
                    processing[o.orderId || o._id] ||
                    (percorsiCount[o.orderId || o._id] || 0) > 0 ||
                    !isEligibleStatus(o)
                  "
                >
                  {{
                    (percorsiCount[o.orderId || o._id] || 0) > 0
                      ? 'Percorsi già creati'
                      : (!isEligibleStatus(o)
                          ? 'Non idoneo'
                          : (processing[o.orderId || o._id]
                              ? 'Creazione…'
                              : 'Genera percorsi'))
                  }}
                </button>
              </div>
              <p v-if="isManagedGiftCardOrder(o)" class="hint-text">Modifiche, annullamenti e rimborsi della gift card richiedono la gestione dedicata del team, con eventuale storno del credito.</p>
            </div>

            <div class="management-section" v-if="isBonificoOrder(o)">
              <div class="section-header">
                <h4>{{ isManagedGiftCardOrder(o) ? 'Conferma bonifico gift card' : 'Cambio stato pagamento' }}</h4>
                <span v-if="isManagedGiftCardOrder(o)" class="hint-text">Conferma dopo aver verificato l’accredito bancario: il saldo viene aggiunto una sola volta al destinatario.</span>
                <span v-else class="hint-text">
                  Imposta il nuovo stato e allega il documento contabile (PDF o immagine) per i bonifici.
                </span>
              </div>
              <p v-if="isStatusChangeLocked(o)" class="status-lock-hint">
                Gli ordini con pagamento Alma, PayPal o Klarna aggiornano automaticamente lo stato quando passano da
                “in attesa di pagamento” a “pagato”. Non è possibile forzare il cambio manualmente.
              </p>

              <div class="status-form-grid">
                <div class="field">
                  <label>Nuovo stato</label>
                  <select
                    class="input"
                    :value="statusForm(o).nextStatus"
                    @change="onStatusSelectChange(o, $event.target.value)"
                    :disabled="isStatusChangeLocked(o)"
                  >
                    <option value="" disabled>Seleziona…</option>
                    <option
                      v-for="s in (isManagedGiftCardOrder(o) ? ['pagato'] : statusChangeOptions)"
                      :key="s"
                      :value="s"
                    >
                      {{ formatStatus(s) }}
                    </option>
                  </select>
                </div>

                <div class="field">
                  <label>Documento contabile (PDF o immagine)</label>
                  <input
                    type="file"
                    accept="application/pdf,image/*"
                    @change="onStatusFileSelected(o, $event)"
                    :disabled="isStatusChangeLocked(o)"
                  />
                  <small
                    v-if="!isStatusChangeLocked(o) && requiresPaymentProof(o, statusForm(o).nextStatus)"
                    class="hint"
                  >
                    Obbligatorio quando si passa a “Pagato” per bonifici.
                  </small>
                  <small v-else-if="!isStatusChangeLocked(o)" class="hint">Facoltativo.</small>
                  <small v-else class="hint">Gestito automaticamente dal provider.</small>
                </div>
              </div>

              <div class="status-file-info">
                <span v-if="statusForm(o).fileName">
                  File selezionato: {{ statusForm(o).fileName }}
                </span>
                <span v-else> Nessun file selezionato. </span>
                <a
                  v-if="o.paymentProof?.url"
                  :href="o.paymentProof.url"
                  target="_blank"
                  rel="noopener"
                >
                  {{ proofDisplayLabel(o.paymentProof) }}
                </a>
              </div>

              <div class="status-actions">
                <button
                  class="btn primary tiny staff-button-positive"
                  :disabled="isStatusSaving(o) || isStatusChangeLocked(o) || (isManagedGiftCardOrder(o) && o.giftCredit?.status === 'credited')"
                  @click="submitStatusChange(o)"
                >
                  {{ isStatusSaving(o) ? 'Aggiornamento…' : (isManagedGiftCardOrder(o) && statusForm(o).nextStatus === 'pagato' ? 'Conferma bonifico e accredita gift' : 'Aggiorna stato') }}
                </button>
                <span class="form-error" v-if="statusError(o)">{{ statusError(o) }}</span>
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </template>
</tbody>


          </table>
        </div>

        <div class="pagination">
        </div>
        </section>

        <p v-else class="empty-state card-surface">Nessun ordine trovato.</p>
      </div>
    </div>
  </div>




  <!-- RICEVUTA PDF (smart/light) -->
  <div
    v-if="receiptOrder"
    ref="receiptRef"
    class="receipt-pdf"
    aria-hidden="true"
  >
    <div class="receipt-logo">
      <img :src="receiptLogoSrc" alt="Logo" />
    </div>
    <div class="receipt-header">
      <div class="receipt-title">Ricevuta di cortesia</div>
      <div class="receipt-subtitle">Documento non fiscale</div>
    </div>

    <div class="receipt-section">
      <div class="receipt-kv">
        <span>Data ordine</span>
        <strong>{{ formatDate(receiptOrder.orderDate) }}</strong>
      </div>
      <div class="receipt-kv">
        <span>Ordine</span>
        <strong>{{ receiptOrder.orderId || receiptOrder._id || '—' }}</strong>
      </div>
      <div class="receipt-kv">
        <span>Stato</span>
        <strong>{{ formatStatus(receiptOrder.status) }}</strong>
      </div>
      <div class="receipt-kv">
        <span>Pagamento</span>
        <strong>{{ formatLabel(receiptOrder.paymentMethod || receiptOrder.paymentProvider) }}</strong>
      </div>
    </div>

    <div class="receipt-section">
      <div class="receipt-section-title">Cliente</div>
      <div class="receipt-grid">
        <div class="receipt-kv">
          <span>Nome</span>
          <strong>{{ receiptCustomer.name || '—' }} {{ receiptCustomer.surname || '' }}</strong>
        </div>
        <div class="receipt-kv">
          <span>Email</span>
          <strong>{{ receiptCustomer.email || '—' }}</strong>
        </div>
        <div class="receipt-kv">
          <span>Telefono</span>
          <strong>{{ receiptCustomer.phone || '—' }}</strong>
        </div>
        <div class="receipt-kv">
          <span>Studio</span>
          <strong>{{ receiptCustomer.studio || '—' }}</strong>
        </div>
        <div class="receipt-kv">
          <span>Codice fiscale</span>
          <strong>{{ receiptCustomer.codFiscale || '—' }}</strong>
        </div>
      </div>
    </div>

    <div class="receipt-section">
      <div class="receipt-section-title">Prodotti</div>
      <table class="receipt-table">
        <thead>
          <tr>
            <th>Prodotto</th>
            <th class="num">Qtà</th>
            <th class="num">Prezzo</th>
            <th class="num">Totale</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in receiptItems" :key="`${item.name}-${idx}`">
            <td>{{ item.name }}</td>
            <td class="num">{{ item.quantity }}</td>
            <td class="num">{{ formatPrice(item.price) }}</td>
            <td class="num">{{ formatPrice(item.total) }}</td>
          </tr>
        </tbody>
      </table>
      <div class="receipt-total">
        <span>Totale</span>
        <strong>{{ formatPrice(receiptOrder.totalPrice) }}</strong>
      </div>
    </div>

    <div v-if="receiptOrder.notes" class="receipt-section">
      <div class="receipt-section-title">Note</div>
      <div class="receipt-notes">{{ receiptOrder.notes }}</div>
    </div>
  </div>


  <!-- MODALE: CREA ORDINE MANUALE -->
  <div v-if="showCreate" class="modal staff-order-create-overlay">
    <div class="staff-editor-dialog staff-order-create-dialog" role="dialog" aria-modal="true" aria-labelledby="staff-order-create-title" aria-describedby="staff-order-create-description">
      <header class="staff-editor-header">
        <span class="material-icons staff-editor-heading-icon" aria-hidden="true">add_shopping_cart</span>
        <div>
          <div class="staff-order-heading-title">
            <h2 id="staff-order-create-title">Nuovo ordine manuale</h2>
            <span
              v-if="csenExistingInfo.visible"
              class="csen-badge"
              :class="csenExistingInfo.className"
              :title="csenExistingInfo.tooltip"
            >
              <span class="material-icons" aria-hidden="true">{{ csenExistingInfo.icon }}</span>
              <span class="csen-badge__text">CSEN · {{ csenExistingInfo.label }}</span>
            </span>
          </div>
          <p id="staff-order-create-description">Compila i dati necessari per registrare un ordine esterno.</p>
        </div>
        <button type="button" class="staff-editor-close staff-button-neutral" aria-label="Chiudi nuovo ordine manuale" title="Chiudi nuovo ordine manuale" @click="closeCreate">
          <span class="material-icons" aria-hidden="true">close</span>
        </button>
      </header>
      <form @submit.prevent="saveOrder()" class="staff-editor-form" :aria-busy="saving">
        <div class="staff-editor-body">
          <fieldset class="staff-editor-section">
            <legend>Dati utente</legend>
            <div class="staff-editor-grid staff-editor-grid--three">

          <div class="staff-editor-field">
            <label for="staff-order-form-userEmail">Email utente *</label>
            <input id="staff-order-form-userEmail"
              v-model.trim="form.userEmail"
              required
              placeholder="es. mario@rossi.it"
              @blur="handleEmailBlur"
            />
            <small v-if="userLookup.loading" class="hint">Verifica in corso…</small>
            <small v-else-if="userLookup.existing" class="hint">
              Utente trovato: {{ userLookup.displayName || form.userEmail }}
            </small>
            <small v-else-if="userLookup.checkedEmail" class="hint">
              Nuovo utente: verrà creato automaticamente all'ordine.
            </small>
          </div>
          <div class="staff-editor-field">
            <label for="staff-order-form-userName">Nome *</label>
            <input id="staff-order-form-userName"
              v-model.trim="form.userName"
              :disabled="userLookup.existing"
              required
              placeholder="Nome"
            />
          </div>
          <div class="staff-editor-field">
            <label for="staff-order-form-userSurname">Cognome *</label>
            <input id="staff-order-form-userSurname"
              v-model.trim="form.userSurname"
              :disabled="userLookup.existing"
              required
              placeholder="Cognome"
            />
          </div>
          <div class="staff-editor-field">
            <label for="staff-order-form-userPhone">Telefono</label>
            <input id="staff-order-form-userPhone"
              v-model.trim="form.userPhone"
              required
              placeholder="Numero di telefono"
            />
          </div>
          <div class="staff-editor-field">
            <label for="staff-order-form-userCodFiscale">Codice fiscale</label>
            <input id="staff-order-form-userCodFiscale"
              v-model.trim="form.userCodFiscale"
              placeholder="Codice fiscale"
            />
          </div>
          <div class="staff-editor-field">
            <label for="staff-order-form-userStudio">Studio</label>
            <select id="staff-order-form-userStudio" v-model="form.userStudio" :disabled="userLookup.existing">
              <option disabled value="">Seleziona uno studio</option>
              <option value="Tivoli Quartier generale">Tivoli Quartier generale</option>
              <option value="FF Genova">FF Genova</option>
              <option value="FF Bologna">FF Bologna</option>
              <option value="FF Bari">FF Bari</option>
              <option value="FF Pescara">FF Pescara</option>
              <option value="FF Firenze">FF Firenze</option>
              <option value="FF Torino">FF Torino</option>
              <option value="FF Napoli">FF Napoli</option>
              <option value="FF Milano">FF Milano</option>
              <option value="FF Roma">FF Roma</option>
              <option value="FF Salerno">FF Salerno</option>
              <option value="FF Cagliari">FF Cagliari</option>
              <option value="FF Milano Citta Studi">FF Milano Città Studi</option>
              <option value="FF Salerno">FF Salerno</option>
              <option value="FF Roma Eur">FF Roma Eur</option>
              <option value="FF Milano Sempione">FF Milano Sempione</option>
              <option value="FF Padova">FF Padova</option>
            </select>
          </div>
            </div>
          </fieldset>
          <fieldset class="staff-editor-section">
            <legend>Ordine e pagamento</legend>
            <div class="staff-editor-grid staff-editor-grid--three">
          <div class="staff-editor-field">
            <label for="staff-order-form-orderDateLocal">Data ordine *</label>
            <input id="staff-order-form-orderDateLocal" v-model="form.orderDateLocal" type="datetime-local" required />
          </div>
          <div class="staff-editor-field">
            <label for="staff-order-form-percorsiStartDate">Data inizio percorsi</label>
            <input id="staff-order-form-percorsiStartDate" v-model="form.percorsiStartDate" type="date" />
            <small class="hint">
              Se scegli una data futura, il questionario verrà inviato automaticamente quel giorno.
            </small>
          </div>
          <div v-if="csenCreateInfo.visible" class="field csen-field">
            <div class="csen-callout" :class="csenCreateInfo.className">
              <div class="csen-callout__header">
                <div>
                  <div class="csen-callout__title">CSEN · 1 anno</div>
                  <div class="csen-callout__meta">Quantità {{ csenCreateInfo.qty }}</div>
                </div>
                <span class="csen-callout__badge" :class="csenCreateInfo.className">
                  <span class="material-icons" aria-hidden="true">{{ csenCreateInfo.icon }}</span>
                  {{ csenCreateInfo.label }}
                </span>
              </div>
              <div class="csen-callout__dates">
                <span>Acquisto: <strong>{{ csenCreateInfo.purchaseLabel }}</strong></span>
                <span>Scadenza: <strong>{{ csenCreateInfo.expiryLabel }}</strong></span>
              </div>
              <small v-if="csenCreateInfo.hint" class="hint">{{ csenCreateInfo.hint }}</small>
            </div>
          </div>
          <div class="staff-editor-field">
            <label for="staff-order-form-status">Stato *</label>
            <select id="staff-order-form-status" v-model="form.status" required :disabled="form.paymentMethod === 'rate_manuali'">
              <option v-for="s in knownStatuses" :key="s" :value="s">{{ s }}</option>
            </select>
            <small v-if="form.paymentMethod === 'rate_manuali'" class="hint">
              Con rate manuali lo stato passa a "rateizzato" alla prima rata pagata e diventa "pagato" solo al saldo completo.
            </small>
          </div>

          <div class="staff-editor-field">
            <label for="staff-order-form-paymentMethod">Metodo di pagamento</label>
            <select id="staff-order-form-paymentMethod" v-model="form.paymentMethod" required @change="handlePaymentMethodChange">
              <option value="">—</option>
              <option value="contanti">Contanti</option>
              <option value="pos">POS</option>
              <option value="welfare">Welfare</option>
              <option value="bonifico">Bonifico</option>
              <option value="paypal">PayPal</option>
              <option value="alma">AlmaPay</option>
              <option v-if="canManageUserCredit" value="credito">Credito</option>
              <option value="rate_manuali">Rate manuali</option>
            </select>
          </div>
          <div class="staff-editor-field" v-if="form.paymentMethod === 'welfare'">
            <label for="staff-order-form-welfareProvider">Circuito Welfare</label>
            <select id="staff-order-form-welfareProvider" v-model="form.welfareProvider" required @change="handlePaymentMethodChange">
              <option value="">—</option>
              <option v-for="provider in welfareProviderOptions" :key="provider" :value="provider">
                {{ provider }}
              </option>
            </select>
          </div>
          <div class="block manual-installments" v-if="form.paymentMethod === 'rate_manuali'">
            <div class="block-title">Piano rate manuali</div>
            <p class="hint">Imposta più rate con metodi e date diverse. La somma deve coincidere con il totale ordine.</p>
            <div v-if="form.manualInstallments.length" class="installments-table">
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Importo *</th>
                    <th>Metodo</th>
                    <th>Data</th>
                    <th>Stato *</th>
                    <th class="wide">Note</th>
                    <th class="actions-col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(inst, idx) in form.manualInstallments" :key="inst.id || idx">
                    <td :data-label="'#'">{{ idx + 1 }}</td>
                    <td :data-label="'Importo *'">
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        v-model.number="inst.amount"
                        placeholder="0,00"
                      />
                    </td>
                    <td :data-label="'Metodo'">
                      <select v-model="inst.method">
                        <option value="">—</option>
                        <option v-for="option in manualInstallmentMethods" :key="option" :value="option">
                          {{ formatLabel(option) }}
                        </option>
                      </select>
                      <div v-if="normalizeMethod(inst.method) === 'alma'" class="alma-installments-select">
                        <select v-model.number="inst.almaInstallments">
                          <option disabled value="">Rate Alma</option>
                          <option v-for="rate in almaInstallmentsOptionsForForm" :key="rate" :value="rate">
                            {{ rate }} rate
                          </option>
                        </select>
                      </div>
                    </td>
                    <td :data-label="'Data'">
                      <input type="date" v-model="inst.scheduledDate" />
                    </td>
                    <td :data-label="'Stato *'">
                      <select v-model="inst.status">
                        <option v-for="status in manualInstallmentStatusOptions" :key="status" :value="status">
                          {{ formatStatus(status) }}
                        </option>
                      </select>
                    </td>
                    <td :data-label="'Note'" class="note-cell">
                      <input type="text" v-model="inst.note" placeholder="Nota" />
                    </td>
                    <td class="right actions-col" :data-label="'Azioni'">
                      <button
                        type="button"
                        class="btn danger tiny icon-btn staff-button-cancel"
                        @click="removeManualInstallment(idx)"
                        aria-label="Rimuovi rata"
                        title="Rimuovi rata"
                      >
                        <span class="material-icons" aria-hidden="true">close</span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p v-else class="muted">Nessuna rata configurata. Aggiungine una per iniziare.</p>
            <div class="installments-summary">
              <div>
                Somma rate: {{ formatPrice(manualInstallmentsTotal) }} · Totale ordine: {{ formatPrice(computedDiscountTotal) }}
              </div>
              <div v-if="manualInstallmentsDelta !== 0" class="warn">
                Differenza: {{ formatPrice(manualInstallmentsDeltaAbs) }}
              </div>
            </div>
            <div class="installments-actions">
              <button
                type="button"
                class="btn tiny ghost staff-button-positive"
                @click="addManualInstallment"
              >
                Aggiungi rata
              </button>
            </div>
          </div>
          <div class="staff-editor-field" v-if="form.paymentMethod === 'alma'">
            <label for="staff-order-form-almaInstallments">Numero rate (Alma)</label>
            <select id="staff-order-form-almaInstallments" v-model.number="form.almaInstallments">
              <option v-for="rate in almaInstallmentsOptionsForForm" :key="rate" :value="rate">
                {{ rate }} rate
              </option>
            </select>
            <small class="hint">Valori consentiti: 2, 3, 4, 6, 10 rate.</small>
          </div>
          <div class="staff-editor-field">
            <label for="staff-order-form-discount">Sconto</label>
            <input id="staff-order-form-discount" type="number" step="0.01" v-model.number="form.discount" placeholder="0,00" />
            <small class="hint">Valore positivo in euro, sottratto dal totale.</small>
          </div>
          <div class="staff-editor-field">
            <label for="staff-order-form-notes">Note</label>
            <input id="staff-order-form-notes" v-model.trim="form.notes" placeholder="Annotazioni interne…" />
          </div>
          <div
            v-if="userCredit.visible"
            class="field credit-order-card"
            :class="{ 'credit-order-card--applied': creditAppliedAmount > 0 }"
          >
            <div class="credit-order-card__top">
              <div>
                <label>Credito utente</label>
                <strong>{{ formatPrice(userCredit.total) }}</strong>
              </div>
              <button
                v-if="canManageUserCredit"
                type="button"
                class="btn tiny"
                :class="[creditAppliedAmount > 0 ? 'danger' : 'primary', creditAppliedAmount > 0 ? 'staff-button-cancel' : 'staff-button-positive']"
                :disabled="!canApplyCredit"
                @click="toggleUseCredit"
              >
                {{ creditAppliedAmount > 0 ? 'Rimuovi credito' : 'Usa credito' }}
              </button>
            </div>
            <small v-if="userCredit.loading" class="hint">Caricamento credito…</small>
            <small v-else-if="userCredit.error" class="hint credit-order-card__error">{{ userCredit.error }}</small>
            <small v-else-if="!canManageUserCredit" class="hint">L’utilizzo manuale del saldo sugli ordini è riservato a Valerio.</small>
            <small v-else-if="creditAppliedAmount > 0" class="hint">
              Applicato {{ formatPrice(creditAppliedAmount) }}.
              Da pagare {{ formatPrice(computedDiscountTotal) }}.
            </small>
            <small v-else-if="!canApplyCredit" class="hint">
              Seleziona il prodotto e poi decidi se usare il credito utente.
            </small>
          </div>
            </div>
          </fieldset>
        <fieldset class="staff-editor-section staff-order-products">
          <legend>Prodotti</legend>

          <div class="picker">
            <select aria-label="Prodotto da aggiungere" v-model="selectedProductId" class="input">
              <option disabled value="">Seleziona un prodotto…</option>
              <option v-for="p in manualOrderProducts" :key="p.id" :value="p.id">
                {{ p.name }} ({{ p.sku || 'no-sku' }}) — {{ formatPrice(p.price) }}
              </option>
            </select>
            <select
              v-if="isSelectedCustomPtProduct"
              aria-label="Numero di sedute" v-model.number="selectedCustomPtQty"
              class="input qty"
            >
              <option v-for="qtyOption in customPtQtyOptions" :key="qtyOption" :value="qtyOption">
                {{ qtyOption }} sedute
              </option>
            </select>
            <input
              v-if="isSelectedManualPriceProduct"
              aria-label="Prezzo del prodotto" v-model.number="selectedManualPrice"
              type="number"
              min="0.01"
              step="0.01"
              class="input qty"
              placeholder="Prezzo EUR"
            />
            <label v-if="canUseVat22Flag" class="vat-toggle">
              <input type="checkbox" v-model="selectedAddVat22" />
              <span>Aggiungi IVA 22%</span>
              <strong v-if="selectedVatPreviewPrice">
                {{ formatPrice(selectedVatPreviewPrice) }}
              </strong>
            </label>
            <button type="button" class="btn primary staff-button-positive" @click="addLine">Aggiungi</button>
          </div>
          <p v-if="isSelectedManualPriceProduct" class="hint">
            Il prezzo base di INTEGRAZIONE SERVIZI e' {{ formatPrice(0) }}: inserisci manualmente l'importo (es. 24, 99 o 150).
          </p>

          <div v-if="lines.length" class="lines">
            <table>
              <thead>
                <tr>
                  <th>Prodotto</th>
                  <th>SKU</th>
                  <th class="num">Prezzo</th>
                  <th class="num">Subtotale</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(l, i) in lines" :key="l.key">
                  <td data-label="Prodotto">
                    {{ l.name }}
                    <small v-if="isCustomPtProduct(l)" class="muted">({{ l.quantity }} sedute)</small>
                    <small v-if="isManualPriceProduct(l)" class="muted">(prezzo manuale)</small>
                    <small v-if="l.vat22Applied" class="muted">(IVA 22% inclusa)</small>
                  </td>
                  <td data-label="SKU">{{ l.sku || '—' }}</td>
                  <td class="num" data-label="Prezzo">
                    <input
                      v-if="isManualPriceProduct(l)"
                      v-model.number="l.price"
                      type="number"
                      min="0.01"
                      step="0.01"
                      class="qty-inline"
                      @input="recalcTotal"
                    />
                    <span v-else>{{ formatPrice(l.price) }}</span>
                  </td>
                  <td class="num" data-label="Subtotale">{{ formatPrice(l.price * l.quantity) }}</td>
                  <td class="right" data-label="Azioni"><button type="button" class="btn danger tiny staff-button-cancel" @click="removeLine(i)">Rimuovi</button></td>
                </tr>
              </tbody>
            </table>
          </div>
          <p v-else class="muted">Nessun prodotto aggiunto.</p>
        </fieldset>

          <div v-if="errorMsg" class="error-msg" role="alert">{{ errorMsg }}</div>
          <div v-if="successMsg" class="success-msg" role="status">{{ successMsg }}</div>
        </div>
        <footer class="staff-editor-footer">
          <div class="footer-total">
            <span class="footer-total__label">Totale da pagare</span>
            <small v-if="creditAppliedAmount > 0" class="footer-total__breakdown">
              Lordo {{ formatPrice(total) }} · Sconto {{ formatPrice(manualDiscountAmount) }} · Credito {{ formatPrice(creditAppliedAmount) }}
            </small>
            <span class="footer-total__value">{{ formatPrice(computedDiscountTotal) }}</span>
          </div>

          <div class="staff-editor-actions">
            <button type="button" class="staff-editor-button staff-editor-cancel staff-button-cancel" @click="closeCreate">Annulla</button>
            <button type="submit" class="staff-editor-button staff-editor-save staff-button-positive" :disabled="saving">{{ saving ? 'Salvataggio…' : 'Salva ordine' }}</button>
          </div>
        </footer>
      </form>
    </div>
  </div>

  <div v-if="showCreditUsageConfirm" class="credit-confirm-overlay">
    <div class="credit-confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="credit-confirm-title">
      <h3 id="credit-confirm-title">Credito disponibile</h3>
      <p>Questo utente ha del credito.</p>
      <p>Vuoi utilizzarlo in questa transazione?</p>
      <div class="credit-confirm-summary">
        <span>Credito utente</span>
        <strong>{{ formatPrice(userCredit.total) }}</strong>
      </div>
      <div class="credit-confirm-actions">
        <button type="button" class="btn ghost staff-button-positive" :disabled="saving" @click="confirmSaveWithoutCredit">
          NO lo utilizzerà in seguito
        </button>
        <button type="button" class="btn primary staff-button-positive" :disabled="saving || !canApplyCredit" @click="confirmSaveWithCredit">
          SI aggiungi credito
        </button>
      </div>
    </div>
  </div>



  <!-- MODALE: RIMBORSO ORDINE -->
  <div v-if="showRefund" class="modal">
    <div class="dialog">
      <form @submit.prevent="confirmRefund" class="modal-form">
        <div class="form-body">
          <div class="modal-title">
            <h3>Gestisci rimborso</h3>
            <p class="modal-subtitle">
              Ordine {{ refundForm.order?.orderId || refundForm.order?._id || '—' }} · Totale {{ formatPrice(refundForm.originalTotal) }}
            </p>
          </div>

          <div class="grid">
            <div class="field">
              <label>Importo da rimborsare (EUR)</label>
              <input
                v-model.number="refundForm.amount"
                type="number"
                min="0"
                step="0.01"
                :max="Math.max(refundForm.originalTotal, 0)"
                placeholder="0,00"
                required
              />
              <small class="hint">Inserisci l'importo effettivo del rimborso.</small>
            </div>

            <div class="field">
              <label>Nuovo prodotto (opz.)</label>
              <select v-model="refundForm.newProductId" class="input">
                <option value="">— Nessun cambio prodotto —</option>
                <option v-for="p in products" :key="p.id" :value="p.id">
                  {{ p.name }} · {{ formatPrice(p.price) }}
                </option>
              </select>
              <small class="hint">Seleziona un prodotto sostitutivo per ricreare i programmi associati.</small>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <div class="modal-actions">
            <button type="button" class="btn ghost staff-button-cancel" @click="closeRefundModal" :disabled="refundProcessing">Annulla</button>
            <button type="submit" class="btn primary staff-button-positive" :disabled="refundProcessing">
              {{ refundProcessing ? 'Salvataggio…' : 'Conferma rimborso' }}
            </button>
          </div>
        </div>

        <div v-if="refundError" class="error-msg">{{ refundError }}</div>
      </form>
    </div>
  </div>


  <!-- MODALE: MODIFICA ORDINE ESISTENTE -->
  <div v-if="showEditOrder" class="modal">
    <div class="dialog">
      <form @submit.prevent="confirmEditOrder" class="modal-form">
        <div class="form-body">
          <div class="modal-title">
            <h3>Modifica ordine</h3>
            <p class="modal-subtitle">
              Aggiorna prodotto e importo per l’ordine
              {{ editOrderTarget?.orderId || editOrderTarget?._id || '—' }}.
            </p>
          </div>

          <div class="grid">
            <div class="field">
              <label>Prodotto</label>
              <select v-model="editForm.productId" class="input" required @change="onEditProductChange">
                <option value="">— Seleziona prodotto —</option>
                <option v-for="p in products" :key="p.id" :value="p.id">
                  {{ p.name }} · {{ formatPrice(p.price) }}
                </option>
              </select>
              <small class="hint">
                Usa i prodotti del catalogo per garantire il numero corretto di percorsi.
              </small>
            </div>

            <div class="field">
              <label>Quantità</label>
              <input
                type="number"
                min="1"
                v-model.number="editForm.quantity"
                @change="onEditQuantityChange"
                required
              />
              <small class="hint">Numero di unità acquistate per il prodotto selezionato.</small>
            </div>
          </div>

          <div class="field">
            <label>Totale ordine (EUR)</label>
            <input
              type="number"
              min="0"
              step="0.01"
              v-model.number="editForm.totalPrice"
              required
            />
            <small class="hint">
              Questo sarà l’importo mostrato nell’ordine. Puoi modificarlo manualmente se necessario.
            </small>
          </div>

          <div v-if="editSelectedProduct" class="inline-note">
            <span>
              Il prodotto selezionato prevede
              <strong>{{ editSelectedProduct.coaching_quantity || 0 }}</strong>
              programmi per unità (durata {{ editSelectedProduct.duration_months || 1 }} mesi).
            </span>
          </div>
        </div>

        <div class="modal-footer">
          <div class="modal-actions">
            <button type="button" class="btn ghost staff-button-cancel" @click="closeEditOrderModal" :disabled="editSaving">Annulla</button>
            <button type="submit" class="btn primary staff-button-positive" :disabled="editSaving">
              {{ editSaving ? 'Salvataggio…' : 'Salva modifiche' }}
            </button>
          </div>
        </div>

        <div v-if="editError" class="error-msg">{{ editError }}</div>
      </form>
    </div>
  </div>
</template>




<script>
import SidebarComponent from '../SidebarComponent.vue';
import {
  getFirestore,
  collection,
  query,
  where,
  orderBy,
  limit,
  startAt,
  endAt,
  startAfter,
  getDocs,
  getDoc,
  doc,
  setDoc,
  updateDoc,
  deleteDoc,
  addDoc,
  runTransaction,
} from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { createPercorsiForProduct, stepKeyFromName } from '@/lib/percorsi';
import { appendTicketMessage } from '@/lib/technicalTickets';
import { getPayPalFunctionUrl, getAlmaFunctionUrl, getKlarnaFunctionUrl, getEnvVar } from '@/lib/env';
import { buildProgramStepLink } from '@/lib/programStepLinks';
import { buildTopSkuFields, orderHasTopProduct } from '@/lib/topSku';
import { isGiftCardOrder, resolveGiftCardOrderDate } from '@/lib/giftCard';
import { canManuallyManageCredit } from '@/lib/creditPermissions';
import { exportElementAsPdf } from '@/lib/pdfExport';
import { manualOrderProductOptions } from '@/lib/manualOrderProductPicker';
import {
  deriveManualInstallmentStatus,
  isManualInstallmentOperationallyExpired,
  isManualInstallmentPaid,
  isManualInstallmentsOrderTerminal,
  isManualInstallmentsTerminalStatus,
  isManualPaymentProofMethod,
  manualInstallmentPaymentProof,
  manualInstallmentProofLabel,
  manualInstallmentStats,
  manualInstallmentsOrderState,
  normalizeManualInstallmentMethod,
} from '@/lib/manualInstallments';
import receiptLogoSrc from '@/media/black.png';

/**
 * Mappatura locale per gli SKU/prodotti importati da WooCommerce che non esistono
 * nella collezione Firestore `products`.
 *
 * Aggiungi qui i prodotti che vuoi gestire manualmente, ad esempio:
 *
 * '74125': {
 *   name: 'FC 6 Basic',
 *   coachingQty: 6,
 *   cons_tecniche: 0,
 *   cons_nutrizionali: 0,
 *   pt_quantity: 0,
 *   duration_months: 6,
 *   aliases: ['fc 6 basic', 'fc6-basic', 'fc-6-basic']
 * }
 */
const PRODUCT_FALLBACKS = {


    '38331': {
    name: 'FC 1 plus',
    coachingQty: 1,
    cons_tecniche: 1,
    cons_nutrizionali: 1,
    pt_quantity: 0,
    duration_months: 1,
    aliases: ['fc 1 plus', 'fc1-plus'],
  },
  'fc1-plus': {
    name: 'FC 1 plus',
    coachingQty: 1,
    cons_tecniche: 1,
    cons_nutrizionali: 1,
    pt_quantity: 0,
    duration_months: 1,
  },



      '35258': {
    name: 'FC 4 basic',
    coachingQty: 4,
    cons_tecniche: 0,
    cons_nutrizionali: 1,
    pt_quantity: 0,
    duration_months: 5,
    aliases: ['fc 4 basic', 'fc4-basic'],
  },
  'fc4-basic': {
    name: 'FC 4 Basic',
    coachingQty: 4,
    cons_tecniche: 0,
    cons_nutrizionali: 1,
    pt_quantity: 0,
    duration_months: 5,
  },



  '56203': {
    name: 'FC 6 Basic',
    coachingQty: 6,
    cons_tecniche: 0,
    cons_nutrizionali: 1,
    pt_quantity: 0,
    duration_months: 8,
    aliases: ['fc 6 basic', 'fc6-basic'],
  },
  'fc6-basic': {
    name: 'FC 6 Basic',
    coachingQty: 6,
    cons_tecniche: 0,
    cons_nutrizionali: 1,
    pt_quantity: 0,
    duration_months: 8,
  },


    '66893': {
    name: 'FC 4 +4 plus',
    coachingQty: 4,
    cons_tecniche: 4,
    cons_nutrizionali: 1,
    pt_quantity: 0,
    duration_months: 5,
    aliases: ['fc 4 +4 plus', 'fc4+4-plus'],
  },
  'fc4+4-plus': {
    name: 'FC 4 +4 plus',
    coachingQty: 4,
    cons_tecniche: 4,
    cons_nutrizionali: 1,
    pt_quantity: 0,
    duration_months: 5,
  },


    '72124': {
    name: 'FC 6 +6 plus',
    coachingQty: 6,
    cons_tecniche: 6,
    cons_nutrizionali: 1,
    pt_quantity: 0,
    duration_months: 8,
    aliases: ['fc 6 +6 plus', 'fc6+6-plus'],
  },
  'fc6+6-plus': {
    name: 'FC 6 +6 plus',
    coachingQty: 6,
    cons_tecniche: 6,
    cons_nutrizionali: 1,
    pt_quantity: 0,
    duration_months: 8,
  },

    '65915': {
    name: 'Solo Alimentazione 6 Programmi',
    coachingQty: 6,
    cons_tecniche: 0,
    cons_nutrizionali: 1,
    pt_quantity: 0,
    duration_months: 8,
    aliases: ['solo alimentazione 6 programmi', 'solo-alimentazione-6programmi'],
  },
  'solo-alimentazione-6programmi': {
    name: 'Solo Alimentazione 6 Programmi',
    coachingQty: 6,
    cons_tecniche: 0,
    cons_nutrizionali: 1,
    pt_quantity: 0,
    duration_months: 8,
  },


    '38578': {
    name: 'solo allenamento',
    coachingQty: 1,
    cons_tecniche: 0,
    cons_nutrizionali: 0,
    pt_quantity: 0,
    duration_months: 1,
    aliases: ['solo allenamento', 'solo-allenamento'],
  },
  'solo-allenamento': {
    name: 'Solo Allenamento',
    coachingQty: 1,
    cons_tecniche: 0,
    cons_nutrizionali: 0,
    pt_quantity: 0,
    duration_months: 1,
  },


    '65911': {
    name: '6 solo allenamento',
    coachingQty: 6,
    cons_tecniche: 0,
    cons_nutrizionali: 0,
    pt_quantity: 0,
    duration_months: 8,
    aliases: ['6 solo allenamento', '6-solo-allenamento'],
  },
  '6-solo-allenamento': {
    name: '6 Solo Allenamento',
    coachingQty: 6,
    cons_tecniche: 0,
    cons_nutrizionali: 0,
    pt_quantity: 0,
    duration_months: 8,
  },

  '10topsoloallenamento': {
    name: '10 Top Solo Allenamento',
    sku: '10topsoloallenamento',
    coachingQty: 10,
    cons_tecniche: 0,
    cons_nutrizionali: 0,
    pt_quantity: 0,
    duration_months: 12,
    aliases: ['10 top solo allenamento', '10-top-solo-allenamento'],
  },


      '38580': {
    name: 'solo alimentazione',
    coachingQty: 1,
    cons_tecniche: 0,
    cons_nutrizionali: 0,
    pt_quantity: 0,
    duration_months: 1,
    aliases: ['solo alimentazione', 'solo-alimentazione'],
  },
  'solo-alimentazione': {
    name: 'Solo Alimentazione',
    coachingQty: 1,
    cons_tecniche: 0,
    cons_nutrizionali: 0,
    pt_quantity: 0,
    duration_months: 1,
  },

      '74382': {
    name: 'protocollo xmas25',
    coachingQty: 1,
    cons_tecniche: 1,
    cons_nutrizionali: 1,
    pt_quantity: 0,
    duration_months: 1,
    aliases: ['protocollo xmas25', 'protocollo-xmas25'],
  },
  'protocollo-xmas25': {
    name: 'PROTOCOLLO XMAS25',
    coachingQty: 1,
    cons_tecniche: 1,
    cons_nutrizionali: 1,
    pt_quantity: 0,
    duration_months: 1,
  },


        '73172': {
    name: 'Solo allenamento + 6 consulenze plus',
    coachingQty: 6,
    cons_tecniche: 6,
    cons_nutrizionali: 0,
    pt_quantity: 0,
    duration_months: 8,
    aliases: ['solo allenamento + 6 consulenze plus', 'solo-allenamento+6consulenze-plus'],
  },
  'solo-allenamento+6consulenze-plus': {
    name: 'Solo allenamento + 6 consulenze plus',
    coachingQty: 6,
    cons_tecniche: 6,
    cons_nutrizionali: 0,
    pt_quantity: 0,
    duration_months: 8,
  },


          '38334': {
    name: 'FC 10 Programmi',
    coachingQty: 10,
    cons_tecniche: 0,
    cons_nutrizionali: 1,
    pt_quantity: 0,
    duration_months: 12,
    aliases: ['fc 10 programmi', 'fc-10-programmi'],
  },
  'fc-10-programmi': {
    name: 'FC 10 Programmi',
    coachingQty: 10,
    cons_tecniche: 0,
    cons_nutrizionali: 1,
    pt_quantity: 0,
    duration_months: 12,
  },





};

const auth = getAuth();
const storage = getStorage();
const AUTO_GATEWAY_METHODS = ['alma', 'paypal', 'klarna'];
const NO_STUDIO_FILTER = '__NO_STUDIO__';
const CSEN_PRODUCT_KEY = '1annocsen';
const CSEN_DURATION_MONTHS = 12;
const TOP_STUDIO_OVERRIDE = 'Tivoli Quartier generale';
const CUSTOM_PT_SKU = 'sedutacustom';
const MANUAL_PRICE_SKU = 'integrazione-servizi';
const PROTOCOLLO_25_SKU = 'protocollo25-summer';
const CUSTOM_PT_MIN_QTY = 1;
const CUSTOM_PT_MAX_QTY = 20;
const VAT_22_RATE = 0.22;
const VAT_22_ALLOWED_UID = 'HpMiFyBZnwX6EUf6VR9iCsHkqo82';
const SURNAME_FETCH_LIMIT = 2000;
const FIRESTORE_IN_FILTER_CHUNK_SIZE = 10;
const CSV_EXPORT_PAGE_SIZE = 500;
// Lock anti-duplicati percorsi tra tab/sessioni admin.
const PERCORSI_LOCK_MAX_AGE_MS = 5 * 60 * 1000;

const pad2 = (n) => String(n).padStart(2, '0');
const toDateInput = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
const defaultDateRange = () => {
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);
  return { from: toDateInput(yesterday), to: toDateInput(today) };
};

export default {
  name: 'OrdersListAll',
  components: { SidebarComponent },
  data() {
    const { from, to } = defaultDateRange();
    return {
      db: null,
      authUnsub: null,
      currentAdminUid: auth?.currentUser?.uid || '',
      currentAdminEmail: auth?.currentUser?.email || '',
      orders: [],
      nearbyPaidOrderCandidates: [],
      expanded: {},
      cursor: null,
      hasMore: true,
      loading: false,
      pageSize: 50,
      csvExporting: false,
      csvExportScanned: 0,
      csvExportMatched: 0,
      filtersOpen: false,
      productFilterOpen: false,
      filters: {
        email: '',
        surname: '',
        source: '', // '', 'woocommerce', 'legacy', 'manuale', 'fuscofit'
        status: '',
        product: [],
        studio: '',
        fromDate: from,
        toDate: to,
        hideWelfare: true,
      },
      // Stati Woo "classici" per i filtri
      knownStatuses: [
        'pagato',
        'rateizzato',
        'in attesa di pagamento',
        'scaduto',
        'rimborsato',
        'rimborsato parzialmente',
        'cancellato'
      ],
      almaInstallmentsOptions: [2, 3, 4, 6, 10],
      welfareProviderOptions: [
        'DOUBLE YOU',
        'TRE CUORI',
        'UPDAYWELFARE',
        'RANDSTAD',
        'WELLHUB',
        'FITPRIME x WELLHUB',
        'EDENRED',
        'EDENRED x FITPRIME',
        'EUDAIMON',
        'EASYWELFARE',
        'AON',
      ],
      statusChangeOptions: ['pagato', 'in attesa di pagamento', 'scaduto'],
      manualInstallmentStatusOptions: ['pagato', 'in attesa di pagamento', 'scaduta'],
      manualInstallmentMethods: ['contanti', 'bonifico', 'addebito_diretto', 'pos', 'welfare', 'alma'],
      studioOptions: [
        'Tivoli Quartier generale',
        'FF Genova',
        'FF Bologna',
        'FF Bari',
        'FF Pescara',
        'FF Firenze',
        'FF Torino',
        'FF Napoli',
        'FF Milano',
        'FF Roma',
        'FF Salerno',
        'FF Cagliari',
        'FF Milano Città Studi',
        'FF Roma Eur',
        'FF Milano Sempione',
        'FF Padova'
      ],
      noStudioFilterValue: NO_STUDIO_FILTER,

      /* ---- creazione ordine manuale ---- */
      showCreate: false,
      showCreditUsageConfirm: false,
      products: [],
      selectedProductId: '',
      selectedCustomPtQty: CUSTOM_PT_MIN_QTY,
      selectedManualPrice: '',
      selectedAddVat22: false,
      lines: [],
      total: 0,
      saving: false,
      errorMsg: '',
      successMsg: '',
      form: {
        userEmail: '',
        userName: '',
        userSurname: '',
        userStudio: '',
        userPhone: '',
        userCodFiscale: '',
        orderDateLocal: '',
        percorsiStartDate: '',
        status: 'pagato',
        paymentMethod: '',
        paymentProvider: '',   // 'paypal' | 'alma' | 'klarna' | ''
        welfareProvider: '',
        almaInstallments: 3,
        discount: '',
        creditApplied: 0,
        notes: '',
        manualInstallments: [],
      },
      userLookup: {
        loading: false,
        existing: false,
        checkedEmail: '',
        uid: null,
        displayName: '',
        phone: '',
        codFiscale: '',
      },
      userCredit: {
        loading: false,
        visible: false,
        uid: null,
        total: 0,
        movements: [],
        error: '',
      },
      csenLookup: {
        loading: false,
        checkedEmail: '',
        orderDate: null,
      },

      /* ---- rimborso ---- */
      showRefund: false,
      refundProcessing: false,
      refundError: '',
      refundForm: {
        order: null,
        amount: '',
        newProductId: '',
        originalTotal: 0,
      },

      /* ---- modifica ordine esistente ---- */
      showEditOrder: false,
      editOrderTarget: null,
      editForm: {
        productId: '',
        quantity: 1,
        totalPrice: 0,
      },
      editSaving: false,
      editError: '',

      /* ---- feedback percorsi per riga ordine ---- */
      percorsiCount: {},     // { [orderId]: number }
      percorsiLoading: {},   // { [orderId]: boolean }
      processing: {},        // { [orderId]: boolean } azione "Genera percorsi" in corso
      userUidCache: {},      // { [orderDocId]: userUid|null }
      userUidLookupInFlight: {}, // { [orderDocId]: true }
      emailUidCache: {},     // { [emailLower]: userUid|null }
      userStudioCache: {},   // { [uidOrEmail]: studio }
      activePercorsiCache: {}, // { [uid]: boolean }
      orderStatusCache: {},  // { [orderId]: statusLower|null }
      almaSyncing: {},       // { [orderId]: boolean }
      klarnaSyncing: {},     // { [orderId]: boolean }
      paypalRegenerating: {}, // { [orderId]: boolean }
      statusForms: {},       // { [orderId]: { nextStatus, file, fileName } }
      statusSaving: {},      // { [orderId]: boolean }
      statusErrors: {},      // { [orderId]: string }
      orderNoteSaving: {},   // { [orderId]: boolean }
      orderNoteErrors: {},   // { [orderId]: string }
      manualInstallmentSaving: {}, // { `${orderId}:${index}`: boolean }
      routePrefillKey: '',   // firma ultima query per apertura modale
      giftUserCreation: {}, // { [orderId]: boolean }
      receiptOrder: null,
      receiptExporting: false,
      receiptLogoSrc,
    };
  },
  created() {
    this.db = getFirestore();
    this.authUnsub = onAuthStateChanged(auth, (user) => {
      this.currentAdminUid = user?.uid || '';
      this.currentAdminEmail = user?.email || '';
      if (!canManuallyManageCredit(user)) {
        this.form.creditApplied = 0;
        this.showCreditUsageConfirm = false;
        if (this.form.paymentMethod === 'credito') this.form.paymentMethod = '';
      }
      if (this.currentAdminUid !== VAT_22_ALLOWED_UID) {
        this.selectedAddVat22 = false;
      }
    });
    this.loadProducts();
    this.form.orderDateLocal = this.defaultLocalNow();
    this.applyEmailFilterFromRoute({ reload: false });
    this.reload();
    this.applyPrefillFromRoute();
  },
  beforeUnmount() {
    if (typeof this.authUnsub === 'function') {
      this.authUnsub();
      this.authUnsub = null;
    }
  },
  watch: {
    '$route.query'() {
      this.applyEmailFilterFromRoute({ reload: true });
      this.applyPrefillFromRoute();
    },
    selectedProductId(nextValue, prevValue) {
      if (nextValue === prevValue) return;
      const product = this.products.find((p) => p.id === nextValue) || null;
      this.selectedManualPrice = this.isManualPriceProduct(product)
        ? (Number(product?.price) || 0)
        : '';
      this.selectedAddVat22 = false;
    },
    'form.userEmail'(nextValue, prevValue) {
      const next = (nextValue || '').trim().toLowerCase();
      const prev = (prevValue || '').trim().toLowerCase();
      if (next === prev) return;
      this.resetCsenLookup();
      this.resetUserCredit();
    },
  },
  computed: {
    canManageUserCredit() {
      return canManuallyManageCredit({ uid: this.currentAdminUid, email: this.currentAdminEmail });
    },
    manualDiscountAmount() {
      return this.roundMoney(Math.max(0, Number(this.form.discount) || 0));
    },
    totalAfterManualDiscount() {
      return this.roundMoney(Math.max(0, (Number(this.total) || 0) - this.manualDiscountAmount));
    },
    creditAppliedAmount() {
      if (!this.canManageUserCredit) return 0;
      const requested = Math.max(0, Number(this.form.creditApplied) || 0);
      const available = Math.max(0, Number(this.userCredit.total) || 0);
      return this.roundMoney(Math.min(requested, available, this.totalAfterManualDiscount));
    },
    computedDiscountTotal() {
      return this.roundMoney(Math.max(0, this.totalAfterManualDiscount - this.creditAppliedAmount));
    },
    canApplyCredit() {
      return (
        this.canManageUserCredit &&
        !this.userCredit.loading &&
        !this.userCredit.error &&
        Number(this.userCredit.total) > 0 &&
        this.totalAfterManualDiscount > 0
      );
    },
    manualInstallmentsTotal() {
      const items = Array.isArray(this.form.manualInstallments) ? this.form.manualInstallments : [];
      return items.reduce((sum, inst) => sum + (Number(inst.amount) || 0), 0);
    },
    manualInstallmentsDelta() {
      if (this.form.paymentMethod !== 'rate_manuali') return 0;
      const total = Number(this.manualInstallmentsTotal) || 0;
      const orderTotal = Number(this.computedDiscountTotal) || 0;
      const diff = total - orderTotal;
      return Math.abs(diff) < 0.01 ? 0 : diff;
    },
    manualInstallmentsDeltaAbs() {
      return Math.abs(this.manualInstallmentsDelta || 0);
    },
    almaInstallmentsOptionsForForm() {
      return this.almaInstallmentsOptions;
    },
    manualOrderProducts() {
      return manualOrderProductOptions(this.products);
    },
    selectedProductForPicker() {
      const productId = this.selectedProductId;
      if (!productId) return null;
      return this.manualOrderProducts.find(p => p.id === productId) || null;
    },
    isSelectedCustomPtProduct() {
      return this.isCustomPtProduct(this.selectedProductForPicker);
    },
    isSelectedManualPriceProduct() {
      return this.isManualPriceProduct(this.selectedProductForPicker);
    },
    canUseVat22Flag() {
      return this.currentAdminUid === VAT_22_ALLOWED_UID;
    },
    selectedProductBasePrice() {
      if (!this.selectedProductForPicker) return 0;
      const rawPrice = this.isSelectedManualPriceProduct
        ? Number(this.selectedManualPrice)
        : Number(this.selectedProductForPicker.price);
      return Number.isFinite(rawPrice) && rawPrice > 0 ? rawPrice : 0;
    },
    selectedVatPreviewPrice() {
      if (!this.canUseVat22Flag || !this.selectedAddVat22) return 0;
      return this.addVat22ToPrice(this.selectedProductBasePrice);
    },
    customPtQtyOptions() {
      return Array.from(
        { length: CUSTOM_PT_MAX_QTY - CUSTOM_PT_MIN_QTY + 1 },
        (_, index) => CUSTOM_PT_MIN_QTY + index
      );
    },
    csenCreateInfo() {
      const lines = Array.isArray(this.lines) ? this.lines : [];
      const csenLines = lines.filter(line => this.isCsenLine(line));
      if (!csenLines.length) return { visible: false };

      const qty = csenLines.reduce((sum, line) => sum + (Number(line.quantity) || 0), 0) || 1;
      const purchaseDate = this.parseLocalDateOnly(this.form.orderDateLocal);
      if (!purchaseDate) {
        return {
          visible: true,
          status: 'missing',
          label: 'Data ordine mancante',
          icon: 'help_outline',
          className: 'csen-status--missing',
          qty,
          purchaseLabel: '—',
          expiryLabel: '—',
          hint: 'Imposta la data ordine per calcolare la validità CSEN.',
        };
      }

      const expiryDate = this.addMonthsLocal(purchaseDate, CSEN_DURATION_MONTHS);
      const warningStart = this.addMonthsLocal(expiryDate, -1);
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

      let status = 'valid';
      if (today > expiryDate) status = 'expired';
      else if (today >= warningStart) status = 'warning';

      const labels = {
        valid: 'Valido',
        warning: 'In scadenza',
        expired: 'Scaduto',
      };
      const icons = {
        valid: 'check_circle',
        warning: 'error',
        expired: 'cancel',
      };

      return {
        visible: true,
        status,
        label: labels[status],
        icon: icons[status],
        className: `csen-status--${status}`,
        qty,
        purchaseLabel: this.formatShortDate(purchaseDate),
        expiryLabel: this.formatShortDate(expiryDate),
        hint: `Validità ${CSEN_DURATION_MONTHS} mesi dalla data ordine.`,
      };
    },
    csenExistingInfo() {
      const email = this.normalizeEmail(this.form.userEmail || '');
      if (!email) return { visible: false };

      if (this.csenLookup.loading) {
        return {
          visible: true,
          label: 'Verifico…',
          icon: 'hourglass_top',
          className: 'csen-status--missing',
          tooltip: 'Ricerca ordini CSEN in corso.',
        };
      }

      if (this.csenLookup.checkedEmail !== email) {
        return {
          visible: true,
          label: 'Da verificare',
          icon: 'help_outline',
          className: 'csen-status--missing',
          tooltip: 'Aggiorna la verifica CSEN per questa email.',
        };
      }

      const purchaseDate = this.csenLookup.orderDate;
      if (!purchaseDate) {
        return {
          visible: true,
          label: 'Nessun acquisto',
          icon: 'help_outline',
          className: 'csen-status--missing',
          tooltip: 'Nessun ordine CSEN pagato trovato per questa email.',
        };
      }

      const expiryDate = this.addMonthsLocal(purchaseDate, CSEN_DURATION_MONTHS);
      const warningStart = this.addMonthsLocal(expiryDate, -1);
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

      let status = 'valid';
      if (today > expiryDate) status = 'expired';
      else if (today >= warningStart) status = 'warning';

      const labels = {
        valid: 'Valido',
        warning: 'In scadenza',
        expired: 'Scaduto',
      };
      const icons = {
        valid: 'check_circle',
        warning: 'error',
        expired: 'cancel',
      };

      const purchaseLabel = this.formatShortDate(purchaseDate);
      const expiryLabel = this.formatShortDate(expiryDate);
      const tooltip = `Ultimo acquisto: ${purchaseLabel} · Scadenza: ${expiryLabel}`;

      return {
        visible: true,
        label: labels[status],
        icon: icons[status],
        className: `csen-status--${status}`,
        tooltip,
      };
    },
    editSelectedProduct() {
      const pid = this.editForm?.productId;
      if (!pid) return null;
      return this.products.find(p => p.id === pid) || null;
    },
    productFilterOptions() {
      return [...this.products].sort((a, b) =>
        String(a.name || '').localeCompare(String(b.name || ''), 'it', { sensitivity: 'base' })
      );
    },
    manualInstallmentsLink() {
      const email = (this.filters?.email || '').trim();
      const query = email ? { searchEmail: email } : {};
      return { path: '/rate-manuali', query };
    },
    receiptCustomer() {
      if (!this.receiptOrder) return {};
      return this.deriveUserDetailsFromOrder(this.receiptOrder);
    },
    receiptItems() {
      if (!this.receiptOrder || !Array.isArray(this.receiptOrder.products)) return [];
      return this.receiptOrder.products.map((item) => {
        const quantity = Number(item?.quantity ?? item?.qty ?? 1) || 1;
        const unitPrice = Number(item?.price ?? item?.unitPrice ?? item?.unit_price ?? 0) || 0;
        const total = Number(item?.total ?? item?.line_total ?? unitPrice * quantity) || 0;
        return {
          name: (item?.name || item?.id || 'Prodotto').toString(),
          quantity,
          price: unitPrice,
          total,
        };
      });
    },
  },
  methods: {
    mapOrderDoc(docSnap) {
      if (!docSnap) return null;
      const data = typeof docSnap.data === 'function' ? docSnap.data() || {} : {};
      const docId = docSnap.id || data._id || '';
      const rawSource = data.source ? String(data.source).toLowerCase() : '';
      const publicCheckoutSource = data.checkoutSource || data.landingSource || 'fuscofit';
      const derivedSource = rawSource === 'public_checkout'
        ? publicCheckoutSource
        : (data.source
          ? data.source
          : (docId.startsWith('legacy_')
          ? 'legacy'
          : docId.startsWith('export_')
            ? 'woocommerce'
            : docId.startsWith('manual_')
              ? 'manuale'
              : 'unknown'));
      return { _id: docId, _source: derivedSource, ...data, orderDate: resolveGiftCardOrderDate(data) };
    },
    statusClass(status) {
      return (status || 'unknown')
        .toString()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-');
    },
    isStatusWithPaidProximityCheck(statusRaw) {
      const normalized = String(statusRaw || '').trim().toLowerCase();
      return normalized === 'in attesa di pagamento' || normalized === 'cancellato' || normalized === 'scaduto';
    },
    isCoachingDayOnlineProductLabel(value) {
      const normalized = this.normalizeProductLabel(value)
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      if (!normalized) return false;
      return normalized.includes('coaching day online');
    },
    isCoachingDayOnlineOrder(order) {
      const products = Array.isArray(order?.products) ? order.products : [];
      if (!products.length) return false;
      return products.some((product) => {
        const labels = [product?.name, product?.id, product?.sku, product?.productName, product?.title];
        return labels.some((label) => this.isCoachingDayOnlineProductLabel(label));
      });
    },
    getOrderIdentityKey(order) {
      if (!order) return '';
      const reference = order._id || order.orderId || order.id;
      if (reference) return String(reference);
      const email = this.normalizeEmail(order.userEmail || order.customerEmail || order.email);
      const date = order.orderDate || order.createdAt || '';
      return email && date ? `${email}|${date}` : '';
    },
    captureNearbyPaidOrderCandidates(orders) {
      const candidates = Array.isArray(orders) ? orders : [];
      if (!candidates.length) return;

      const indexed = new Map();
      (this.nearbyPaidOrderCandidates || []).forEach((order) => {
        const key = this.getOrderIdentityKey(order);
        if (key) indexed.set(key, order);
      });
      candidates.forEach((order) => {
        if (!this.isPaidOrProcessingStatus(order?.status)) return;
        const key = this.getOrderIdentityKey(order);
        if (key) indexed.set(key, order);
      });
      this.nearbyPaidOrderCandidates = Array.from(indexed.values());
    },
    getNearbyPaidOrderSearchSpace() {
      const indexed = new Map();
      [...(this.nearbyPaidOrderCandidates || []), ...(this.orders || [])].forEach((order) => {
        const key = this.getOrderIdentityKey(order);
        if (key) indexed.set(key, order);
      });
      return Array.from(indexed.values());
    },
    getNearbyPaidOrdersForOrder(order) {
      if (!order || !this.isStatusWithPaidProximityCheck(order.status)) return [];
      const baseDate = this.parseOrderDateFromOrder(order);
      if (!baseDate) return [];

      const baseMs = baseDate.getTime();
      const proximityMs = 48 * 60 * 60 * 1000;
      const orders = this.getNearbyPaidOrderSearchSpace();

      const candidates = orders
        .filter((candidate) => {
          if (!candidate || candidate === order) return false;
          if (!this.isSameCustomerOrder(order, candidate)) return false;
          if (!this.isPaidOrProcessingStatus(candidate.status)) return false;
          if (this.isCoachingDayOnlineOrder(candidate)) return false;
          const candidateDate = this.parseOrderDateFromOrder(candidate);
          if (!candidateDate) return false;
          return Math.abs(candidateDate.getTime() - baseMs) <= proximityMs;
        })
        .map((candidate) => {
          const candidateDate = this.parseOrderDateFromOrder(candidate);
          const distanceMs = candidateDate ? Math.abs(candidateDate.getTime() - baseMs) : Number.POSITIVE_INFINITY;
          return { order: candidate, distanceMs };
        })
        .filter((entry) => entry.order && Number.isFinite(entry.distanceMs))
        .sort((a, b) => a.distanceMs - b.distanceMs)
        .map((entry) => entry.order);

      return candidates;
    },
    getOrderReference(order) {
      if (!order) return 'ordine';
      const ref = order.orderNumber || order.orderId || order._id || order.id;
      if (ref) return String(ref);
      const email = this.normalizeEmail(order.userEmail || order.customerEmail || order.email);
      return email ? `utente:${email}` : 'ordine';
    },
    getOrderProductsSummary(order) {
      const products = Array.isArray(order?.products) ? order.products : [];
      if (!products.length) return 'Prodotto non disponibile';
      const list = this.formatProductList(products);
      return `Prodotti: ${list}`;
    },
    nearbyPaidOrdersLabel(order) {
      const candidates = this.getNearbyPaidOrdersForOrder(order);
      if (!candidates.length) return 'Esiste un ordine pagato entro 48 ore.';
      const first = candidates[0];
      const id = this.getOrderReference(first);
      const date = this.formatDate(first.orderDate);
      const productsSummary = this.getOrderProductsSummary(first);
      return `Ordine pagato correlato: ${id} (${date}) — ${productsSummary}`;
    },
    isSameCustomerOrder(a, b) {
      if (!a || !b) return false;
      const uidA = a.userUid || a.userId || a.uid || '';
      const uidB = b.userUid || b.userId || b.uid || '';
      if (uidA && uidB) {
        return String(uidA) === String(uidB);
      }
      const emailA = this.normalizeEmail(a.userEmail || a.customerEmail || a.email);
      const emailB = this.normalizeEmail(b.userEmail || b.customerEmail || b.email);
      if (!emailA || !emailB) return false;
      return emailA === emailB;
    },
    hasNearbyPaidOrder(order) {
      return this.getNearbyPaidOrdersForOrder(order).length > 0;
    },
    showNearbyPaidOrderReference(order) {
      const candidates = this.getNearbyPaidOrdersForOrder(order);
      if (!candidates.length) return;

      const lines = candidates.slice(0, 5).map((candidate, index) => {
        const id = this.getOrderReference(candidate);
        const date = this.formatDate(candidate.orderDate);
        const productsSummary = this.getOrderProductsSummary(candidate);
        return `${index + 1}. ${id} — ${date} — ${this.formatStatus(candidate.status || '')} — ${productsSummary}`;
      });
      const extra = candidates.length > lines.length ? `\n...e altri ${candidates.length - lines.length} ordine/i.` : '';
      window.alert(`Ordini pagati entro ±48 ore per questo utente:\n${lines.join('\n')}${extra}`);
    },
    formatLabel(value) {
      if (!value) return '—';
      return value
        .toString()
        .replace(/[_-]+/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase());
    },
    formatStatus(status) {
      if (String(status || '').trim().toLowerCase() === 'annullata') {
        return 'Annullata / non dovuta';
      }
      return this.formatLabel(status || 'Unknown');
    },
    normalizeEmail(value) {
      if (!value) return '';
      return value.toString().trim().toLowerCase();
    },
    looksLikeExactEmail(value) {
      const trimmed = (value || '').trim();
      if (!trimmed) return false;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
    },
    normalizeStudioName(value) {
      if (!value) return '';
      return value
        .toString()
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ');
    },
    normalizeProductLabel(value) {
      return (value || '')
        .toString()
        .trim()
        .toLowerCase();
    },
    normalizeProductSku(value) {
      return (value || '')
        .toString()
        .trim()
        .toLowerCase();
    },
    isProtocollo25Product(productLike) {
      if (!productLike) return false;
      const sku = typeof productLike === 'string'
        ? productLike
        : (productLike.sku || productLike.SKU || '');
      return this.normalizeProductSku(sku) === PROTOCOLLO_25_SKU;
    },
    addCalendarMonthsClampedIso(value, months) {
      const date = value ? new Date(value) : null;
      if (!date || Number.isNaN(date.getTime())) return null;

      const amount = Number(months) || 0;
      const originalDay = date.getUTCDate();
      const shifted = new Date(date.getTime());
      shifted.setUTCDate(1);
      shifted.setUTCMonth(shifted.getUTCMonth() + amount);
      const lastDay = new Date(Date.UTC(
        shifted.getUTCFullYear(),
        shifted.getUTCMonth() + 1,
        0
      )).getUTCDate();
      shifted.setUTCDate(Math.min(originalDay, lastDay));
      return shifted.toISOString();
    },
    isCustomPtProduct(productLike) {
      if (!productLike) return false;
      if (typeof productLike === 'string') {
        return this.normalizeProductSku(productLike) === CUSTOM_PT_SKU;
      }
      const sku = productLike.sku || productLike.SKU || '';
      return this.normalizeProductSku(sku) === CUSTOM_PT_SKU;
    },
    isManualPriceProduct(productLike) {
      if (!productLike) return false;
      if (typeof productLike === 'string') {
        return this.normalizeProductSku(productLike) === MANUAL_PRICE_SKU;
      }
      const sku = productLike.sku || productLike.SKU || '';
      return this.normalizeProductSku(sku) === MANUAL_PRICE_SKU;
    },
    hasInvalidManualPriceLine(line = null) {
      if (!this.isManualPriceProduct(line)) return false;
      const price = Number(line?.price);
      return !Number.isFinite(price) || price <= 0;
    },
    isCustomPtOrderLine(line = null, effectiveProd = null) {
      const skuCandidates = [
        line?.sku,
        line?.SKU,
        effectiveProd?.sku,
        effectiveProd?.SKU,
      ];
      if (skuCandidates.some((sku) => this.isCustomPtProduct(sku))) return true;

      const labelCandidates = [
        line?.name,
        line?.productName,
        line?.title,
        effectiveProd?.name,
      ];
      return labelCandidates.some((value) =>
        this.normalizeProductLabel(value).includes('seduta pt online custom')
      );
    },
    resolvePtSessionModeForLine(line = null, effectiveProd = null) {
      if (this.isCustomPtOrderLine(line, effectiveProd)) return 'online';

      const labelCandidates = [
        line?.name,
        line?.productName,
        line?.title,
        effectiveProd?.name,
      ];
      const hasOnlineHint = labelCandidates.some((value) =>
        this.normalizeProductLabel(value).includes('online')
      );
      return hasOnlineHint ? 'online' : 'studio';
    },
    orderHasQuestionarioEligibleProducts(orderPayload = {}) {
      if (this.isGiftCardOrder(orderPayload)) return false;
      const lines = Array.isArray(orderPayload?.products) ? orderPayload.products : [];
      if (!lines.length) return false;

      return lines.some((line) => {
        const product = this.products.find((p) => p.id === line?.id);
        const fallbackProd = product ? null : this.lookupProductFallback(line);
        const effectiveProd = product || fallbackProd || null;
        if (this.isCustomPtOrderLine(line, effectiveProd)) return false;

        let coachingBase = Number(effectiveProd?.coaching_quantity ?? effectiveProd?.coachingQty);
        if (!Number.isFinite(coachingBase) || coachingBase <= 0) {
          coachingBase = this.inferCoachingQty(line?.name, line?.sku);
        }

        const consNutr = Number(effectiveProd?.cons_nutrizionali ?? effectiveProd?.consNutr ?? 0);
        const consTech = Number(effectiveProd?.cons_tecniche ?? effectiveProd?.consTec ?? 0);
        const hasConsulenze = consNutr > 0 || consTech > 0;
        const priceNum = Number(line?.price ?? effectiveProd?.price ?? 0) || 0;

        return priceNum !== 0 && (coachingBase > 0 || hasConsulenze);
      });
    },
    clampCustomPtQty(value) {
      const parsed = Number(value);
      if (!Number.isFinite(parsed)) return CUSTOM_PT_MIN_QTY;
      return Math.min(CUSTOM_PT_MAX_QTY, Math.max(CUSTOM_PT_MIN_QTY, Math.round(parsed)));
    },
    normalizeWooValue(value) {
      const norm = this.normalizeProductLabel(value);
      if (!norm) return '';
      if (norm.startsWith('woo:')) return norm.slice(4).trim();
      return norm;
    },
    normalizeCsenKey(value) {
      return (value || '')
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '');
    },
    isCsenLine(line) {
      if (!line) return false;
      const skuKey = this.normalizeCsenKey(line.sku);
      const nameKey = this.normalizeCsenKey(line.name || line.productName || line.title);
      if (skuKey === CSEN_PRODUCT_KEY || nameKey === CSEN_PRODUCT_KEY) return true;
      const matched = this.matchProductFromLine(line);
      if (!matched) return false;
      const matchedSku = this.normalizeCsenKey(matched.sku);
      const matchedName = this.normalizeCsenKey(matched.name);
      return matchedSku === CSEN_PRODUCT_KEY || matchedName === CSEN_PRODUCT_KEY;
    },
    async applyTopStudioOverride({ userUid, orderId, originalStudio, forcedStudio, payload } = {}) {
      if (!userUid || !forcedStudio) return;
      const userRef = doc(this.db, 'users', String(userUid));
      let currentStudio = null;
      try {
        const snap = await getDoc(userRef);
        if (!snap.exists()) return;
        const data = snap.data() || {};
        currentStudio = (data.studio || '').trim() || null;
      } catch (err) {
        console.warn('applyTopStudioOverride: lettura utente fallita', err);
        return;
      }

      const prevStudio = (originalStudio || currentStudio || '').trim() || null;
      const updates = {};
      if (currentStudio !== forcedStudio) {
        updates.studio = forcedStudio;
        updates.updatedAt = new Date().toISOString();
      }
      if (prevStudio && prevStudio !== forcedStudio) {
        updates.studioOriginal = prevStudio;
        updates.studioOriginalOrderId = orderId || null;
      }
      if (Object.keys(updates).length) {
        try {
          await updateDoc(userRef, updates);
        } catch (err) {
          console.warn('applyTopStudioOverride: update utente fallito', err);
        }
      }

      if (payload && prevStudio && prevStudio !== forcedStudio) {
        payload.customerStudioOriginal = prevStudio;
      }
    },
    parseOrderDateFromOrder(order = {}) {
      const value = order?.orderDate;
      if (!value) return null;
      if (typeof value?.toDate === 'function') {
        const date = value.toDate();
        return date instanceof Date && !Number.isNaN(date.getTime()) ? date : null;
      }
      const str = String(value).trim();
      if (!str) return null;
      const normalized = str.includes('T') ? str : str.replace(' ', 'T');
      const parsed = new Date(normalized);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    },
    isInvalidOrderStatus(statusRaw) {
      const status = String(statusRaw || '').trim().toLowerCase();
      if (!status) return false;
      return (
        isManualInstallmentsTerminalStatus(statusRaw) ||
        status.includes('rimborsato') ||
        status.includes('refunded') ||
        status.includes('failed')
      );
    },
    isTerminalOrder(order = {}) {
      return isManualInstallmentsOrderTerminal(order);
    },
    isPaidOrder(order = {}) {
      const status = String(order.status || '').trim().toLowerCase();
      const paymentStatus = String(order.paymentStatus || '').trim().toLowerCase();
      if (this.isInvalidOrderStatus(status) || this.isInvalidOrderStatus(paymentStatus)) return false;
      return status === 'pagato' || status === 'rateizzato' || status === 'completed' || paymentStatus === 'completed';
    },
    parseLocalDateOnly(localStr) {
      const raw = String(localStr || '').trim();
      if (!raw) return null;
      const datePart = raw.split('T')[0];
      const match = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!match) return null;
      const year = Number(match[1]);
      const month = Number(match[2]) - 1;
      const day = Number(match[3]);
      const parsed = new Date(year, month, day);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    },
    normalizePercorsiStartDate(dateStr) {
      const parsed = this.parseLocalDateOnly(dateStr);
      return parsed ? parsed.toISOString() : null;
    },
    resolvePercorsiStartAt(orderPayload = {}) {
      const raw = orderPayload?.percorsiStartAt || null;
      if (!raw) return null;
      const parsed = new Date(raw);
      return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString();
    },
    isFutureIsoDate(iso) {
      if (!iso) return false;
      const parsed = new Date(iso);
      if (Number.isNaN(parsed.getTime())) return false;
      return parsed.getTime() > Date.now();
    },
    addMonthsLocal(date, months) {
      if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;
      const out = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      out.setMonth(out.getMonth() + Number(months || 0));
      return out;
    },
    formatShortDate(date) {
      if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '—';
      return date.toLocaleDateString('it-IT');
    },
    resetCsenLookup() {
      this.csenLookup = { loading: false, checkedEmail: '', orderDate: null };
    },
    async fetchCsenStatusForUser() {
      const emailRaw = (this.form.userEmail || '').trim();
      const emailNormalized = this.normalizeEmail(emailRaw);
      const uid = this.userLookup.uid || null;
      if (!emailRaw && !uid) {
        this.resetCsenLookup();
        return;
      }

      const requestEmail = emailNormalized || emailRaw;
      this.csenLookup = { loading: true, checkedEmail: requestEmail, orderDate: null };

      try {
        const ordersRef = collection(this.db, 'orders');
        const attempts = [];
        const pushAttempt = (field, value) => {
          if (!field || !value) return;
          attempts.push({ field, value });
        };

        if (uid) {
          pushAttempt('userUid', uid);
          pushAttempt('uid', uid);
          pushAttempt('userId', uid);
        }
        if (emailRaw) {
          pushAttempt('userEmail', emailRaw);
          pushAttempt('customerEmail', emailRaw);
        }
        if (emailNormalized && emailNormalized !== emailRaw) {
          pushAttempt('userEmail', emailNormalized);
          pushAttempt('customerEmail', emailNormalized);
        }

        const docsById = new Map();
        for (const attempt of attempts) {
          try {
            const snap = await getDocs(query(ordersRef, where(attempt.field, '==', attempt.value)));
            snap.forEach((docSnap) => {
              if (!docsById.has(docSnap.id)) {
                docsById.set(docSnap.id, docSnap.data());
              }
            });
          } catch (err) {
            console.warn(`fetchCsenStatusForUser query failed (${attempt.field} == ${attempt.value}):`, err);
          }
        }

        let latest = null;
        for (const order of docsById.values()) {
          if (!this.isPaidOrder(order)) continue;
          const products = Array.isArray(order?.products) ? order.products : [];
          if (!products.some(line => this.isCsenLine(line))) continue;
          const date = this.parseOrderDateFromOrder(order);
          if (!date) continue;
          if (!latest || date > latest) latest = date;
        }

        if (this.csenLookup.checkedEmail !== requestEmail) return;
        this.csenLookup = { loading: false, checkedEmail: requestEmail, orderDate: latest };
      } catch (error) {
        console.error('fetchCsenStatusForUser error:', error);
        if (this.csenLookup.checkedEmail === requestEmail) {
          this.csenLookup = { loading: false, checkedEmail: requestEmail, orderDate: null };
        }
      }
    },
    setUserStudioCache(key, value) {
      if (!key) return;
      const safeValue = value || '';
      if (this.$set) this.$set(this.userStudioCache, key, safeValue);
      else this.userStudioCache[key] = safeValue;
    },

    async fetchUserStudioByUid(uid) {
      if (!uid) return '';
      if (Object.prototype.hasOwnProperty.call(this.userStudioCache, uid)) {
        return this.userStudioCache[uid];
      }
      try {
        const snap = await getDoc(doc(this.db, 'users', uid));
        const studio = snap?.exists?.() ? (snap.data()?.studio || '') : '';
        this.setUserStudioCache(uid, studio);
        return studio;
      } catch (err) {
        console.warn('fetchUserStudioByUid error:', err);
        this.setUserStudioCache(uid, '');
        return '';
      }
    },

    async resolveOrderStudio(order) {
      if (!order) return '';
      if (Object.prototype.hasOwnProperty.call(order, '_resolvedStudio')) {
        return order._resolvedStudio || '';
      }

      const inline = order.userStudio || order.customerStudio || order.studio;
      if (inline) {
        order._resolvedStudio = inline;
        return inline;
      }

      let uid = order.userUid || order.userId || order.uid || null;
      if (!uid) {
        try {
          uid = await this.ensureUserLinkForOrder(order);
        } catch (err) {
          console.warn('resolveOrderStudio ensureUserLinkForOrder error:', err);
        }
      }

      let studio = '';
      if (uid) {
        studio = await this.fetchUserStudioByUid(uid);
      } else if (order.userEmail) {
        const rawEmail = (order.userEmail || '').trim();
        const normalizedEmail = this.normalizeEmail(rawEmail);
        if (normalizedEmail) {
          const emailKey = normalizedEmail;
          if (Object.prototype.hasOwnProperty.call(this.userStudioCache, emailKey)) {
            studio = this.userStudioCache[emailKey];
          } else {
            try {
              let docSnap = null;
              const primarySnap = await getDocs(
                query(collection(this.db, 'users'), where('email', '==', rawEmail), limit(1))
              );
              if (!primarySnap.empty) {
                docSnap = primarySnap.docs[0];
              } else if (rawEmail.toLowerCase() !== rawEmail) {
                const fallbackSnap = await getDocs(
                  query(collection(this.db, 'users'), where('email', '==', normalizedEmail), limit(1))
                );
                if (!fallbackSnap.empty) docSnap = fallbackSnap.docs[0];
              }
              if (docSnap) {
                const data = docSnap.data() || {};
                studio = data.studio || '';
                const inferredUid = data.uid || docSnap.id || null;
                this.setUserStudioCache(emailKey, studio);
                if (inferredUid) {
                  this.setUserStudioCache(inferredUid, studio);
                  if (!order.userUid) {
                    if (this.$set) this.$set(order, 'userUid', inferredUid);
                    else order.userUid = inferredUid;
                  }
                }
              } else {
                this.setUserStudioCache(emailKey, '');
              }
            } catch (err) {
              console.warn('resolveOrderStudio email lookup error:', err);
              this.setUserStudioCache(emailKey, '');
            }
          }
        }
      }

      order._resolvedStudio = studio;
      return studio;
    },

    async filterBatchByStudio(batch) {
      const filterValue = this.filters.studio;
      if (!filterValue) return batch;
      if (filterValue === this.noStudioFilterValue) {
        const decisions = await Promise.all(
          batch.map(async order => {
            const studio = await this.resolveOrderStudio(order);
            return !this.normalizeStudioName(studio);
          })
        );
        return batch.filter((_, idx) => decisions[idx]);
      }
      const target = this.normalizeStudioName(filterValue);
      if (!target) return batch;
      const decisions = await Promise.all(
        batch.map(async order => {
          const studio = await this.resolveOrderStudio(order);
          return this.normalizeStudioName(studio) === target;
        })
      );
      return batch.filter((_, idx) => decisions[idx]);
    },
    hasProductFilter() {
      const raw = this.filters.product;
      if (Array.isArray(raw)) {
        return raw.filter(Boolean).length > 0;
      }
      return !!raw;
    },
    orderMatchesProductFilter(order) {
      const raw = this.filters.product;
      const targetIds = Array.isArray(raw)
        ? raw.map(val => String(val || '')).filter(Boolean)
        : (raw ? [String(raw)] : []);
      if (!targetIds.length) return true;
      if (!order) return false;

      const lines = Array.isArray(order.products) ? order.products : [];
      if (!lines.length) return false;

      return targetIds.some(targetId => {
        const target = this.products.find(p => String(p.id) === targetId) || null;
        const targetSku = (target?.sku || '').toString().trim().toLowerCase();
        const targetName = this.normalizeProductLabel(target?.name);
        const targetWoo = this.normalizeWooValue(target?.woo);

        return lines.some(line => {
          if (!line) return false;
          const lineId = (line.id || '').toString();
          if (lineId && lineId === targetId) return true;

          const matched = this.matchProductFromLine(line);
          if (matched && String(matched.id) === targetId) return true;

          const lineSku = (line.sku || '').toString().trim().toLowerCase();
          if (targetSku && lineSku && lineSku === targetSku) return true;

          if (targetName) {
            const lineName = this.normalizeProductLabel(line.name);
            if (lineName && lineName === targetName) return true;
          }

          if (targetWoo) {
            const lineNameWoo = this.normalizeWooValue(line.name);
            const lineWooField = this.normalizeWooValue(line.woo);
            if (lineNameWoo && lineNameWoo === targetWoo) return true;
            if (lineWooField && lineWooField === targetWoo) return true;
          }

          return false;
        });
      });
    },
    proofDisplayLabel(proof = {}) {
      return manualInstallmentProofLabel(proof);
    },
    isRefundedStatus(status) {
      return String(status || '').toLowerCase() === 'rimborsato';
    },
    isGiftOrder(order) {
      return !!(order && order.gift);
    },
    isGiftCardOrder,
    isManagedGiftCardOrder(order) {
      return this.isGiftCardOrder(order) && order.gift?.type === 'giftcard';
    },
    giftCardCreditLabel(order) {
      if (order?.giftCredit?.status === 'credited') return 'Accreditato al destinatario';
      if (order?.giftCredit?.status === 'pending') return 'In attesa di pagamento e accredito';
      return 'Stato accredito non disponibile';
    },
    async confirmGiftCardTransfer(order) {
      const orderId = this.docKey(order);
      if (!orderId || this.isStatusSaving(order)) return false;
      if (!this.isManagedGiftCardOrder(order)) {
        this.setStatusError(order, 'Questo ordine non supporta l’accredito automatico della gift card.');
        return false;
      }
      if (!this.isBonificoOrder(order) || this.usesAutoGateway(order)) {
        this.setStatusError(order, 'Il credito viene aggiunto dopo la conferma del pagamento da parte del provider. Non è possibile forzarlo manualmente.');
        return false;
      }
      if (order.giftCredit?.status === 'credited') return true;
      const form = this.statusForm(order);
      if (!form.file && !order.paymentProof?.url) {
        this.setStatusError(order, 'Carica il documento contabile per confermare il bonifico e accreditare la gift card.');
        return false;
      }

      if (this.$set) this.$set(this.statusSaving, orderId, true);
      else this.statusSaving[orderId] = true;
      this.clearStatusError(orderId);
      this.successMsg = '';
      try {
        if (form.file) {
          const paymentProof = await this.uploadPaymentProof(order, form.file);
          await updateDoc(doc(this.db, 'orders', orderId), { paymentProof });
          order.paymentProof = paymentProof;
        }
        const confirmTransfer = httpsCallable(getFunctions(), 'confirmGiftCardBankTransfer');
        const response = await confirmTransfer({ orderId });
        const result = response?.data;
        if (!result?.ok || !result?.credited) {
          throw new Error('Il bonifico non è stato confermato. Nessun accredito confermato.');
        }
        Object.assign(order, {
          status: 'pagato',
          paymentStatus: 'pagato',
          userUid: result.recipientUid || order.userUid || null,
          giftCredit: {
            ...order.giftCredit,
            status: 'credited',
            amount: result.amount,
            amountCents: result.amountCents,
            currency: result.currency,
            recipientUid: result.recipientUid,
          },
        });
        this.successMsg = result.duplicate
          ? 'Gift card già accreditata al destinatario.'
          : 'Bonifico confermato e gift card accreditata al destinatario.';
        this.resetStatusForm(order);
        return true;
      } catch (error) {
        this.setStatusError(order, error?.message || 'Impossibile confermare il bonifico e accreditare la gift card.');
        return false;
      } finally {
        if (this.$set) this.$set(this.statusSaving, orderId, false);
        else this.statusSaving[orderId] = false;
      }
    },
    async paypalRequestHeaders() {
      const token = await auth.currentUser?.getIdToken();
      return {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      };
    },
    isManualOrder(order) {
      return (order?._source || '').toLowerCase() === 'manuale';
    },
    usesAutoGateway(order) {
      const method = (order?.paymentMethod || '').toLowerCase();
      const provider = (order?.paymentProvider || '').toLowerCase();
      return AUTO_GATEWAY_METHODS.includes(method) || AUTO_GATEWAY_METHODS.includes(provider);
    },
    isStatusChangeLocked(order) {
      if (!order) return false;
      const currentStatus = String(order?.status || '').toLowerCase();
      return currentStatus === 'in attesa di pagamento' && this.usesAutoGateway(order);
    },
    isBonificoOrder(order) {
      const method = (order?.paymentMethod || order?.paymentProvider || '').toLowerCase();
      return ['bonifico', 'bonifico bancario', 'bank-transfer', 'bank transfer'].includes(method);
    },
    docKey(order) {
      if (!order) return '';
      const raw = order._id || order.orderId;
      return raw ? String(raw) : '';
    },
    orderReferenceCandidates(orderOrId) {
      const rawValues = orderOrId && typeof orderOrId === 'object'
        ? [orderOrId._id, orderOrId.orderId, orderOrId.id]
        : [orderOrId];
      const candidates = [];
      const seen = new Set();

      rawValues.forEach(rawValue => {
        if (rawValue === undefined || rawValue === null) return;
        const stringValue = String(rawValue).trim();
        if (!stringValue) return;

        const stringKey = `string:${stringValue}`;
        if (!seen.has(stringKey)) {
          seen.add(stringKey);
          candidates.push(stringValue);
        }

        const numericValue = Number(stringValue);
        if (Number.isFinite(numericValue)) {
          const numericKey = `number:${numericValue}`;
          if (!seen.has(numericKey)) {
            seen.add(numericKey);
            candidates.push(numericValue);
          }
        }
      });

      return candidates;
    },
    shouldCleanupGeneratedOrderAssets(order = {}) {
      const statuses = [order.status, order.paymentStatus]
        .map(value => String(value || '').trim().toLowerCase());
      return statuses.some(status => (
        status.includes('cancellato')
        || status.includes('cancelled')
        || status.includes('canceled')
        || status.includes('rimborsato')
        || status.includes('refunded')
        || status === 'void'
      ));
    },
    async cleanupGeneratedOrderAssets(order, { refreshCount = true } = {}) {
      if (!order || !this.shouldCleanupGeneratedOrderAssets(order)) return false;
      const docId = this.docKey(order);
      if (!docId) return false;

      const [deletedPercorsi, deletedPtSessions] = await Promise.all([
        this.removePercorsiForOrder(order),
        this.removePtSessionsForOrder(order),
      ]);
      if (deletedPercorsi === null || deletedPtSessions === null) return false;

      const cleanedAt = new Date().toISOString();
      const cleanupUpdates = {
        percorsiCreationState: null,
        percorsiCreationAt: null,
        percorsiCreationError: null,
        percorsiCreatedAt: null,
        percorsiCreatedCount: 0,
        percorsiCancellationCleanupState: 'completed',
        percorsiCancellationCleanupAt: cleanedAt,
        percorsiCancellationDeletedCount: deletedPercorsi,
        ptCancellationDeletedCount: deletedPtSessions,
      };
      await updateDoc(doc(this.db, 'orders', String(docId)), cleanupUpdates);
      Object.assign(order, cleanupUpdates);
      if (refreshCount) await this.fetchPercorsiCount(order.orderId || order._id || docId);
      return true;
    },
    reconcileCancelledOrderAssets(order) {
      if (!this.shouldCleanupGeneratedOrderAssets(order)) return Promise.resolve(false);
      if (String(order.percorsiCancellationCleanupState || '').toLowerCase() === 'completed') {
        return Promise.resolve(false);
      }
      return this.cleanupGeneratedOrderAssets(order);
    },
    isOrderNoteSaving(order) {
      const key = this.docKey(order);
      return !!(key && this.orderNoteSaving[key]);
    },
    orderNoteError(order) {
      const key = this.docKey(order);
      return key ? this.orderNoteErrors[key] || '' : '';
    },
    clearOrderNoteError(order) {
      const key = this.docKey(order);
      if (!key) return;
      if (this.$set) this.$set(this.orderNoteErrors, key, '');
      else this.orderNoteErrors[key] = '';
    },
    async saveInternalReminderNote(order, event) {
      const key = this.docKey(order);
      const input = event?.target || null;
      const previousNote = String(order?.internalReminderNote || '').trim();
      const nextNote = String(input?.value || '').trim().slice(0, 2000);
      if (input) input.value = nextNote;

      if (!key) {
        if (input) input.value = previousNote;
        return;
      }
      if (nextNote === previousNote || this.isOrderNoteSaving(order)) return;

      const nowIso = new Date().toISOString();
      const updates = {
        internalReminderNote: nextNote,
        internalReminderNoteUpdatedAt: nowIso,
        internalReminderNoteUpdatedBy: auth?.currentUser?.uid || null,
      };

      if (this.$set) {
        this.$set(this.orderNoteSaving, key, true);
        this.$set(this.orderNoteErrors, key, '');
      } else {
        this.orderNoteSaving[key] = true;
        this.orderNoteErrors[key] = '';
      }

      try {
        await updateDoc(doc(this.db, 'orders', key), updates);
        Object.assign(order, updates);
      } catch (err) {
        console.error('saveInternalReminderNote error:', err);
        if (input) input.value = previousNote;
        const message = 'Salvataggio non riuscito.';
        if (this.$set) this.$set(this.orderNoteErrors, key, message);
        else this.orderNoteErrors[key] = message;
      } finally {
        if (this.$set) this.$set(this.orderNoteSaving, key, false);
        else this.orderNoteSaving[key] = false;
      }
    },
    statusForm(order) {
      const key = this.docKey(order);
      if (!key) {
        return { nextStatus: '', file: null, fileName: '' };
      }
      if (!this.statusForms[key]) {
        const normalized = String(order?.status || '').toLowerCase();
        let defaultStatus = '';
        if (normalized === 'in attesa di pagamento') defaultStatus = 'pagato';
        else if (normalized) defaultStatus = normalized;
        const initial = {
          nextStatus: defaultStatus,
          file: null,
          fileName: '',
        };
        if (this.$set) this.$set(this.statusForms, key, initial);
        else this.statusForms[key] = initial;
      }
      return this.statusForms[key];
    },
    updateStatusForm(order, patch = {}) {
      const key = this.docKey(order);
      if (!key) return;
      const current = this.statusForm(order);
      const next = { ...current, ...patch };
      if (this.$set) this.$set(this.statusForms, key, next);
      else this.statusForms[key] = next;
    },
    resetStatusForm(order) {
      const key = this.docKey(order);
      if (!key) return;
      const normalized = String(order?.status || '').toLowerCase();
      let defaultStatus = '';
      if (normalized === 'in attesa di pagamento') defaultStatus = 'pagato';
      else if (normalized) defaultStatus = normalized;
      const base = { nextStatus: defaultStatus, file: null, fileName: '' };
      if (this.$set) this.$set(this.statusForms, key, base);
      else this.statusForms[key] = base;
      this.clearStatusError(key);
    },
    onStatusSelectChange(order, value) {
      this.updateStatusForm(order, { nextStatus: value || '' });
      this.clearStatusError(this.docKey(order));
    },
    onStatusFileSelected(order, event) {
      const input = event?.target;
      const file = input?.files?.[0] || null;
      if (!file) {
        this.updateStatusForm(order, { file: null, fileName: '' });
        return;
      }
      if (!this.isValidProofFile(file)) {
        if (input) input.value = '';
        this.setStatusError(order, 'Carica un PDF o un’immagine valida.');
        return;
      }
      this.updateStatusForm(order, { file, fileName: file.name });
      this.clearStatusError(this.docKey(order));
    },
    isValidProofFile(file) {
      if (!file) return false;
      const type = (file.type || '').toLowerCase();
      const name = (file.name || '').toLowerCase();
      if (type === 'application/pdf') return true;
      if (type.startsWith('image/')) return true;
      const allowedExt = ['.pdf', '.jpg', '.jpeg', '.png', '.webp', '.gif', '.bmp', '.heic', '.heif'];
      return allowedExt.some(ext => name.endsWith(ext));
    },
    setStatusError(orderOrKey, message) {
      const key = typeof orderOrKey === 'string' ? orderOrKey : this.docKey(orderOrKey);
      if (!key) return;
      if (this.$set) this.$set(this.statusErrors, key, message || '');
      else this.statusErrors[key] = message || '';
    },
    clearStatusError(orderOrKey) {
      const key = typeof orderOrKey === 'string' ? orderOrKey : this.docKey(orderOrKey);
      if (!key) return;
      if (this.$set) this.$set(this.statusErrors, key, '');
      else this.statusErrors[key] = '';
    },
    statusError(order) {
      const key = this.docKey(order);
      if (!key) return '';
      return this.statusErrors[key] || '';
    },
    isStatusSaving(order) {
      const key = this.docKey(order);
      if (!key) return false;
      return !!this.statusSaving[key];
    },
    isGiftUserCreation(order) {
      const key = this.docKey(order);
      if (!key) return false;
      return !!this.giftUserCreation[key];
    },
    requiresPaymentProof(order, nextStatus) {
      const normalized = String(nextStatus || '').toLowerCase();
      if (normalized !== 'pagato') return false;
      const method = (order?.paymentMethod || order?.paymentProvider || '').toLowerCase();
      const bonificoKeys = ['bonifico', 'bonifico bancario', 'bank-transfer', 'bank transfer'];
      return bonificoKeys.includes(method);
    },

    isUserLookupInFlight(order) {
      const key = this.docKey(order);
      return !!(key && this.userUidLookupInFlight[key]);
    },

    async openUserProfile(order) {
      if (!order) return;
      try {
        const uid = await this.ensureUserLinkForOrder(order);
        if (uid) {
          const resolved = this.$router.resolve({ name: 'UserDetails', params: { userId: String(uid) } });
          window.open(resolved.href, '_blank', 'noopener');
        } else {
          alert('Profilo utente non trovato.');
        }
      } catch (err) {
        console.error('openUserProfile error:', err);
        alert('Impossibile aprire il profilo utente.');
      }
    },

    async ensureUserLinkForOrder(order) {
      if (!order) return null;
      const docId = this.docKey(order);
      const direct = [order.userUid, order.userId, order.uid, order.user_uid].find(Boolean);
      const emailRaw = (order.userEmail || '').trim();
      const emailKey = this.normalizeEmail(emailRaw);

      if (direct) {
        if (docId) {
          if (this.$set) {
            this.$set(this.userUidCache, docId, direct);
          } else {
            this.userUidCache[docId] = direct;
          }
        }
        if (emailKey) {
          if (this.$set) this.$set(this.emailUidCache, emailKey, direct);
          else this.emailUidCache[emailKey] = direct;
        }
        return direct;
      }

      if (!emailKey) {
        if (docId) {
          if (this.$set) this.$set(this.userUidCache, docId, null);
          else this.userUidCache[docId] = null;
        }
        return null;
      }

      if (docId && Object.prototype.hasOwnProperty.call(this.userUidCache, docId)) {
        const cachedDocUid = this.userUidCache[docId];
        if (cachedDocUid && !order.userUid) {
          if (this.$set) this.$set(order, 'userUid', cachedDocUid);
          else order.userUid = cachedDocUid;
        }
        return cachedDocUid || null;
      }

      if (emailKey && Object.prototype.hasOwnProperty.call(this.emailUidCache, emailKey)) {
        const cachedUid = this.emailUidCache[emailKey];
        if (docId) {
          if (this.$set) this.$set(this.userUidCache, docId, cachedUid);
          else this.userUidCache[docId] = cachedUid;
        }
        if (cachedUid && !order.userUid) {
          if (this.$set) this.$set(order, 'userUid', cachedUid);
          else order.userUid = cachedUid;
          if (docId && !this.isManagedGiftCardOrder(order)) {
            try {
              await updateDoc(doc(this.db, 'orders', docId), {
                userUid: cachedUid,
                updatedAt: new Date().toISOString(),
              });
            } catch (linkErr) {
              console.warn('Impossibile aggiornare order.userUid su Firestore (cache email):', linkErr);
            }
          }
        }
        return cachedUid || null;
      }

      if (docId) {
        const inFlight = this.userUidLookupInFlight[docId];
        if (inFlight) return inFlight;
      }

      const promise = (async () => {
        let uid = null;
        try {
          uid = await this.resolveUserUidByEmail(emailRaw);
          if (this.$set) {
            if (docId) this.$set(this.userUidCache, docId, uid || null);
            if (emailKey) this.$set(this.emailUidCache, emailKey, uid || null);
          } else {
            if (docId) this.userUidCache[docId] = uid || null;
            if (emailKey) this.emailUidCache[emailKey] = uid || null;
          }

          if (uid) {
            if (!order.userUid) {
              if (this.$set) this.$set(order, 'userUid', uid);
              else order.userUid = uid;
            }
            if (docId && !this.isManagedGiftCardOrder(order)) {
              try {
                await updateDoc(doc(this.db, 'orders', docId), {
                  userUid: uid,
                  updatedAt: new Date().toISOString(),
                });
              } catch (linkErr) {
                console.warn('Impossibile aggiornare order.userUid su Firestore:', linkErr);
              }
            }
          }
        } catch (err) {
          console.warn('ensureUserLinkForOrder error:', err);
          if (emailKey) {
            if (this.$set) this.$set(this.emailUidCache, emailKey, null);
            else this.emailUidCache[emailKey] = null;
          }
        } finally {
          if (docId) {
            if (this.$delete) this.$delete(this.userUidLookupInFlight, docId);
            else delete this.userUidLookupInFlight[docId];
          }
        }
        return uid;
      })();

      if (docId) {
        if (this.$set) this.$set(this.userUidLookupInFlight, docId, promise);
        else this.userUidLookupInFlight[docId] = promise;
      }

      return promise;
    },
    handlePaymentMethodChange() {
      const m = this.form.paymentMethod;

      // provider derivato
      if (m !== 'welfare') {
        this.form.welfareProvider = '';
      }
      this.form.paymentProvider = (m === 'paypal')
        ? 'paypal'
        : (m === 'alma')
          ? 'alma'
          : (m === 'klarna')
            ? 'klarna'
            : (m === 'welfare' ? (this.form.welfareProvider || '').trim() : '');

      if (m === 'alma' && !this.form.almaInstallments) {
        this.form.almaInstallments = 3;
      }

      if (m === 'rate_manuali') {
        this.form.status = 'in attesa di pagamento';
        if (!Array.isArray(this.form.manualInstallments) || !this.form.manualInstallments.length) {
          this.addManualInstallment();
        }
      } else if (m === 'contanti' || m === 'pos' || m === 'welfare' || m === 'credito') {
        this.form.status = 'pagato';
      } else if (m === 'bonifico' || m === 'paypal' || m === 'alma' || m === 'klarna') {
        this.form.status = 'in attesa di pagamento';
      }

      if (m !== 'rate_manuali' && Array.isArray(this.form.manualInstallments) && this.form.manualInstallments.length) {
        if (this.$set) this.$set(this.form, 'manualInstallments', []);
        else this.form.manualInstallments = [];
      }
    },



async copy(txt) {
  if (!txt) return;

  // 1) API moderna (richiede contesto sicuro: https o localhost)
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(txt);
      alert('Link copiato negli appunti');
      return;
    }
  } catch (e) {
    // passa ai fallback
  }

  // 2) Fallback compatibile (execCommand)
  try {
    const ta = document.createElement('textarea');
    ta.value = txt;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    alert('Link copiato (fallback)');
    return;
  } catch (e) {
    // passa all’ultimo fallback
  }

  // 3) Ultimo fallback
  prompt('Copia manualmente il link:', txt);
},

paypalOrderKey(order = {}) {
  return String(order?._id || order?.orderId || '').trim();
},

isPayPalRegenerating(order = {}) {
  const key = this.paypalOrderKey(order);
  return Boolean(key && this.paypalRegenerating[key]);
},

canRegeneratePayPalLink(order = {}) {
  const provider = String(order.paymentProvider || '').trim().toLowerCase();
  const method = String(order.paymentMethod || '').trim().toLowerCase();
  if (provider !== 'paypal' && method !== 'paypal') return false;
  if (this.isPaidOrder(order)) return false;
  if (this.isInvalidOrderStatus(order.status) || this.isInvalidOrderStatus(order.paymentStatus)) return false;
  const amount = Number(order.totalPrice);
  return Number.isFinite(amount) && amount > 0;
},

paypalItemsFromOrder(order = {}) {
  const products = Array.isArray(order.products) ? order.products : [];
  return products
    .map((p) => {
      const quantity = Number(p?.quantity) || 1;
      const rowTotal = Number(p?.total);
      const fallbackUnitPrice = Number.isFinite(rowTotal) && rowTotal > 0 ? rowTotal / quantity : 0;
      const price = Number(p?.unit_amount ?? p?.price ?? fallbackUnitPrice);
      return {
        name: String(p?.name || p?.sku || p?.id || 'Prodotto').slice(0, 127),
        quantity,
        unit_amount: Number.isFinite(price) && price > 0 ? price : 0,
      };
    })
    .filter((p) => p.unit_amount > 0);
},

buildPayPalRedirectUrls(orderId) {
  const basePath = (process.env.BASE_URL || '/').replace(/\/?$/, '/');
  const appBaseUrl = window.location.origin + basePath;
  return {
    returnUrl: `${appBaseUrl}#/paypal/return?orderId=${encodeURIComponent(orderId)}`,
    cancelUrl: `${appBaseUrl}#/paypal/cancel?orderId=${encodeURIComponent(orderId)}`,
  };
},

async regeneratePayPalLink(order = {}) {
  const orderId = this.paypalOrderKey(order);
  if (!orderId || this.isPayPalRegenerating(order)) return;
  if (!this.canRegeneratePayPalLink(order)) {
    this.errorMsg = 'Il link PayPal si puo rigenerare solo per ordini PayPal non saldati.';
    return;
  }

  const shouldContinue = typeof window === 'undefined'
    ? true
    : window.confirm('Rigenerare un nuovo link PayPal per questo ordine? Se presente, verra inviata una nuova email al cliente.');
  if (!shouldContinue) return;

  const url = getPayPalFunctionUrl('create');
  if (!url) {
    this.errorMsg = 'Endpoint creazione PayPal non configurato.';
    return;
  }

  const amount = Number(order.totalPrice);
  const previousPaypalOrderId = order.paypalOrderId || null;
  const previousPaypalApproveLink = order.paypalApproveLink || null;
  const { returnUrl, cancelUrl } = this.buildPayPalRedirectUrls(orderId);

  try {
    this.errorMsg = '';
    this.successMsg = '';
    if (this.$set) this.$set(this.paypalRegenerating, orderId, true);
    else this.paypalRegenerating[orderId] = true;

    const resp = await fetch(url, {
      method: 'POST',
      headers: await this.paypalRequestHeaders(),
      body: JSON.stringify({
        orderId,
        amount: amount.toFixed(2),
        currency: 'EUR',
        userEmail: this.normalizeEmail(order.userEmail || order.customerEmail || ''),
        returnUrl,
        cancelUrl,
        items: this.paypalItemsFromOrder(order),
        metadata: {
          createdFrom: 'OrderComponentNew.regeneratePayPalLink',
          previousPaypalOrderId,
        },
      }),
    });

    const text = await resp.text();
    let data = {};
    if (text) {
      try {
        data = JSON.parse(text);
      } catch (parseErr) {
        if (resp.ok) console.warn('Risposta PayPal non JSON:', parseErr);
      }
    }

    if (!resp.ok) {
      const detail = data?.error || data?.message || text || 'Errore durante la rigenerazione PayPal.';
      throw new Error(detail);
    }

    if (this.isManagedGiftCardOrder(order)) {
      if (data.alreadyPaid || data.status === 'COMPLETED') {
        const snapshot = await getDoc(doc(this.db, 'orders', orderId));
        if (!snapshot.exists()) throw new Error('Ordine non trovato. Aggiorna la pagina.');
        Object.assign(order, snapshot.data());
        this.successMsg = 'Gift card già pagata e credito accreditato al destinatario.';
        return;
      }
      if (!data.approveLink) throw new Error('PayPal non ha restituito un link di approvazione.');
      Object.assign(order, {
        paypalOrderId: data.paypalOrderId || order.paypalOrderId || null,
        paypalApproveLink: data.approveLink,
      });
      const payerEmail = order.payerEmail || order.gift?.payerEmail || order.gift?.fromEmail;
      this.successMsg = payerEmail
        ? `Link PayPal disponibile. L’invio dell’email è indirizzato a ${payerEmail}.`
        : 'Link PayPal disponibile.';
      return;
    }

    if (!data?.approveLink) {
      throw new Error('PayPal non ha restituito un nuovo link di approvazione.');
    }

    const nowIso = new Date().toISOString();
    const auditUpdate = {
      paypalLinkRegeneratedAt: nowIso,
      paypalPreviousOrderId: previousPaypalOrderId,
      paypalPreviousApproveLink: previousPaypalApproveLink,
      paypalRegeneratedBy: auth?.currentUser?.uid || null,
      updatedAt: nowIso,
    };
    await updateDoc(doc(this.db, 'orders', orderId), auditUpdate);

    const localUpdates = {
      paypalOrderId: data.paypalOrderId || null,
      paypalApproveLink: data.approveLink || null,
      paymentProvider: 'paypal',
      paymentStatus: 'pending',
      ...auditUpdate,
    };
    for (const [key, value] of Object.entries(localUpdates)) {
      if (this.$set) this.$set(order, key, value);
      else order[key] = value;
    }

    this.successMsg = order.userEmail
      ? `Nuovo link PayPal generato e inviato a ${order.userEmail}.`
      : 'Nuovo link PayPal generato.';
  } catch (err) {
    console.error('regeneratePayPalLink error:', err);
    this.errorMsg = err?.message || 'Errore durante la rigenerazione del link PayPal.';
  } finally {
    if (this.$set) this.$set(this.paypalRegenerating, orderId, false);
    else this.paypalRegenerating[orderId] = false;
  }
},

async callAlmaFunction(type, payload = {}) {
  const url = getAlmaFunctionUrl(type);
  if (!url) throw new Error(`Endpoint Alma non configurato per ${type}`);

  const resp = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const text = await resp.text();
  if (!resp.ok) {
    let detail = text || resp.statusText;
    try {
      const parsed = text ? JSON.parse(text) : null;
      if (parsed?.error) detail = parsed.error;
      else if (parsed?.message) detail = parsed.message;
      else if (parsed) detail = JSON.stringify(parsed);
    } catch (e) {
      // ignore
    }
    throw new Error(detail || 'Errore richiesta Alma');
  }
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch (err) {
    console.warn('Risposta Alma non JSON:', err);
    return {};
  }
},

async syncAlmaPayment(order, { silent } = {}) {
  if (!order) return;
  const docId = order._id || order.orderId;
  if (!docId) return;
  if (this.almaSyncing[docId]) return;
  const prevStatus = (order.status || '').toLowerCase();

  try {
    if (this.$set) this.$set(this.almaSyncing, docId, true);
    else this.almaSyncing[docId] = true;

    const result = await this.callAlmaFunction('sync', { orderId: String(docId) });
    const updates = result?.orderUpdate || {};
    for (const [key, value] of Object.entries(updates)) {
      if (this.$set) this.$set(order, key, value);
      else order[key] = value;
    }

    const nowRefunded = this.isRefundedStatus(order.status);
    if (!this.isRefundedStatus(prevStatus) && nowRefunded) {
      await this.handleOrderRefunded(order);
    }

    let autoCreated = false;
    let autoError = null;
    try {
      autoCreated = await this.maybeAutoCreatePercorsi(order, { previousStatus: prevStatus });
    } catch (autoErr) {
      autoError = autoErr;
      console.error('maybeAutoCreatePercorsi error:', autoErr);
    }

    if (!silent) {
      if (autoError) {
        this.errorMsg = `Stato pagamento Alma aggiornato ma generazione percorsi fallita: ${autoError?.message || 'Errore inatteso.'}`;
      } else {
        this.successMsg = autoCreated
          ? 'Stato pagamento Alma aggiornato e percorsi generati automaticamente.'
          : 'Stato pagamento Alma aggiornato.';
      }
    }
  } catch (err) {
    console.error('syncAlmaPayment error:', err);
    if (!silent) this.errorMsg = err?.message || 'Impossibile aggiornare lo stato Alma.';
  } finally {
    if (this.$set) this.$set(this.almaSyncing, docId, false);
    else this.almaSyncing[docId] = false;
  }
},

async cancelAlmaPayment(order) {
  if (!order) return false;
  const docId = order._id || order.orderId;
  if (!docId) return false;
  try {
    const result = await this.callAlmaFunction('cancel', { orderId: String(docId) });
    const updates = result?.orderUpdate || {};
    for (const [key, value] of Object.entries(updates)) {
      if (this.$set) this.$set(order, key, value);
      else order[key] = value;
    }
    this.successMsg = 'Pagamento Alma annullato correttamente.';
    return true;
  } catch (err) {
    console.error('cancelAlmaPayment error:', err);
    this.errorMsg = err?.message || 'Errore durante l’annullamento Alma.';
    return false;
  }
},

async callKlarnaFunction(type, payload = {}) {
  const url = getKlarnaFunctionUrl(type);
  if (!url) throw new Error(`Endpoint Klarna non configurato per ${type}`);

  const resp = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const text = await resp.text();
  if (!resp.ok) {
    let detail = text || resp.statusText;
    try {
      const parsed = text ? JSON.parse(text) : null;
      if (parsed?.error) detail = parsed.error;
      else if (parsed?.message) detail = parsed.message;
      else if (parsed) detail = JSON.stringify(parsed);
    } catch (e) {
      // ignore
    }
    throw new Error(detail || 'Errore richiesta Klarna');
  }
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch (err) {
    console.warn('Risposta Klarna non JSON:', err);
    return {};
  }
},

async syncKlarnaPayment(order, { silent } = {}) {
  if (!order) return;
  const docId = order._id || order.orderId;
  if (!docId) return;
  if (this.klarnaSyncing[docId]) return;
  const prevStatus = (order.status || '').toLowerCase();

  try {
    if (this.$set) this.$set(this.klarnaSyncing, docId, true);
    else this.klarnaSyncing[docId] = true;

    const result = await this.callKlarnaFunction('sync', { orderId: String(docId) });
    const updates = result?.orderUpdate || {};
    for (const [key, value] of Object.entries(updates)) {
      if (this.$set) this.$set(order, key, value);
      else order[key] = value;
    }

    const nowRefunded = this.isRefundedStatus(order.status);
    if (!this.isRefundedStatus(prevStatus) && nowRefunded) {
      await this.handleOrderRefunded(order);
    }

    let autoCreated = false;
    let autoError = null;
    try {
      autoCreated = await this.maybeAutoCreatePercorsi(order, { previousStatus: prevStatus });
    } catch (autoErr) {
      autoError = autoErr;
      console.error('maybeAutoCreatePercorsi Klarna error:', autoErr);
    }

    if (!silent) {
      if (autoError) {
        this.errorMsg = `Stato pagamento Klarna aggiornato ma generazione percorsi fallita: ${autoError?.message || 'Errore inatteso.'}`;
      } else {
        this.successMsg = autoCreated
          ? 'Stato pagamento Klarna aggiornato e percorsi generati automaticamente.'
          : 'Stato pagamento Klarna aggiornato.';
      }
    }
  } catch (err) {
    console.error('syncKlarnaPayment error:', err);
    if (!silent) this.errorMsg = err?.message || 'Impossibile aggiornare lo stato Klarna.';
  } finally {
    if (this.$set) this.$set(this.klarnaSyncing, docId, false);
    else this.klarnaSyncing[docId] = false;
  }
},

async cancelKlarnaPayment(order) {
  if (!order) return false;
  const docId = order._id || order.orderId;
  if (!docId) return false;
  try {
    const result = await this.callKlarnaFunction('cancel', { orderId: String(docId) });
    const updates = result?.orderUpdate || {};
    for (const [key, value] of Object.entries(updates)) {
      if (this.$set) this.$set(order, key, value);
      else order[key] = value;
    }
    this.successMsg = 'Pagamento Klarna annullato correttamente.';
    return true;
  } catch (err) {
    console.error('cancelKlarnaPayment error:', err);
    this.errorMsg = err?.message || 'Errore durante l’annullamento Klarna.';
    return false;
  }
},


    // #### Data loading ####
    async reload() {
      this.orders = [];
      this.nearbyPaidOrderCandidates = [];
      this.cursor = null;
      this.hasMore = true;
      this.userUidCache = {};
      this.userUidLookupInFlight = {};
      this.almaSyncing = {};
      this.klarnaSyncing = {};
      this.statusForms = {};
      this.statusSaving = {};
      this.statusErrors = {};
      this.orderNoteSaving = {};
      this.orderNoteErrors = {};
      await this.loadMore(true);
    },
    capitalizeFirst(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    async runSurnameSearch(term) {
      const trimmed = (term || '').trim();
      if (!trimmed) return [];

      const lower = trimmed.toLowerCase();
      const capitalized = this.capitalizeFirst(lower);
      const upper = trimmed.toUpperCase();
      const firstUpper = capitalized.charAt(0);
      const firstLower = firstUpper.toLowerCase();
      const prefixes = new Set();

      if (capitalized) prefixes.add(capitalized);
      if (trimmed && trimmed !== capitalized) prefixes.add(trimmed);
      if (upper && upper !== capitalized) prefixes.add(upper);
      if (firstUpper) prefixes.add(firstUpper);
      if (firstLower && firstLower !== firstUpper) prefixes.add(firstLower);

      const usersRef = collection(this.db, 'users');
      const surnameQueries = Array.from(prefixes).map(prefix => (
        getDocs(
          query(
            usersRef,
            orderBy('surname'),
            startAt(prefix),
            endAt(`${prefix}\uf8ff`),
            limit(SURNAME_FETCH_LIMIT)
          )
        )
      ));
      const snapshots = await Promise.allSettled(surnameQueries);
      const resultsMap = new Map();

      snapshots.forEach(result => {
        if (result.status !== 'fulfilled') {
          console.warn('Ricerca cognome non riuscita per una query:', result.reason);
          return;
        }

        result.value.forEach(docSnap => {
          const data = docSnap.data() || {};
          const surname = (data.surname || '').toString().trim().toLowerCase();
          if (!surname.includes(lower)) return;
          resultsMap.set(docSnap.id, {
            _docId: docSnap.id,
            ...data,
            uid: data.uid || docSnap.id,
          });
        });
      });

      return Array.from(resultsMap.values());
    },
    chunkFilterValues(values, size = FIRESTORE_IN_FILTER_CHUNK_SIZE) {
      const uniqueValues = Array.from(new Set((values || []).filter(Boolean)));
      const chunks = [];
      for (let index = 0; index < uniqueValues.length; index += size) {
        chunks.push(uniqueValues.slice(index, index + size));
      }
      return chunks;
    },
    async collectOrdersByFieldValues(field, values, resultsMap) {
      const chunks = this.chunkFilterValues(values);
      for (const valuesChunk of chunks) {
        try {
          const snapshot = await getDocs(
            query(collection(this.db, 'orders'), where(field, 'in', valuesChunk))
          );
          snapshot.forEach(docSnap => {
            const order = this.mapOrderDoc(docSnap);
            if (order?._id) resultsMap.set(order._id, order);
          });
        } catch (err) {
          console.warn(`Ricerca ordini per ${field} non riuscita:`, err);
        }
      }
    },
    async applyDirectOrderFilters(orders) {
      let filtered = Array.isArray(orders) ? [...orders] : [];
      const emailNeedle = this.normalizeEmail(this.filters.email);
      const range = this.buildDateRangeFilter();

      if (emailNeedle) {
        filtered = filtered.filter(order => {
          const candidates = [order?.userEmail, order?.customerEmail, order?.email]
            .map(value => this.normalizeEmail(value))
            .filter(Boolean);
          return candidates.some(email => email.includes(emailNeedle));
        });
      }
      if (this.filters.source) {
        filtered = filtered.filter(order => order._source === this.filters.source);
      }
      if (this.filters.status) {
        const status = this.filters.status.toLowerCase();
        filtered = filtered.filter(order => (order.status || '').toLowerCase() === status);
      }
      if (this.hasProductFilter()) {
        filtered = filtered.filter(order => this.orderMatchesProductFilter(order));
      }
      if (range) {
        filtered = filtered.filter(order => this.orderMatchesDateRange(order, range));
      }
      if (this.filters.hideWelfare) {
        filtered = filtered.filter(order => (order.paymentMethod || '').toLowerCase() !== 'welfare');
      }
      if (this.filters.studio) {
        filtered = await this.filterBatchByStudio(filtered);
      }

      return filtered.sort((orderA, orderB) => {
        const timeA = this.orderTimestamp(orderA?.orderDate);
        const timeB = this.orderTimestamp(orderB?.orderDate);
        return (Number.isFinite(timeB) ? timeB : 0) - (Number.isFinite(timeA) ? timeA : 0);
      });
    },
    async finalizeDirectOrderSearch(results) {
      this.captureNearbyPaidOrderCandidates(results);
      const filteredResults = await this.applyDirectOrderFilters(results);
      this.orders = filteredResults;
      this.cursor = null;
      this.hasMore = false;

      for (const order of filteredResults) {
        this.fetchPercorsiCount(order.orderId || order._id);
        this.reconcileCancelledOrderAssets(order).catch(err => {
          console.warn(`Pulizia percorso ordine cancellato ${order.orderId || order._id} fallita:`, err);
        });
        this.maybeAutoCreatePercorsi(order).catch(err => {
          console.warn(`Auto creazione percorsi fallita per ordine ${order.orderId || order._id}:`, err);
        });
      }
    },
    async collectOrdersBySurname(rawSurname) {
      const users = await this.runSurnameSearch(rawSurname);
      const emailValues = new Set();
      const uidValues = new Set();

      users.forEach(user => {
        [user?.email, user?.emailLower, user?.userEmail].forEach(value => {
          const rawEmail = (value || '').toString().trim();
          const normalizedEmail = this.normalizeEmail(rawEmail);
          if (rawEmail) emailValues.add(rawEmail);
          if (normalizedEmail) emailValues.add(normalizedEmail);
        });
        [user?.uid, user?._docId, user?.userId, user?.UserId]
          .map(value => (value || '').toString().trim())
          .filter(Boolean)
          .forEach(value => uidValues.add(value));
      });

      if (!emailValues.size && !uidValues.size) {
        return [];
      }

      const resultsMap = new Map();
      const emails = Array.from(emailValues);
      const uids = Array.from(uidValues);
      await Promise.all([
        this.collectOrdersByFieldValues('userEmail', emails, resultsMap),
        this.collectOrdersByFieldValues('customerEmail', emails, resultsMap),
        this.collectOrdersByFieldValues('email', emails, resultsMap),
        this.collectOrdersByFieldValues('userUid', uids, resultsMap),
        this.collectOrdersByFieldValues('userId', uids, resultsMap),
        this.collectOrdersByFieldValues('uid', uids, resultsMap),
      ]);
      return Array.from(resultsMap.values());
    },
    async loadOrdersBySurname(rawSurname) {
      const results = await this.collectOrdersBySurname(rawSurname);
      await this.finalizeDirectOrderSearch(results);
    },
    async collectOrdersByExactEmail(rawInput, normalizedEmail) {
      const trimmed = (rawInput || '').trim();
      const normalized = normalizedEmail || this.normalizeEmail(trimmed);
      const ordersRef = collection(this.db, 'orders');
      const attempts = [];
      const pushAttempt = (field, value) => {
        if (!field || !value) return;
        attempts.push({ field, value });
      };

      pushAttempt('userEmail', trimmed);
      pushAttempt('customerEmail', trimmed);
      pushAttempt('email', trimmed);
      if (normalized && normalized !== trimmed) {
        pushAttempt('userEmail', normalized);
        pushAttempt('customerEmail', normalized);
        pushAttempt('email', normalized);
      }

      const resultsMap = new Map();
      for (const attempt of attempts) {
        try {
          const snap = await getDocs(query(ordersRef, where(attempt.field, '==', attempt.value)));
          snap.forEach(docSnap => {
            const order = this.mapOrderDoc(docSnap);
            if (order && order._id) {
              resultsMap.set(order._id, order);
            }
          });
        } catch (err) {
          console.warn(`loadOrdersByExactEmail query failed (${attempt.field} == ${attempt.value}):`, err);
        }
      }

      return Array.from(resultsMap.values());
    },
    async loadOrdersByExactEmail(rawInput, normalizedEmail) {
      const results = await this.collectOrdersByExactEmail(rawInput, normalizedEmail);
      await this.finalizeDirectOrderSearch(results);
    },
    async loadMore(firstPage = false) {
      if (this.loading) return;
      this.loading = true;

      try {
        const rawEmailFilter = (this.filters.email || '').trim();
        const rawSurnameFilter = (this.filters.surname || '').trim();
        const emailNeedle = this.normalizeEmail(rawEmailFilter);
        const emailSearchMode = !!emailNeedle;
        if (rawSurnameFilter) {
          await this.loadOrdersBySurname(rawSurnameFilter);
          return;
        }
        if (emailSearchMode && this.looksLikeExactEmail(rawEmailFilter)) {
          await this.loadOrdersByExactEmail(rawEmailFilter, emailNeedle);
          return;
        }
        const existingIds = new Set(this.orders.map(o => o._id));
        const range = this.buildDateRangeFilter();

        let keepPaging = true;
        while (keepPaging) {
          let q = query(
            collection(this.db, 'orders'),
            orderBy('orderDate', 'desc'),
            limit(this.pageSize)
          );

          if (range?.startString) {
            q = query(q, where('orderDate', '>=', range.startString));
          }
          if (range?.endString) {
            q = query(q, where('orderDate', '<=', range.endString));
          }
          if (this.cursor && !firstPage) {
            q = query(q, startAfter(this.cursor));
          }

          const snap = await getDocs(q);
          if (snap.empty) {
            this.hasMore = false;
            break;
          }

          let batch = snap.docs.map(d => this.mapOrderDoc(d)).filter(Boolean);
          this.captureNearbyPaidOrderCandidates(batch);

          if (emailNeedle) {
            batch = batch.filter(o => this.normalizeEmail(o.userEmail).includes(emailNeedle));
          }
          if (this.filters.source) {
            batch = batch.filter(o => o._source === this.filters.source);
          }
          if (this.filters.status) {
            batch = batch.filter(o => (o.status || '').toLowerCase() === this.filters.status.toLowerCase());
          }
          if (this.hasProductFilter()) {
            batch = batch.filter(o => this.orderMatchesProductFilter(o));
          }
          if (range) {
            batch = batch.filter(o => this.orderMatchesDateRange(o, range));
          }
          if (this.filters.hideWelfare) {
            batch = batch.filter(o => (o.paymentMethod || '').toLowerCase() !== 'welfare');
          }
          if (this.filters.studio) {
            batch = await this.filterBatchByStudio(batch);
          }

          const uniqueBatch = batch.filter(o => {
            if (!o._id || existingIds.has(o._id)) return false;
            existingIds.add(o._id);
            return true;
          });

          this.cursor = snap.docs[snap.docs.length - 1];

          if (uniqueBatch.length) {
            if (firstPage) {
              this.orders = [...uniqueBatch];
            } else {
              this.orders = [...this.orders, ...uniqueBatch];
            }
            this.orders.sort((a, b) => this.orderTimestamp(b.orderDate) - this.orderTimestamp(a.orderDate));
            for (const o of uniqueBatch) {
              this.fetchPercorsiCount(o.orderId || o._id);
              this.reconcileCancelledOrderAssets(o).catch(err => {
                console.warn(`Pulizia percorso ordine cancellato ${o.orderId || o._id} fallita:`, err);
              });
              this.maybeAutoCreatePercorsi(o).catch(err => {
                console.warn(`Auto creazione percorsi fallita per ordine ${o.orderId || o._id}:`, err);
              });
            }
            firstPage = false;
          }

          if (snap.size < this.pageSize) {
            this.hasMore = false;
            keepPaging = false;
          } else {
            this.hasMore = true;
            firstPage = false;
          }
        }
      } catch (e) {
        console.error('Errore caricamento ordini:', e);
      } finally {
        this.loading = false;
      }
    },
    // ---- Azione manuale su riga: genera percorsi ----
    async processOrder(o) {
      if (this.isGiftCardOrder(o)) return;
      const id = o.orderId || o._id;
      if (!id) return;
      if (!this.isEligibleStatus(o)) {
        alert('Ordine non idoneo: serve wc-completed o wc-processing.');
        return;
      }
      try {
        this.$set ? this.$set(this.processing, id, true) : (this.processing[id] = true);
        if (!o.userUid) {
          const userDetails = this.deriveUserDetailsFromOrder(o);
          if (!userDetails.email) {
            throw new Error('Email utente mancante sull’ordine. Impossibile creare il profilo.');
          }
          if (!userDetails.name || !userDetails.surname) {
            throw new Error('Nome o cognome mancanti sull’ordine. Completa i dati prima di generare i percorsi.');
          }
          const ensureResult = await this.ensureUserForOrder(userDetails, { updateFormState: false });
          if (ensureResult?.uid) {
            const nextUid = ensureResult.uid;
            if (this.$set) this.$set(o, 'userUid', nextUid);
            else o.userUid = nextUid;
            const orderDocId = o._id || o.orderId;
            if (orderDocId) {
              try {
                await updateDoc(doc(this.db, 'orders', String(orderDocId)), {
                  userUid: nextUid,
                  updatedAt: new Date().toISOString(),
                });
              } catch (linkErr) {
                console.warn('Impossibile aggiornare l’ordine con lo userUid:', linkErr);
              }
            }
          }
        }
        await this.createPercorsiForOrder({ ...o });
        await this.fetchPercorsiCount(id); // aggiorna feedback

        const source = this.deriveSource(o, id);
        const alreadyTicketed = Boolean(o.orderConfirmationTicketAt);
        if (source === 'woocommerce' && !alreadyTicketed) {
          try {
            await this.createOrderConfirmationTicket({
              orderId: id,
              orderPayload: o,
              ensureResult: null,
              newUserCreated: false,
            });
          } catch (ticketErr) {
            console.warn('Ticket conferma ordine non inviato dopo processOrder:', ticketErr);
          }
        }
      } catch (e) {
        console.error('processOrder error:', e);
        alert(e?.message || 'Errore durante la generazione dei percorsi.');
      } finally {
        this.$set ? this.$set(this.processing, id, false) : (this.processing[id] = false);
      }
    },

    // ---- Trigger automatico percorsi (gateway pagato / Woo processing) ----
    async maybeAutoCreatePercorsi(order, options = {}) {
      if (!order) return false;
      if (this.isGiftCardOrder(order)) return false;
      const previousStatus = String(options.previousStatus || '').toLowerCase();
      const currentStatus = String(order.status || '').toLowerCase();
      const orderId = order.orderId || order._id;
      if (!orderId) return false;

      const creationState = String(order.percorsiCreationState || '').toLowerCase();
      if (
        order.percorsiCreatedAt ||
        creationState === 'created' ||
        creationState === 'creating' ||
        creationState === 'skipped'
      ) return false;

      const provider = (order.paymentProvider || order.paymentMethod || '').toLowerCase();
      const source = this.deriveSource(order, orderId);

      const activatedStatuses = new Set(['pagato', 'rateizzato']);
      const isAutoGatewayPaid =
        AUTO_GATEWAY_METHODS.includes(provider) &&
        activatedStatuses.has(currentStatus) &&
        !activatedStatuses.has(previousStatus);
      const isWooProcessing = source === 'woocommerce' && currentStatus === 'wc-processing';
      if (!isAutoGatewayPaid && !isWooProcessing) return false;

      if (this.processing[orderId]) return false;
      if (!Array.isArray(order.products) || !order.products.length) {
        throw new Error('Prodotti mancanti sull’ordine. Impossibile creare i percorsi.');
      }

      if (this.$set) this.$set(this.processing, orderId, true);
      else this.processing[orderId] = true;

      try {
        const already = await this.hasPercorsiForOrder(orderId);
        if (already) {
          await this.fetchPercorsiCount(orderId);
          return false;
        }

        if (!order.userUid) {
          const userDetails = this.deriveUserDetailsFromOrder(order);
          if (!userDetails.email) {
            throw new Error('Email utente mancante sull’ordine.');
          }
          if (!userDetails.name || !userDetails.surname) {
            throw new Error('Nome o cognome mancanti sull’ordine.');
          }
          const ensureResult = await this.ensureUserForOrder(userDetails, { updateFormState: false });
          if (ensureResult?.uid) {
            if (this.$set) this.$set(order, 'userUid', ensureResult.uid);
            else order.userUid = ensureResult.uid;
            try {
              await updateDoc(doc(this.db, 'orders', String(orderId)), {
                userUid: ensureResult.uid,
                updatedAt: new Date().toISOString(),
              });
            } catch (linkErr) {
              console.warn('Impossibile aggiornare l’ordine con lo userUid (auto percorsi):', linkErr);
            }
          }
        }

        await this.applyUserNewPurchaseState(order);

        await this.createPercorsiForOrder({ ...order });
        await this.fetchPercorsiCount(orderId);

        const created = await this.hasPercorsiForOrder(orderId);
        if (created) {
          try {
            await this.createOrderConfirmationTicket({
              orderId,
              orderPayload: order,
              ensureResult: null,
              newUserCreated: false,
            });
          } catch (ticketErr) {
            console.warn('Notifica post creazione percorsi non inviata:', ticketErr);
          }
        }
        return created;
      } finally {
        if (this.$set) this.$set(this.processing, orderId, false);
        else this.processing[orderId] = false;
      }
    },

    async applyManualStatus(order, nextStatus) {
      if (!order) return;
      if (this.isGiftCardOrder(order) && String(nextStatus || '').toLowerCase() === 'pagato') {
        return this.confirmGiftCardTransfer(order);
      }
      if (this.isManagedGiftCardOrder(order)) {
        this.errorMsg = 'Le modifiche e gli storni delle gift card richiedono la gestione dedicata del team.';
        return;
      }
      const docId = order._id || order.orderId;
      if (!docId) {
        alert('Impossibile individuare il documento ordine.');
        return;
      }

      const label = this.formatStatus(nextStatus);
      if (!window.confirm(`Confermi il cambio stato in “${label}”?`)) return;

      const nowIso = new Date().toISOString();

      if (nextStatus === 'cancellato' && (order.paymentProvider || '').toLowerCase() === 'alma') {
        const hasPaymentId = !!(order.almaPaymentId || '').toString().trim();
        if (hasPaymentId) {
          const success = await this.cancelAlmaPayment(order);
          if (!success) alert('Annullamento Alma non riuscito: procedo con annullamento manuale.');
        } else {
          alert('Nessun pagamento Alma collegato all’ordine: procedo con annullamento manuale.');
        }
      }

      if (nextStatus === 'cancellato' && (order.paymentProvider || '').toLowerCase() === 'klarna') {
        const hasKlarnaSession = !!(
          order.klarnaOrderId ||
          order.klarnaHppSessionId ||
          order.klarnaKpSessionId
        );
        if (hasKlarnaSession) {
          const success = await this.cancelKlarnaPayment(order);
          if (!success) alert('Annullamento Klarna non riuscito: procedo con annullamento manuale.');
        } else {
          alert('Nessuna sessione Klarna collegata all’ordine: procedo con annullamento manuale.');
        }
      }

      let paymentStatus = order.paymentStatus || '';
      if (nextStatus === 'rimborsato') paymentStatus = 'refunded';
      if (nextStatus === 'cancellato') paymentStatus = 'void';

      const updates = {
        status: nextStatus,
        paymentStatus,
        updatedAt: nowIso,
        manualStatus: true,
        manualStatusAt: nowIso,
      };

      try {
        const orderRef = doc(this.db, 'orders', String(docId));
        const savedUpdates = await runTransaction(this.db, async (tx) => {
          const snapshot = await tx.get(orderRef);
          if (!snapshot.exists()) throw new Error('Ordine non trovato.');

          const freshOrder = snapshot.data() || {};
          const nextUpdates = { ...updates };
          if (
            (nextStatus === 'cancellato' || nextStatus === 'rimborsato')
            && Array.isArray(freshOrder.manualInstallments)
          ) {
            nextUpdates.manualInstallments = this.cancelUnpaidManualInstallments(
              freshOrder.manualInstallments
            );
          }
          tx.update(orderRef, nextUpdates);
          return nextUpdates;
        });
        Object.assign(order, savedUpdates);

        if (nextStatus === 'cancellato' || nextStatus === 'rimborsato') {
          await this.cleanupGeneratedOrderAssets(order);
        }
      } catch (err) {
        console.error('applyManualStatus error:', err);
        alert('Errore durante l’aggiornamento dello stato.');
      }
    },

    async uploadPaymentProof(order, file) {
      if (!order || !file) return null;
      const docId = this.docKey(order);
      if (!docId) throw new Error('ID ordine non valido per il caricamento del documento.');
      const rawNameExt = (file.name || '').split('.').pop() || '';
      const typeExt = (file.type || '').includes('/') ? file.type.split('/')[1] : '';
      const normalizedExt = rawNameExt || typeExt || 'file';
      const safeExt = normalizedExt.toLowerCase().replace(/[^a-z0-9]/g, '') || 'file';
      const path = `orders/${docId}/payment-proof-${Date.now()}.${safeExt}`;
      const fileRef = storageRef(storage, path);
      const imageExts = new Set(['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'heic', 'heif']);
      let fallbackContentType = 'application/octet-stream';
      if (safeExt === 'pdf') fallbackContentType = 'application/pdf';
      else if (imageExts.has(safeExt)) {
        const mapped = safeExt === 'jpg' ? 'jpeg' : safeExt;
        fallbackContentType = `image/${mapped}`;
      }
      await uploadBytes(fileRef, file, {
        contentType: file.type || fallbackContentType,
      });
      const url = await getDownloadURL(fileRef);
      const nowIso = new Date().toISOString();
      return {
        url,
        fileName: file.name,
        fileType: file.type || null,
        storagePath: path,
        uploadedAt: nowIso,
        uploadedBy: auth?.currentUser?.uid || null,
      };
    },

    async submitStatusChange(order) {
      if (!order) return;
      if (this.isStatusSaving(order)) return;
      const docId = this.docKey(order);
      if (!docId) {
        this.setStatusError(order, 'ID ordine non valido.');
        return;
      }
      const requestedStatus = String(this.statusForm(order)?.nextStatus || '').trim().toLowerCase();
      if (this.isGiftCardOrder(order) && requestedStatus === 'pagato') {
        return this.confirmGiftCardTransfer(order);
      }
      if (this.isManagedGiftCardOrder(order)) {
        this.setStatusError(order, 'Le modifiche e gli storni delle gift card richiedono la gestione dedicata del team.');
        return;
      }
      if (this.isStatusChangeLocked(order)) {
        this.setStatusError(order, 'Gli ordini con pagamento Alma, PayPal o Klarna gestiscono automaticamente questo stato.');
        return;
      }
      const form = this.statusForm(order);
      const targetStatus = (form?.nextStatus || '').trim().toLowerCase();
      if (!targetStatus) {
        this.setStatusError(order, 'Seleziona un nuovo stato.');
        return;
      }
      if (targetStatus === String(order.status || '').toLowerCase()) {
        this.setStatusError(order, 'L’ordine è già in questo stato.');
        return;
      }
      const proofRequired = this.requiresPaymentProof(order, targetStatus);
      if (proofRequired && !form.file) {
        this.setStatusError(order, 'Carica il documento contabile per confermare il pagamento.');
        return;
      }

      if (this.$set) this.$set(this.statusSaving, docId, true);
      else this.statusSaving[docId] = true;
      this.clearStatusError(docId);

      try {
        const nowIso = new Date().toISOString();
        const updates = {
          status: targetStatus,
          updatedAt: nowIso,
          manualStatus: true,
          manualStatusAt: nowIso,
        };

        if (targetStatus === 'pagato') {
          updates.paymentStatus = 'paid';
        } else if (targetStatus === 'in attesa di pagamento') {
          updates.paymentStatus = 'pending';
        } else if (targetStatus === 'rimborsato') {
          updates.paymentStatus = 'refunded';
        } else if (targetStatus === 'cancellato') {
          updates.paymentStatus = 'void';
        }

        let proofPayload = null;
        if (form.file) {
          proofPayload = await this.uploadPaymentProof(order, form.file);
          updates.paymentProof = proofPayload;
        }

        await updateDoc(doc(this.db, 'orders', String(docId)), updates);
        Object.assign(order, updates);
        if (proofPayload) {
          order.paymentProof = proofPayload;
        }

        if (targetStatus === 'pagato') {
          await this.applyUserNewPurchaseState({ ...order, status: 'pagato' });
          await this.createPercorsiForOrder({ ...order });
          await this.fetchPercorsiCount(docId);
          try {
            await this.createOrderConfirmationTicket({
              orderId: docId,
              orderPayload: order,
              ensureResult: null,
              newUserCreated: false,
            });
          } catch (ticketErr) {
            console.warn('createOrderConfirmationTicket dopo cambio stato fallita:', ticketErr);
          }
        } else if (targetStatus === 'cancellato' || targetStatus === 'rimborsato') {
          await this.cleanupGeneratedOrderAssets(order);
        }

        this.successMsg = 'Stato ordine aggiornato.';
        this.resetStatusForm(order);
      } catch (err) {
        console.error('submitStatusChange error:', err);
        this.setStatusError(order, err?.message || 'Errore durante l’aggiornamento dello stato.');
      } finally {
        if (this.$set) this.$set(this.statusSaving, docId, false);
        else this.statusSaving[docId] = false;
      }
    },

    async removePercorsiForOrder(orderOrId) {
      try {
        const orderReferences = this.orderReferenceCandidates(orderOrId);
        if (!orderReferences.length) return 0;
        const percorsiCol = collection(this.db, 'percorsi');
        const snapshots = await Promise.all(
          orderReferences.map(orderRef => getDocs(query(percorsiCol, where('orderRef', '==', orderRef))))
        );
        const toDelete = new Map();
        snapshots.forEach(snapshot => {
          snapshot.forEach(documentSnapshot => {
            toDelete.set(documentSnapshot.ref.path, documentSnapshot);
          });
        });

        await Promise.all(
          [...toDelete.values()].map(documentSnapshot => deleteDoc(documentSnapshot.ref))
        );
        return toDelete.size;
      } catch (err) {
        console.error('removePercorsiForOrder error:', err);
        alert('Programmi non rimossi a causa di un errore. Controlla manualmente.');
        return null;
      }
    },

    openRefundModal(order) {
      if (this.isManagedGiftCardOrder(order)) {
        this.errorMsg = 'Il rimborso di una gift card richiede la gestione dedicata del team e l’eventuale storno del credito.';
        return;
      }
      if (!order) return;
      const total = Number(order.totalPrice) || 0;
      this.refundForm.order = order;
      this.refundForm.amount = Number.isFinite(total) ? Math.max(total, 0) : 0;
      this.refundForm.newProductId = '';
      this.refundForm.originalTotal = total;
      this.refundError = '';
      this.showRefund = true;
    },
    closeRefundModal() {
      this.showRefund = false;
      this.refundError = '';
      this.refundProcessing = false;
      this.refundForm = {
        order: null,
        amount: '',
        newProductId: '',
        originalTotal: 0,
      };
    },

    /* ===== Modifica ordine (prodotto/prezzo) ===== */
    resetEditForm() {
      this.editForm = {
        productId: '',
        quantity: 1,
        totalPrice: 0,
      };
      this.editError = '';
      this.editSaving = false;
      this.editOrderTarget = null;
    },
    openEditOrderModal(order) {
      if (this.isManagedGiftCardOrder(order)) {
        this.errorMsg = 'La modifica di una gift card richiede la gestione dedicata del team.';
        return;
      }
      if (!order) return;
      this.resetEditForm();
      this.editOrderTarget = order;

      const firstLine = Array.isArray(order.products) && order.products.length ? order.products[0] : null;
      const matchedProduct = this.matchProductFromLine(firstLine);
      if (matchedProduct) {
        this.editForm.productId = matchedProduct.id;
      }
      if (!this.editForm.productId && firstLine?.id) {
        this.editForm.productId = firstLine.id;
      }

      this.editForm.quantity = Math.max(1, Number(firstLine?.quantity) || 1);
      const fallbackUnit = Number(firstLine?.price) || Number(matchedProduct?.price) || 0;
      const fallbackTotal = Number(order.totalPrice) || (fallbackUnit * this.editForm.quantity);
      this.editForm.totalPrice = Number.isFinite(fallbackTotal) ? Math.max(fallbackTotal, 0) : 0;

      this.showEditOrder = true;
    },
    closeEditOrderModal() {
      this.showEditOrder = false;
      this.resetEditForm();
    },
    onEditProductChange() {
      const prod = this.editSelectedProduct;
      if (!prod) return;
      this.updateEditTotalFromSelection();
    },
    onEditQuantityChange() {
      if (!Number.isFinite(this.editForm.quantity) || this.editForm.quantity < 1) {
        this.editForm.quantity = 1;
      }
      this.updateEditTotalFromSelection();
    },
    updateEditTotalFromSelection() {
      const prod = this.editSelectedProduct;
      if (!prod) return;
      const qty = Math.max(1, Number(this.editForm.quantity) || 1);
      const unitPrice = Number(prod.price) || 0;
      this.editForm.totalPrice = Math.max(0, unitPrice * qty);
    },
    matchProductFromLine(line) {
      if (!line) return null;
      if (line.id) {
        const byId = this.products.find(p => p.id === line.id);
        if (byId) return byId;
      }
      const sku = (line.sku || '').toString().trim().toLowerCase();
      if (sku) {
        const bySku = this.products.find(
          p => (p.sku || '').toString().trim().toLowerCase() === sku
        );
        if (bySku) return bySku;
      }
      const lineWoo = this.normalizeWooValue(line.name || line.woo);
      if (lineWoo) {
        const byWoo = this.products.find(
          p => this.normalizeWooValue(p.woo) === lineWoo
        );
        if (byWoo) return byWoo;
      }
      return null;
    },
    async confirmEditOrder() {
      if (this.editSaving) return;
      const order = this.editOrderTarget;
      if (this.isManagedGiftCardOrder(order)) {
        this.editError = 'La modifica di una gift card richiede la gestione dedicata del team.';
        return;
      }
      if (!order) {
        this.editError = 'Ordine non valido.';
        return;
      }

      const orderId = order.orderId || order._id;
      if (!orderId) {
        this.editError = 'ID ordine mancante.';
        return;
      }

      const product = this.editSelectedProduct;
      if (!product) {
        this.editError = 'Seleziona un prodotto dal catalogo.';
        return;
      }

      const quantity = Math.max(1, Number(this.editForm.quantity) || 1);
      const totalPrice = Number(this.editForm.totalPrice);
      if (!Number.isFinite(totalPrice) || totalPrice < 0) {
        this.editError = 'Totale ordine non valido.';
        return;
      }

      const nowIso = new Date().toISOString();
      const updatedLine = {
        id: product.id,
        name: product.name,
        sku: product.sku || null,
        price: Number(product.price) || 0,
        quantity,
      };

      const updates = {
        products: [updatedLine],
        totalPrice,
        updatedAt: nowIso,
        manualStatus: true,
        manualStatusAt: nowIso,
      };

      try {
        this.editSaving = true;
        this.editError = '';

        await updateDoc(doc(this.db, 'orders', String(orderId)), updates);

        Object.assign(order, updates);
        order.products = updates.products;
        order.totalPrice = updates.totalPrice;
        order.updatedAt = nowIso;

        await this.regeneratePercorsiAfterRefund(order, product.id, quantity);
        await this.fetchPercorsiCount(orderId);

        this.closeEditOrderModal();
      } catch (err) {
        console.error('confirmEditOrder error:', err);
        this.editError = 'Errore durante il salvataggio delle modifiche.';
      } finally {
        this.editSaving = false;
      }
    },

    async confirmRefund() {
      if (this.refundProcessing) return;
      const order = this.refundForm.order;
      if (this.isManagedGiftCardOrder(order)) {
        this.refundError = 'Il rimborso di una gift card richiede la gestione dedicata del team e l’eventuale storno del credito.';
        return;
      }
      if (!order) {
        this.refundError = 'Ordine non valido.';
        return;
      }

      const orderId = this.docKey(order);
      if (!orderId) {
        this.refundError = 'ID ordine mancante.';
        return;
      }

      const amount = Number(this.refundForm.amount);
      if (!Number.isFinite(amount) || amount < 0) {
        this.refundError = 'Importo rimborso non valido.';
        return;
      }

      let selectedProduct = null;
      if (this.refundForm.newProductId) {
        selectedProduct = this.products.find(p => p.id === this.refundForm.newProductId);
        if (!selectedProduct) {
          this.refundError = 'Prodotto selezionato non disponibile.';
          return;
        }
      }

      const epsilon = 0.01;
      const nowIso = new Date().toISOString();

      try {
        this.refundProcessing = true;
        this.refundError = '';

        const orderRef = doc(this.db, 'orders', String(orderId));
        const updates = await runTransaction(this.db, async (tx) => {
          const snapshot = await tx.get(orderRef);
          if (!snapshot.exists()) throw new Error('Ordine non trovato.');

          const freshOrder = snapshot.data() || {};
          const freshTotal = Number(freshOrder.totalPrice) || 0;
          const isFullRefund = freshTotal <= 0
            ? amount > 0
            : amount >= (freshTotal - epsilon);
          const nextUpdates = {
            status: isFullRefund ? 'rimborsato' : 'rimborsato parzialmente',
            paymentStatus: isFullRefund ? 'refunded' : 'partially_refunded',
            refundAmount: amount,
            refundAt: nowIso,
            updatedAt: nowIso,
            manualStatus: true,
            manualStatusAt: nowIso,
          };

          if (selectedProduct) {
            const price = Number(selectedProduct.price) || 0;
            nextUpdates.products = [
              {
                id: selectedProduct.id,
                name: selectedProduct.name,
                sku: selectedProduct.sku || null,
                price,
                quantity: 1,
              },
            ];
            if (Number.isFinite(price) && price > 0) {
              nextUpdates.totalPrice = price;
            }
            nextUpdates.replacementProductId = selectedProduct.id;
          } else {
            nextUpdates.totalPrice = Math.max(freshTotal - amount, 0);
          }

          if (isFullRefund && Array.isArray(freshOrder.manualInstallments)) {
            nextUpdates.manualInstallments = this.cancelUnpaidManualInstallments(
              freshOrder.manualInstallments
            );
          }

          tx.update(orderRef, nextUpdates);
          return nextUpdates;
        });

        Object.assign(order, updates);
        if (updates.products) order.products = updates.products;
        if (updates.totalPrice !== undefined) order.totalPrice = updates.totalPrice;

        await this.regeneratePercorsiAfterRefund(order, selectedProduct ? selectedProduct.id : null);
        await this.fetchPercorsiCount(orderId);
        await this.removePtSessionsForOrder(orderId);

        this.closeRefundModal();
      } catch (err) {
        console.error('confirmRefund error:', err);
        this.refundError = 'Errore durante il salvataggio del rimborso.';
      } finally {
        this.refundProcessing = false;
      }
    },

    async regeneratePercorsiAfterRefund(order, newProductId, quantityMultiplier = 1) {
      if (this.isGiftCardOrder(order)) return;
      try {
        const orderId = order.orderId || order._id;
        const orderDocId = order._id || order.orderId;
        if (!orderId) return;
        const orderRefStr = String(orderId);
        const percorsiCol = collection(this.db, 'percorsi');

        const docsToDelete = [];
        const snapStr = await getDocs(query(percorsiCol, where('orderRef', '==', orderRefStr)));
        snapStr.forEach(d => docsToDelete.push(d));

        if (!snapStr.size) {
          const asNum = Number(orderRefStr);
          if (Number.isFinite(asNum)) {
            const snapNum = await getDocs(query(percorsiCol, where('orderRef', '==', asNum)));
            snapNum.forEach(d => docsToDelete.push(d));
          }
        }

        await Promise.all(docsToDelete.map(d => deleteDoc(doc(this.db, 'percorsi', d.id))));
        await this.updatePercorsiCreationState(orderDocId, { state: null, clearCreated: true });

        if (!newProductId) return;

        const product = this.products.find(p => p.id === newProductId);
        if (!product) return;

        const uid = await this.resolveUserUidByEmail(order.userEmail);
        const orderSource = this.deriveSource(order, orderId);
        const qtyMultiplier = Math.max(1, Number(quantityMultiplier) || 1);
        await createPercorsiForProduct({
          uid: uid || null,
          userEmail: order.userEmail,
          product: {
            id: product.id,
            name: product.name,
            sku: product.sku || null,
            duration_months: Number(product.duration_months) || 1,
            cons_nutrizionali: Number(product.cons_nutrizionali) || 0,
            cons_tecniche: Number(product.cons_tecniche) || 0,
          },
          coachingQty: Number(product.coaching_quantity) || 0,
          quantityMultiplier: qtyMultiplier,
          orderRef: orderRefStr,
          orderSource,
          nowIso: new Date().toISOString(),
          titleBase: product.name || 'Prodotto',
        });
      } catch (err) {
        console.error('regeneratePercorsiAfterRefund error:', err);
        alert('Rimborso salvato ma errore nella rigenerazione dei programmi.');
      }
    },
    async handleOrderRefunded(order) {
      if (this.isGiftCardOrder(order)) return;
      try {
        await this.regeneratePercorsiAfterRefund(order, null);
        const orderId = order.orderId || order._id;
        if (orderId) {
          await this.fetchPercorsiCount(orderId);
          await this.removePtSessionsForOrder(orderId);
        }
      } catch (err) {
        console.warn('handleOrderRefunded error:', err);
      }
    },

    async loadProducts() {
      const ps = await getDocs(query(collection(this.db, 'products'), orderBy('name')));
      this.products = ps.docs.map(d => ({ id: d.id, ...d.data() }));
    },

    // #### UI helpers ####
    toggleDetails(orderOrId) {
      let order = null;
      let id = null;
      if (orderOrId && typeof orderOrId === 'object') {
        order = orderOrId;
        id = order._id || order.orderId;
      } else {
        id = orderOrId;
        order = this.orders.find(o => (o._id || o.orderId) === id) || null;
      }
      if (!id) return;

      const next = !this.expanded[id];
      if (this.$set) this.$set(this.expanded, id, next);
      else this.expanded = { ...this.expanded, [id]: next };

      if (next && order && order.paymentProvider === 'alma') {
        this.syncAlmaPayment(order, { silent: true }).catch(err => {
          console.warn('syncAlmaPayment error:', err);
        });
      } else if (next && order && order.paymentProvider === 'klarna') {
        this.syncKlarnaPayment(order, { silent: true }).catch(err => {
          console.warn('syncKlarnaPayment error:', err);
        });
      }
    },
    resetFilters() {
      const { from, to } = defaultDateRange();
      this.filters = {
        email: '',
        surname: '',
        source: '',
        status: '',
        product: [],
        studio: '',
        fromDate: from,
        toDate: to,
        hideWelfare: true,
      };
      this.productFilterOpen = false;
      this.reload();
    },
    buildDateRangeFilter() {
      if ((this.filters.email || '').trim() || (this.filters.surname || '').trim()) return null;
      const from = (this.filters.fromDate || '').trim();
      const to = (this.filters.toDate || '').trim();
      const build = (dateStr, endOfDay = false) => {
        const parts = dateStr.split('-');
        if (parts.length !== 3) return null;
        const [y, m, d] = parts;
        return `${y}-${pad2(m)}-${pad2(d)} ${endOfDay ? '23:59:59' : '00:00:00'}`;
      };
      const startString = from ? build(from, false) : null;
      const endString = to ? build(to, true) : null;
      if (!startString && !endString) return null;
      const toMillis = (val) => {
        if (!val) return NaN;
        const parsed = new Date(String(val).replace(' ', 'T'));
        return parsed.getTime();
      };
      return {
        startString,
        endString,
        startMs: toMillis(startString),
        endMs: toMillis(endString),
      };
    },
    formatDate(s) {
      if (!s) return '—';
      const d = new Date(String(s).replace(' ', 'T'));
      if (isNaN(d)) return s;
      return d.toLocaleString('it-IT');
    },
    formatPrice(v) {
      if (v === null || v === undefined || v === '') return '—';
      const n = Number(v);
      if (!Number.isFinite(n)) return '—';
      return n.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
    },
    formatProductList(products) {
      if (!Array.isArray(products) || !products.length) return '—';
      return products
        .map(p => {
          const name = (p?.name || p?.id || 'Prodotto').toString();
          const qty = Number(p?.quantity) || 1;
          return qty > 1 ? `${name} ×${qty}` : name;
        })
        .join(', ');
    },
    formatProductTooltip(products) {
      if (!Array.isArray(products) || !products.length) return '';
      return products
        .map(p => {
          const qty = Number(p?.quantity) || 1;
          const name = (p?.name || p?.id || 'Prodotto').toString();
          const price = Number(p?.price);
          const priceLabel = Number.isFinite(price) ? ` · €${price.toFixed(2)}` : '';
          return `${qty}× ${name}${priceLabel}`;
        })
        .join('\n');
    },
    async collectOrdersForCsvExport() {
      const rawEmailFilter = (this.filters.email || '').trim();
      const rawSurnameFilter = (this.filters.surname || '').trim();
      const emailNeedle = this.normalizeEmail(rawEmailFilter);

      if (rawSurnameFilter) {
        const results = await this.collectOrdersBySurname(rawSurnameFilter);
        this.csvExportScanned = results.length;
        const filtered = await this.applyDirectOrderFilters(results);
        this.csvExportMatched = filtered.length;
        return filtered;
      }

      if (emailNeedle && this.looksLikeExactEmail(rawEmailFilter)) {
        const results = await this.collectOrdersByExactEmail(rawEmailFilter, emailNeedle);
        this.csvExportScanned = results.length;
        const filtered = await this.applyDirectOrderFilters(results);
        this.csvExportMatched = filtered.length;
        return filtered;
      }

      const resultsMap = new Map();
      const range = this.buildDateRangeFilter();
      let exportCursor = null;
      let keepPaging = true;

      while (keepPaging) {
        let exportQuery = query(
          collection(this.db, 'orders'),
          orderBy('orderDate', 'desc'),
          limit(CSV_EXPORT_PAGE_SIZE)
        );

        if (range?.startString) {
          exportQuery = query(exportQuery, where('orderDate', '>=', range.startString));
        }
        if (range?.endString) {
          exportQuery = query(exportQuery, where('orderDate', '<=', range.endString));
        }
        if (exportCursor) {
          exportQuery = query(exportQuery, startAfter(exportCursor));
        }

        const snapshot = await getDocs(exportQuery);
        if (snapshot.empty) break;

        const rawBatch = snapshot.docs.map(documentSnapshot => this.mapOrderDoc(documentSnapshot)).filter(Boolean);
        this.csvExportScanned += rawBatch.length;
        const filteredBatch = await this.applyDirectOrderFilters(rawBatch);
        filteredBatch.forEach(order => {
          const key = this.getOrderIdentityKey(order);
          if (key) resultsMap.set(key, order);
        });
        this.csvExportMatched = resultsMap.size;

        exportCursor = snapshot.docs[snapshot.docs.length - 1];
        keepPaging = snapshot.size === CSV_EXPORT_PAGE_SIZE;
      }

      return Array.from(resultsMap.values()).sort((orderA, orderB) => {
        const timeA = this.orderTimestamp(orderA?.orderDate);
        const timeB = this.orderTimestamp(orderB?.orderDate);
        return (Number.isFinite(timeB) ? timeB : 0) - (Number.isFinite(timeA) ? timeA : 0);
      });
    },
    async exportCsv() {
      if (this.csvExporting) return;
      this.csvExporting = true;
      this.csvExportScanned = 0;
      this.csvExportMatched = 0;
      try {
        const orders = await this.collectOrdersForCsvExport();
        const rows = this.buildExportRows(orders);
        if (!rows.length) {
          alert('Nessun ordine da esportare con i filtri correnti.');
          return;
        }
        const headers = [
          'orderId',
          'orderNumber',
          'orderDate',
          'importedAt',
          'status',
          'paymentStatus',
          'paymentMethod',
          'paymentProvider',
          'source',
          'studio',
          'customerEmail',
          'customerFirstName',
          'customerLastName',
          'customerPhone',
          'totalAmount',
          'discount',
          'note',
          'productId',
          'productSku',
          'productName',
          'productQuantity',
          'productPrice',
          'productTotal',
        ];
        const separator = ';';
        const csvLines = [
          headers.join(separator),
          ...rows.map(row => headers.map(key => this.escapeCsvValue(row[key])).join(separator)),
        ];
        this.downloadCsv(csvLines.join('\n'), this.csvFilename());
      } catch (err) {
        console.error('exportCsv error:', err);
        alert('Errore durante l\'esportazione CSV.');
      } finally {
        this.csvExporting = false;
      }
    },
    csvFilename() {
      const start = this.filters.fromDate || 'tutti';
      const end = this.filters.toDate || 'tutti';
      return `ordini_${start}_-${end}.csv`;
    },
    downloadCsv(content, filename) {
      const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    escapeCsvValue(value) {
      if (value === null || value === undefined) return '';
      const raw = value instanceof Date ? value.toISOString() : String(value);
      const needsQuotes = /[";\n,]/.test(raw);
      const sanitized = raw.replace(/"/g, '""');
      return needsQuotes ? `"${sanitized}"` : sanitized;
    },
    buildExportRows(orders = []) {
      const rows = [];
      for (const order of orders || []) {
        const base = this.buildOrderExportBase(order);
        const products = Array.isArray(order?.products) ? order.products : [];
        if (products.length) {
          products.forEach((line) => {
            rows.push({
              ...base,
              ...this.buildLineExport(line),
            });
          });
        } else {
          rows.push({
            ...base,
            productId: '',
            productSku: '',
            productName: '',
            productQuantity: '',
            productPrice: '',
            productTotal: '',
          });
        }
      }
      return rows;
    },
    buildOrderExportBase(order = {}) {
      const customer = this.deriveUserDetailsFromOrder(order);
      return {
        orderId: order._id || order.orderId || order.id || '',
        orderNumber: order.orderNumber || order.number || order.reference || order.code || '',
        orderDate: order.orderDate || '',
        importedAt: order.importedAt || order.updatedAt || '',
        status: order.status || '',
        paymentStatus: order.paymentStatus || '',
        paymentMethod: order.paymentMethod || '',
        paymentProvider: order.paymentProvider || '',
        source: order._source || order.source || '',
        studio: customer.studio || '',
        customerEmail: customer.email || '',
        customerFirstName: customer.name || '',
        customerLastName: customer.surname || '',
        customerPhone: customer.phone || '',
        totalAmount: order.totalPrice ?? '',
        discount: order.discount ?? '',
        note: order.notes || '',
      };
    },
    buildLineExport(line = {}) {
      const quantity = this.resolveLineQuantity(line);
      const unitPrice = this.resolveLineUnitPrice(line);
      const total = this.resolveLineTotal(line, quantity, unitPrice);
      return {
        productId: line.productId || line.product_id || line.id || '',
        productSku: line.sku || line.SKU || '',
        productName: line.name || line.product_name || '',
        productQuantity: quantity,
        productPrice: unitPrice,
        productTotal: total,
      };
    },
    resolveLineQuantity(line = {}) {
      const qty = Number(line.quantity ?? line.qty ?? line.count ?? 1);
      return Number.isFinite(qty) ? qty : 1;
    },
    resolveLineUnitPrice(line = {}) {
      const price = Number(line.price ?? line.unitPrice ?? line.unit_price ?? line.amount ?? 0);
      return Number.isFinite(price) ? price : 0;
    },
    resolveLineTotal(line = {}, quantity = 1, unitPrice = 0) {
      const explicit = Number(line.total ?? line.line_total ?? line.total_price ?? NaN);
      if (Number.isFinite(explicit)) return explicit;
      return Number(unitPrice) * Number(quantity || 0);
    },
    receiptFileName(order) {
      const rawId = order?.orderId || order?._id || 'ordine';
      const safeId = String(rawId)
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9-_]+/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_+|_+$/g, '') || 'ordine';
      const date = order?.orderDate ? new Date(String(order.orderDate).replace(' ', 'T')) : new Date();
      const dateSegment = Number.isFinite(date?.getTime())
        ? date.toISOString().slice(0, 10)
        : new Date().toISOString().slice(0, 10);
      return `ricevuta_${safeId}_${dateSegment}.pdf`;
    },
    async downloadReceipt(order) {
      if (!order || this.receiptExporting) return;
      this.receiptExporting = true;
      this.receiptOrder = order;
      try {
        await this.$nextTick();
        const element = this.$refs.receiptRef;
        if (!element) throw new Error('Template ricevuta non disponibile.');
        await exportElementAsPdf(element, {
          fileName: this.receiptFileName(order),
          pdfOptions: { margin: [10, 10, 16, 10] },
        });
      } catch (err) {
        console.error('downloadReceipt error:', err);
        alert('Impossibile generare la ricevuta.');
      } finally {
        this.receiptExporting = false;
        this.receiptOrder = null;
      }
    },
    emailTooltipName(order) {
      if (!order) return '';
      const details = this.deriveUserDetailsFromOrder(order);
      const fullName = [details?.name, details?.surname].filter(Boolean).join(' ').trim();
      return fullName || '';
    },
    orderTimestamp(value) {
      if (!value) return NaN;
      if (typeof value.toDate === 'function') {
        try {
          const ts = value.toDate();
          return ts instanceof Date ? ts.getTime() : NaN;
        } catch {
          return NaN;
        }
      }
      const parsed = new Date(String(value).replace(' ', 'T'));
      return parsed.getTime();
    },
    orderMatchesDateRange(order, range) {
      if (!range) return true;
      const ms = this.orderTimestamp(order?.orderDate);
      if (!Number.isFinite(ms)) return true;
      if (Number.isFinite(range.startMs) && ms < range.startMs) return false;
      if (Number.isFinite(range.endMs) && ms > range.endMs) return false;
      return true;
    },
    msFromValue(value) {
      if (!value) return NaN;
      if (typeof value.toDate === 'function') {
        try {
          const d = value.toDate();
          return d instanceof Date ? d.getTime() : NaN;
        } catch {
          return NaN;
        }
      }
      const parsed = new Date(String(value).replace(' ', 'T')).getTime();
      return Number.isFinite(parsed) ? parsed : NaN;
    },
    hasManualInstallments(order) {
      return Array.isArray(order?.manualInstallments) && order.manualInstallments.length > 0;
    },
    manualInstallmentTotalAmount(plan = []) {
      if (!Array.isArray(plan)) return 0;
      return plan.reduce((sum, inst) => sum + (Number(inst?.amount) || 0), 0);
    },
    isInstallmentPaid(inst) {
      return isManualInstallmentPaid(inst);
    },
    normalizeMethod(value) {
      return normalizeManualInstallmentMethod(value);
    },
    manualInstallmentStatus(inst, order = {}) {
      return deriveManualInstallmentStatus(inst, Date.now(), order);
    },
    isManualInstallmentExpired(inst, order = {}) {
      return isManualInstallmentOperationallyExpired(inst, Date.now(), order);
    },
    manualInstallmentDisplayStatus(inst, order = {}) {
      return this.isManualInstallmentExpired(inst, order)
        ? 'scaduta'
        : this.manualInstallmentStatus(inst, order);
    },
    manualInstallmentProof(inst, order = {}) {
      return manualInstallmentPaymentProof(inst, order);
    },
    isAlmaInstallment(inst) {
      return this.normalizeMethod(inst?.method) === 'alma';
    },
    canCreateAlmaInstallmentLink(order, inst) {
      if (!order || !inst) return false;
      if (isManualInstallmentsOrderTerminal(order)) return false;
      if (!this.isAlmaInstallment(inst)) return false;
      if (this.isInstallmentPaid(inst)) return false;
      if (inst.almaPaymentUrl || inst.almaPaymentId) return false;
      const amount = Number(inst.amount);
      if (!Number.isFinite(amount) || amount <= 0) return false;
      const almaCount = Number(inst.almaInstallments);
      return Number.isFinite(almaCount) && almaCount > 0;
    },
    isAlmaPaymentPaidState(state, processingStatus) {
      const normalized = String(state || '').toLowerCase();
      const processing = String(processingStatus || '').toLowerCase();
      return normalized === 'paid' || ['captured', 'captured_manual'].includes(processing);
    },
    shouldShowManualInstallmentProof(inst, order = {}) {
      if (!inst) return false;
      const proof = this.manualInstallmentProof(inst, order);
      return isManualPaymentProofMethod(inst.method) || !!proof?.url;
    },
    manualInstallmentProofInputId(order, index) {
      const base = this.docKey(order) || order?.orderId || 'order';
      const safeBase = String(base).replace(/[^a-z0-9_-]+/gi, '_');
      return `manual-proof-${safeBase}-${index}`;
    },
    triggerManualInstallmentProofPicker(order, index) {
      if (typeof document === 'undefined') return;
      const id = this.manualInstallmentProofInputId(order, index);
      const input = document.getElementById(id);
      if (input) input.click();
    },
    async onManualInstallmentProofSelected(order, index, event) {
      const input = event?.target;
      const file = input?.files?.[0] || null;
      if (!file) return;
      if (!this.isValidProofFile(file)) {
        if (input) input.value = '';
        alert('Carica un PDF o un’immagine valida.');
        return;
      }
      try {
        await this.applyManualInstallmentProof(order, index, file);
      } catch (err) {
        console.error('applyManualInstallmentProof error:', err);
        alert('Errore durante il caricamento del documento.');
      } finally {
        if (input) input.value = '';
      }
    },
    async uploadManualInstallmentProof(order, index, file) {
      if (!order || !file) return null;
      const docId = this.docKey(order);
      if (!docId) throw new Error('ID ordine non valido per il caricamento del documento.');
      const idx = Number.isInteger(Number(index)) ? Number(index) + 1 : 'x';
      const rawNameExt = (file.name || '').split('.').pop() || '';
      const typeExt = (file.type || '').includes('/') ? file.type.split('/')[1] : '';
      const normalizedExt = rawNameExt || typeExt || 'file';
      const safeExt = normalizedExt.toLowerCase().replace(/[^a-z0-9]/g, '') || 'file';
      const path = `orders/${docId}/installments/${idx}/payment-proof-${Date.now()}.${safeExt}`;
      const fileRef = storageRef(storage, path);
      const imageExts = new Set(['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'heic', 'heif']);
      let fallbackContentType = 'application/octet-stream';
      if (safeExt === 'pdf') fallbackContentType = 'application/pdf';
      else if (imageExts.has(safeExt)) {
        const mapped = safeExt === 'jpg' ? 'jpeg' : safeExt;
        fallbackContentType = `image/${mapped}`;
      }
      await uploadBytes(fileRef, file, {
        contentType: file.type || fallbackContentType,
      });
      const url = await getDownloadURL(fileRef);
      const nowIso = new Date().toISOString();
      return {
        url,
        fileName: file.name,
        fileType: file.type || null,
        storagePath: path,
        uploadedAt: nowIso,
        uploadedBy: auth?.currentUser?.uid || null,
      };
    },
    async applyManualInstallmentProof(order, index, file) {
      if (!order) return;
      const idx = Number(index);
      if (!Number.isInteger(idx) || idx < 0) return;
      const docId = this.docKey(order);
      if (!docId) {
        alert('Impossibile individuare questo ordine.');
        return;
      }
      const displayedPlan = Array.isArray(order.manualInstallments) ? order.manualInstallments : [];
      const target = displayedPlan[idx];
      if (!target) return;

      this.setManualInstallmentSaving(order, idx, true);
      try {
        const proofPayload = await this.uploadManualInstallmentProof(order, idx, file);
        const nowIso = new Date().toISOString();
        const orderRef = doc(this.db, 'orders', String(docId));
        const result = await runTransaction(this.db, async (tx) => {
          const snapshot = await tx.get(orderRef);
          if (!snapshot.exists()) throw new Error('Ordine non trovato.');

          const freshOrder = snapshot.data() || {};
          const plan = Array.isArray(freshOrder.manualInstallments)
            ? freshOrder.manualInstallments.map(inst => ({ ...inst }))
            : [];
          const targetIndex = this.resolveManualInstallmentIndex(plan, target, idx);
          if (targetIndex < 0) throw new Error('Rata non trovata. Aggiorna la pagina e riprova.');

          const freshTarget = plan[targetIndex];
          const hadPaidBefore = this.hasPaidManualInstallments(plan);
          const nextMethod = isManualPaymentProofMethod(freshTarget.method)
            ? freshTarget.method
            : 'bonifico';
          plan[targetIndex] = {
            ...freshTarget,
            method: nextMethod,
            status: 'pagato',
            paidAt: freshTarget.paidAt || freshTarget.paid_at || nowIso,
            paymentProof: proofPayload,
          };

          const blocked = (
            isManualInstallmentsOrderTerminal(freshOrder)
            || this.isInvalidOrderStatus(freshOrder.status)
            || this.isInvalidOrderStatus(freshOrder.paymentStatus)
          );
          const state = this.manualInstallmentsOrderState(plan);
          const updates = {
            manualInstallments: plan,
            updatedAt: nowIso,
          };
          if (!blocked) {
            updates.status = state.status;
            updates.paymentStatus = state.paymentStatus;
          }
          tx.update(orderRef, updates);

          return {
            blocked,
            hadPaidBefore,
            state,
            plan,
            status: blocked ? freshOrder.status : state.status,
            paymentStatus: blocked ? freshOrder.paymentStatus : state.paymentStatus,
          };
        });

        if (this.$set) this.$set(order, 'manualInstallments', result.plan);
        else order.manualInstallments = result.plan;
        if (result.status !== undefined) {
          if (this.$set) this.$set(order, 'status', result.status);
          else order.status = result.status;
        }
        if (result.paymentStatus !== undefined) {
          if (this.$set) this.$set(order, 'paymentStatus', result.paymentStatus);
          else order.paymentStatus = result.paymentStatus;
        }

        const shouldTriggerActivation = !result.hadPaidBefore
          && result.state.hasPaid
          && !result.blocked;
        if (shouldTriggerActivation) {
          try {
            await this.createPercorsiForOrder({
              ...order,
              status: result.state.status,
              paymentStatus: result.state.paymentStatus,
              manualInstallments: result.plan,
            });
            await this.fetchPercorsiCount(docId);
            await this.createOrderConfirmationTicket({
              orderId: docId,
              orderPayload: {
                ...order,
                status: result.state.status,
                paymentStatus: result.state.paymentStatus,
                manualInstallments: result.plan,
              },
              ensureResult: null,
              newUserCreated: false,
              force: true,
            });
          } catch (postErr) {
            console.warn('Azioni post completamento rate fallite:', postErr);
          }
        }
      } finally {
        this.setManualInstallmentSaving(order, idx, false);
      }
    },
    manualInstallmentPaidCount(plan = []) {
      if (!Array.isArray(plan)) return 0;
      return manualInstallmentStats(plan).paid;
    },
    hasPaidManualInstallments(plan = []) {
      if (!Array.isArray(plan)) return false;
      return plan.some(inst => this.isInstallmentPaid(inst));
    },
    cancelUnpaidManualInstallments(plan = []) {
      if (!Array.isArray(plan)) return [];
      return plan.map((inst) => {
        if (!inst || typeof inst !== 'object' || isManualInstallmentPaid(inst)) {
          return inst;
        }
        const next = {
          ...inst,
          status: 'annullata',
        };
        delete next.overdue;
        return next;
      });
    },
    resolveManualInstallmentIndex(plan = [], target = {}, fallbackIndex = -1) {
      if (!Array.isArray(plan)) return -1;
      const targetId = String(target?.id ?? '').trim();
      if (targetId) {
        return plan.findIndex(inst => String(inst?.id ?? '').trim() === targetId);
      }
      const idx = Number(fallbackIndex);
      return Number.isInteger(idx) && idx >= 0 && idx < plan.length ? idx : -1;
    },
    manualInstallmentsOrderState(plan = []) {
      return manualInstallmentsOrderState(plan);
    },
    manualInstallmentsSummary(plan = [], order = {}) {
      const stats = manualInstallmentStats(plan, Date.now(), order);
      const total = stats.total;
      if (!total) return '—';
      const amount = this.manualInstallmentTotalAmount(plan);
      const parts = [`${total} ${total === 1 ? 'rata' : 'rate'}`];
      parts.push(`${stats.paid}/${total} pagate`);
      if (stats.expired) parts.push(`${stats.expired} ${stats.expired === 1 ? 'scaduta' : 'scadute'}`);
      if (stats.pending) parts.push(`${stats.pending} in attesa`);
      if (stats.cancelled) parts.push(`${stats.cancelled} ${stats.cancelled === 1 ? 'annullata' : 'annullate'}`);
      parts.push(this.formatPrice(amount));
      return parts.join(' · ');
    },
    areAllManualInstallmentsPaid(plan = []) {
      const stats = manualInstallmentStats(plan);
      return stats.total > 0 && stats.paid === stats.total;
    },
    buildManualInstallmentsPayload(defaultPaidAt = null) {
      const list = Array.isArray(this.form.manualInstallments) ? this.form.manualInstallments : [];
      return list.map((inst, idx) => {
        const method = (inst.method || '').trim();
        const rawStatus = (inst.status || '').trim();
        const normalizedStatus = rawStatus.toLowerCase();
        const isPaid = normalizedStatus === 'pagato' || !!inst.paidAt;
        const almaCount = Number(inst.almaInstallments);
        const almaInstallments = Number.isFinite(almaCount) && almaCount > 0 ? almaCount : null;
        return {
          id: inst.id || `manual_rate_${idx + 1}`,
          amount: Number(inst.amount),
          method: method || null,
          scheduledDate: (inst.scheduledDate || '').trim() || null,
          status: rawStatus || 'in attesa di pagamento',
          paidAt: isPaid ? (inst.paidAt || defaultPaidAt || null) : null,
          note: (inst.note || '').trim(),
          almaPaymentId: inst.almaPaymentId || null,
          almaPaymentUrl: inst.almaPaymentUrl || null,
          almaPaymentState: inst.almaPaymentState || null,
          almaProcessingStatus: inst.almaProcessingStatus || null,
          almaPaymentCreatedAt: inst.almaPaymentCreatedAt || null,
          almaLastSyncAt: inst.almaLastSyncAt || null,
          almaInstallments,
        };
      });
    },
    applyEmailFilterFromRoute({ reload = false } = {}) {
      const query = this.$route?.query || {};
      const hasFilterParam =
        Object.prototype.hasOwnProperty.call(query, 'searchEmail') ||
        Object.prototype.hasOwnProperty.call(query, 'filterEmail');
      if (!hasFilterParam) return;
      const next = (query.searchEmail || query.filterEmail || '').toString().trim();
      const current = (this.filters.email || '').trim();
      if (next === current) return;
      if (this.$set) this.$set(this.filters, 'email', next);
      else this.filters.email = next;
      if (reload) this.reload();
    },
    applyPrefillFromRoute() {
      const route = this.$route;
      if (!route || !route.query) return;
      const { email, name, surname, userId } = route.query;
      const trimmedEmail = (email || '').toString().trim();
      if (!trimmedEmail) return;

      const signature = [
        `email:${trimmedEmail}`,
        `name:${(name || '').toString().trim()}`,
        `surname:${(surname || '').toString().trim()}`,
        `userId:${(userId || '').toString().trim()}`
      ].join('|');

      if (signature === this.routePrefillKey && this.showCreate) return;
      this.routePrefillKey = signature;

      this.openCreateModal();
      this.form.userEmail = trimmedEmail;
      if (name) this.form.userName = name.toString().trim();
      if (surname) this.form.userSurname = surname.toString().trim();

      this.$nextTick(() => {
        this.handleEmailBlur();
      });
    },

    /* ===== Creazione ordine manuale (modale) ===== */
    openCreateModal() {
      this.resetCreate();
      this.showCreate = true;
    },
    closeCreate() {
      this.showCreate = false;
      this.showCreditUsageConfirm = false;
      this.resetCreate();
    },
    resetCreate() {
      this.form = {
        userEmail: '',
        userName: '',
        userSurname: '',
        userStudio: '',
        userPhone: '',
        userCodFiscale: '',
        orderDateLocal: this.defaultLocalNow(),
        percorsiStartDate: '',
        status: 'pagato',       // coerente con knownStatuses
        paymentMethod: '',      // unificato
        paymentProvider: '',    // derivato
        welfareProvider: '',
        almaInstallments: 3,
        discount: '',
        creditApplied: 0,
        notes: '',
        manualInstallments: [],
      };
      this.userLookup = {
        loading: false,
        existing: false,
        checkedEmail: '',
        uid: null,
        displayName: '',
        phone: '',
        codFiscale: '',
      };
      this.resetUserCredit();
      this.csenLookup = {
        loading: false,
        checkedEmail: '',
        orderDate: null,
      };
      this.selectedProductId = '';
      this.selectedCustomPtQty = CUSTOM_PT_MIN_QTY;
      this.selectedManualPrice = '';
      this.selectedAddVat22 = false;
      this.lines = [];
      this.total = 0;
      this.errorMsg = '';
      this.successMsg = '';
      this.showCreditUsageConfirm = false;
    },
    defaultLocalNow() {
      const d = new Date();
      const pad = n => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    toMysqlDateTime(localStr) {
      return localStr ? localStr.replace('T', ' ') + ':00' : null;
    },
    makeManualOrderId() {
      const d = new Date();
      const pad = n => String(n).padStart(2, '0');
      const stamp = `${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
      const rnd = Math.random().toString(36).slice(2,5);
      return `${stamp}_${rnd}`;
    },
    ensureManualInstallmentsArray() {
      if (!Array.isArray(this.form.manualInstallments)) {
        if (this.$set) this.$set(this.form, 'manualInstallments', []);
        else this.form.manualInstallments = [];
      }
      return this.form.manualInstallments;
    },
    addManualInstallment() {
      const list = this.ensureManualInstallmentsArray();
      const id = `rate_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`;
      list.push({
        id,
        amount: '',
        method: '',
        scheduledDate: '',
        status: 'in attesa di pagamento',
        note: '',
        almaInstallments: '',
      });
    },
    removeManualInstallment(index) {
      const list = this.ensureManualInstallmentsArray();
      if (index < 0 || index >= list.length) return;
      list.splice(index, 1);
    },
    manualInstallmentSavingKey(orderOrId, index) {
      if (index === undefined || index === null || index < 0) return null;
      let id = '';
      if (typeof orderOrId === 'string') id = orderOrId;
      else id = this.docKey(orderOrId);
      if (!id) return null;
      return `${id}:${index}`;
    },
    setManualInstallmentSaving(orderOrId, index, value) {
      const key = this.manualInstallmentSavingKey(orderOrId, index);
      if (!key) return;
      if (value) {
        if (this.$set) this.$set(this.manualInstallmentSaving, key, true);
        else this.manualInstallmentSaving[key] = true;
      } else if (this.manualInstallmentSaving[key]) {
        if (this.$delete) this.$delete(this.manualInstallmentSaving, key);
        else delete this.manualInstallmentSaving[key];
      }
    },
    isManualInstallmentSaving(orderOrId, index) {
      const key = this.manualInstallmentSavingKey(orderOrId, index);
      if (!key) return false;
      return !!this.manualInstallmentSaving[key];
    },
    async markManualInstallmentPaid(order, index) {
      if (!order && order !== 0) return;
      const idx = Number(index);
      if (!Number.isInteger(idx) || idx < 0) return;
      const docId = this.docKey(order);
      if (!docId) {
        alert('Impossibile individuare questo ordine.');
        return;
      }
      const plan = Array.isArray(order.manualInstallments) ? order.manualInstallments : [];
      const target = plan[idx];
      if (!target) return;
      if (this.isInstallmentPaid(target)) return;
      if (isManualPaymentProofMethod(target.method) && !this.manualInstallmentProof(target, order)?.url) {
        alert('Per segnare pagata questa rata devi prima caricare l’allegato.');
        return;
      }

      const amountLabel = this.formatPrice(target.amount) || 'la rata';
      if (!window.confirm(`Confermi che la rata #${idx + 1} (${amountLabel}) è stata pagata?`)) {
        return;
      }

      this.setManualInstallmentSaving(order, idx, true);
      try {
        const nowIso = new Date().toISOString();
        const orderRef = doc(this.db, 'orders', String(docId));
        const result = await runTransaction(this.db, async (tx) => {
          const snapshot = await tx.get(orderRef);
          if (!snapshot.exists()) throw new Error('Ordine non trovato.');

          const freshOrder = snapshot.data() || {};
          const updatedPlan = Array.isArray(freshOrder.manualInstallments)
            ? freshOrder.manualInstallments.map(inst => ({ ...inst }))
            : [];
          const targetIndex = this.resolveManualInstallmentIndex(updatedPlan, target, idx);
          if (targetIndex < 0) throw new Error('Rata non trovata. Aggiorna la pagina e riprova.');

          const freshTarget = updatedPlan[targetIndex];
          if (
            isManualPaymentProofMethod(freshTarget.method)
            && !this.manualInstallmentProof(freshTarget, freshOrder)?.url
          ) {
            throw new Error('Per segnare pagata questa rata devi prima caricare l’allegato.');
          }

          const hadPaidBefore = this.hasPaidManualInstallments(updatedPlan);
          updatedPlan[targetIndex] = {
            ...freshTarget,
            status: 'pagato',
            paidAt: freshTarget.paidAt || freshTarget.paid_at || nowIso,
          };

          const blocked = (
            isManualInstallmentsOrderTerminal(freshOrder)
            || this.isInvalidOrderStatus(freshOrder.status)
            || this.isInvalidOrderStatus(freshOrder.paymentStatus)
          );
          const state = this.manualInstallmentsOrderState(updatedPlan);
          const updates = {
            manualInstallments: updatedPlan,
            updatedAt: nowIso,
          };
          if (!blocked) {
            updates.status = state.status;
            updates.paymentStatus = state.paymentStatus;
          }
          tx.update(orderRef, updates);

          return {
            blocked,
            hadPaidBefore,
            state,
            plan: updatedPlan,
            status: blocked ? freshOrder.status : state.status,
            paymentStatus: blocked ? freshOrder.paymentStatus : state.paymentStatus,
          };
        });

        if (this.$set) this.$set(order, 'manualInstallments', result.plan);
        else order.manualInstallments = result.plan;
        if (result.status !== undefined) {
          if (this.$set) this.$set(order, 'status', result.status);
          else order.status = result.status;
        }
        if (result.paymentStatus !== undefined) {
          if (this.$set) this.$set(order, 'paymentStatus', result.paymentStatus);
          else order.paymentStatus = result.paymentStatus;
        }

        const shouldTriggerActivation = !result.hadPaidBefore
          && result.state.hasPaid
          && !result.blocked;
        if (shouldTriggerActivation) {
          try {
            await this.createPercorsiForOrder({
              ...order,
              status: result.state.status,
              paymentStatus: result.state.paymentStatus,
              manualInstallments: result.plan,
            });
            await this.fetchPercorsiCount(docId);
            await this.createOrderConfirmationTicket({
              orderId: docId,
              orderPayload: {
                ...order,
                status: result.state.status,
                paymentStatus: result.state.paymentStatus,
                manualInstallments: result.plan,
              },
              ensureResult: null,
              newUserCreated: false,
              force: true,
            });
          } catch (postErr) {
            console.warn('Azioni post completamento rate fallite:', postErr);
          }
        }
      } catch (err) {
        console.error('markManualInstallmentPaid error:', err);
        alert(err?.message || 'Errore durante l’aggiornamento della rata. Riprova.');
      } finally {
        this.setManualInstallmentSaving(order, idx, false);
      }
    },
    async onManualInstallmentMethodChange(order, index, nextMethod) {
      if (!order) return;
      if (isManualInstallmentsOrderTerminal(order)) {
        this.errorMsg = 'Il metodo di pagamento non è modificabile su un ordine annullato.';
        return;
      }
      const idx = Number(index);
      if (!Number.isInteger(idx) || idx < 0) return;
      const docId = this.docKey(order);
      if (!docId) {
        alert('Impossibile individuare questo ordine.');
        return;
      }
      const plan = Array.isArray(order.manualInstallments) ? order.manualInstallments : [];
      const target = plan[idx];
      if (!target) return;
      if (this.isInstallmentPaid(target)) {
        this.errorMsg = 'Il metodo di pagamento non è modificabile su una rata pagata.';
        return;
      }

      const normalized = (nextMethod || '').trim();
      const normalizedMethod = this.normalizeMethod(normalized);
      if ((target.method || '').trim() === normalized) return;

      this.setManualInstallmentSaving(order, idx, true);
      try {
        const orderRef = doc(this.db, 'orders', String(docId));
        const result = await runTransaction(this.db, async (tx) => {
          const snapshot = await tx.get(orderRef);
          if (!snapshot.exists()) throw new Error('Ordine non trovato.');

          const freshOrder = snapshot.data() || {};
          if (isManualInstallmentsOrderTerminal(freshOrder)) {
            throw new Error('Il metodo di pagamento non è modificabile su un ordine annullato.');
          }

          const freshPlan = Array.isArray(freshOrder.manualInstallments)
            ? freshOrder.manualInstallments.map(inst => ({ ...inst }))
            : [];
          const targetIndex = this.resolveManualInstallmentIndex(freshPlan, target, idx);
          if (targetIndex < 0) throw new Error('Rata non trovata. Aggiorna la pagina e riprova.');

          const freshTarget = freshPlan[targetIndex];
          if (this.isInstallmentPaid(freshTarget)) {
            throw new Error('Il metodo di pagamento non è modificabile su una rata pagata.');
          }
          if ((freshTarget.method || '').trim() === normalized) {
            return {
              changed: false,
              plan: freshPlan,
              paymentProvider: freshOrder.paymentProvider,
              targetIndex,
            };
          }

          freshPlan[targetIndex] = {
            ...freshTarget,
            method: normalized || null,
          };
          const hasAlmaInstallment = freshPlan.some(
            inst => this.normalizeMethod(inst.method) === 'alma'
          );
          const updates = {
            manualInstallments: freshPlan,
            updatedAt: new Date().toISOString(),
          };
          if (hasAlmaInstallment) updates.paymentProvider = 'alma';
          tx.update(orderRef, updates);
          return {
            changed: true,
            plan: freshPlan,
            paymentProvider: updates.paymentProvider || freshOrder.paymentProvider,
            targetIndex,
          };
        });

        if (this.$set) this.$set(order, 'manualInstallments', result.plan);
        else order.manualInstallments = result.plan;
        if (result.paymentProvider !== undefined) {
          if (this.$set) this.$set(order, 'paymentProvider', result.paymentProvider);
          else order.paymentProvider = result.paymentProvider;
        }
        if (result.changed && isManualPaymentProofMethod(normalizedMethod)) {
          this.$nextTick(() => this.triggerManualInstallmentProofPicker(order, result.targetIndex));
        }
      } catch (err) {
        console.error('onManualInstallmentMethodChange error:', err);
        alert(err?.message || 'Errore durante l’aggiornamento del metodo di pagamento.');
      } finally {
        this.setManualInstallmentSaving(order, idx, false);
      }
    },
    async onManualInstallmentAlmaInstallmentsChange(order, index, nextValue) {
      if (!order) return;
      if (isManualInstallmentsOrderTerminal(order)) return;
      const idx = Number(index);
      if (!Number.isInteger(idx) || idx < 0) return;
      const docId = this.docKey(order);
      if (!docId) {
        alert('Impossibile individuare questo ordine.');
        return;
      }
      const plan = Array.isArray(order.manualInstallments) ? order.manualInstallments : [];
      const target = plan[idx];
      if (!target) return;
      if (this.isInstallmentPaid(target)) {
        this.errorMsg = 'Il numero di rate Alma non è modificabile su una rata pagata.';
        return;
      }
      if (this.normalizeMethod(target.method) !== 'alma') return;

      const almaInstallments = Number(nextValue);
      if (!Number.isFinite(almaInstallments) || almaInstallments <= 0) {
        alert('Seleziona un numero di rate Alma valido.');
        return;
      }
      if (Number(target.almaInstallments) === almaInstallments) return;

      this.setManualInstallmentSaving(order, idx, true);
      try {
        const orderRef = doc(this.db, 'orders', String(docId));
        const result = await runTransaction(this.db, async (tx) => {
          const snapshot = await tx.get(orderRef);
          if (!snapshot.exists()) throw new Error('Ordine non trovato.');

          const freshOrder = snapshot.data() || {};
          if (isManualInstallmentsOrderTerminal(freshOrder)) {
            throw new Error('Il numero di rate Alma non è modificabile su un ordine annullato.');
          }

          const freshPlan = Array.isArray(freshOrder.manualInstallments)
            ? freshOrder.manualInstallments.map(inst => ({ ...inst }))
            : [];
          const targetIndex = this.resolveManualInstallmentIndex(freshPlan, target, idx);
          if (targetIndex < 0) throw new Error('Rata non trovata. Aggiorna la pagina e riprova.');

          const freshTarget = freshPlan[targetIndex];
          if (this.isInstallmentPaid(freshTarget)) {
            throw new Error('Il numero di rate Alma non è modificabile su una rata pagata.');
          }
          if (this.normalizeMethod(freshTarget.method) !== 'alma') {
            throw new Error('La rata non usa più Alma. Aggiorna la pagina e riprova.');
          }
          if (Number(freshTarget.almaInstallments) === almaInstallments) {
            return { changed: false, plan: freshPlan };
          }

          freshPlan[targetIndex] = { ...freshTarget, almaInstallments };
          tx.update(orderRef, {
            manualInstallments: freshPlan,
            updatedAt: new Date().toISOString(),
          });
          return { changed: true, plan: freshPlan };
        });

        if (this.$set) this.$set(order, 'manualInstallments', result.plan);
        else order.manualInstallments = result.plan;
      } catch (err) {
        console.error('onManualInstallmentAlmaInstallmentsChange error:', err);
        alert(err?.message || 'Errore durante l’aggiornamento delle rate Alma.');
      } finally {
        this.setManualInstallmentSaving(order, idx, false);
      }
    },
    async onManualInstallmentNoteChange(order, index, nextNote) {
      if (!order) return;
      const idx = Number(index);
      if (!Number.isInteger(idx) || idx < 0) return;
      const docId = this.docKey(order);
      if (!docId) {
        alert('Impossibile individuare questo ordine.');
        return;
      }
      const plan = Array.isArray(order.manualInstallments) ? order.manualInstallments : [];
      const target = plan[idx];
      if (!target) return;

      const normalized = (nextNote || '').trim();
      if ((target.note || '').trim() === normalized) return;

      this.setManualInstallmentSaving(order, idx, true);
      try {
        const orderRef = doc(this.db, 'orders', String(docId));
        const result = await runTransaction(this.db, async (tx) => {
          const snapshot = await tx.get(orderRef);
          if (!snapshot.exists()) throw new Error('Ordine non trovato.');

          const freshOrder = snapshot.data() || {};
          const freshPlan = Array.isArray(freshOrder.manualInstallments)
            ? freshOrder.manualInstallments.map(inst => ({ ...inst }))
            : [];
          const targetIndex = this.resolveManualInstallmentIndex(freshPlan, target, idx);
          if (targetIndex < 0) throw new Error('Rata non trovata. Aggiorna la pagina e riprova.');

          const freshTarget = freshPlan[targetIndex];
          if ((freshTarget.note || '').trim() === normalized) {
            return { changed: false, plan: freshPlan };
          }

          freshPlan[targetIndex] = { ...freshTarget, note: normalized };
          tx.update(orderRef, {
            manualInstallments: freshPlan,
            updatedAt: new Date().toISOString(),
          });
          return { changed: true, plan: freshPlan };
        });

        if (this.$set) this.$set(order, 'manualInstallments', result.plan);
        else order.manualInstallments = result.plan;
      } catch (err) {
        console.error('onManualInstallmentNoteChange error:', err);
        alert(err?.message || 'Errore durante l’aggiornamento della nota.');
      } finally {
        this.setManualInstallmentSaving(order, idx, false);
      }
    },
    buildAlmaInstallmentPayload(order, inst, idx) {
      const docId = this.docKey(order);
      if (!docId) return null;
      const amount = Number(inst?.amount) || 0;
      if (!Number.isFinite(amount) || amount <= 0) return null;
      const almaCount = Number(inst?.almaInstallments);
      if (!Number.isFinite(almaCount) || almaCount <= 0) return null;

      const customer = this.deriveUserDetailsFromOrder(order);
      const basePath = (process.env.BASE_URL || '/').replace(/\/?$/, '/');
      const appBaseUrl = window.location.origin + basePath;
      const configuredReturn = (getEnvVar('VITE_ALMA_RETURN_URL') || '').trim();
      const configuredCancel = (getEnvVar('VITE_ALMA_CANCEL_URL') || '').trim();
      const configuredFailure = (getEnvVar('VITE_ALMA_FAILURE_URL') || '').trim();
      const configuredCustomerUrl = (getEnvVar('VITE_ALMA_CUSTOMER_URL') || '').trim();
      const configuredMerchantUrl = (getEnvVar('VITE_ALMA_MERCHANT_URL') || '').trim();
      const captureMethodEnv = (getEnvVar('VITE_ALMA_CAPTURE_METHOD') || '').trim().toLowerCase();
      const expiresAfterEnv = parseInt((getEnvVar('VITE_ALMA_EXPIRES_AFTER_MINUTES') || '').trim(), 10);
      const locale = (getEnvVar('VITE_ALMA_LOCALE') || 'it').trim() || 'it';
      const ipnUrl = (getEnvVar('VITE_ALMA_IPN_URL') || getEnvVar('VITE_ALMA_WEBHOOK_URL') || '').trim();

      const almaReturnUrl = configuredReturn || `${appBaseUrl}#/orders-general`;
      const almaCancelUrl = configuredCancel || almaReturnUrl;
      const almaFailureUrl = configuredFailure || almaCancelUrl;

      const payload = {
        orderId: String(docId),
        amount: amount.toFixed(2),
        installments: almaCount,
        userEmail: customer.email || order.userEmail || order.customerEmail || null,
        customer: {
          firstName: (customer.name || '').trim(),
          lastName: (customer.surname || '').trim(),
          phone: this.normalizeAlmaPhone(customer.phone || ''),
          studio: (customer.studio || '').trim(),
          isBusiness: false,
        },
        returnUrl: almaReturnUrl,
        cancelUrl: almaCancelUrl,
        failureUrl: almaFailureUrl,
        customerUrl: configuredCustomerUrl || almaReturnUrl,
        merchantUrl: configuredMerchantUrl || '',
        locale,
        metadata: {
          createdFrom: 'OrderComponentNew',
          manualInstallment: true,
          installmentIndex: idx + 1,
          installmentId: inst?.id || null,
        },
      };

      if (ipnUrl) {
        payload.ipnCallbackUrl = ipnUrl;
      }
      if (captureMethodEnv === 'manual' || captureMethodEnv === 'automatic') {
        payload.captureMethod = captureMethodEnv;
      }
      if (Number.isFinite(expiresAfterEnv) && expiresAfterEnv > 0) {
        payload.expiresAfter = expiresAfterEnv;
      }
      return payload;
    },
    async createAlmaInstallmentLink(order, index, options = {}) {
      const silent = !!options?.silent;
      if (!order) return false;
      if (isManualInstallmentsOrderTerminal(order)) {
        if (!silent) this.errorMsg = 'Non puoi generare un nuovo link di pagamento per un ordine annullato.';
        return false;
      }
      const idx = Number(index);
      if (!Number.isInteger(idx) || idx < 0) return false;
      const docId = this.docKey(order);
      if (!docId) {
        if (!silent) alert('Impossibile individuare questo ordine.');
        return false;
      }
      const plan = Array.isArray(order.manualInstallments) ? order.manualInstallments.map(inst => ({ ...inst })) : [];
      const target = plan[idx];
      if (!this.canCreateAlmaInstallmentLink(order, target)) return false;

      const payload = this.buildAlmaInstallmentPayload(order, target, idx);
      if (!payload) {
        if (!silent) alert('Dati insufficienti per generare il link Alma.');
        return false;
      }

      this.setManualInstallmentSaving(order, idx, true);
      try {
        const almaResult = await this.callAlmaFunction('create', payload);
        const nowIso = new Date().toISOString();
        const updatedPlan = plan.map((inst, planIdx) => {
          if (planIdx !== idx) return { ...inst };
          return {
            ...inst,
            almaPaymentId: almaResult?.paymentId || inst.almaPaymentId || null,
            almaPaymentUrl: almaResult?.paymentUrl || inst.almaPaymentUrl || null,
            almaPaymentState: almaResult?.state || inst.almaPaymentState || null,
            almaPaymentCreatedAt: inst.almaPaymentCreatedAt || nowIso,
          };
        });

        if (this.$set) this.$set(order, 'manualInstallments', updatedPlan);
        else order.manualInstallments = updatedPlan;
        if ((order.paymentProvider || '').toLowerCase() !== 'alma') {
          if (this.$set) this.$set(order, 'paymentProvider', 'alma');
          else order.paymentProvider = 'alma';
        }
        if (almaResult?.paymentId) {
          if (this.$set) this.$set(order, 'almaPaymentId', almaResult.paymentId);
          else order.almaPaymentId = almaResult.paymentId;
        }
        if (almaResult?.paymentUrl) {
          if (this.$set) this.$set(order, 'almaPaymentUrl', almaResult.paymentUrl);
          else order.almaPaymentUrl = almaResult.paymentUrl;
        }
        if (almaResult?.state) {
          if (this.$set) this.$set(order, 'almaPaymentState', almaResult.state);
          else order.almaPaymentState = almaResult.state;
        }
        if (almaResult?.paymentUrl && !silent) {
          this.successMsg = `Link Alma creato per la rata #${idx + 1}.`;
        }
        return !!almaResult?.paymentUrl;
      } catch (err) {
        console.error('createAlmaInstallmentLink error:', err);
        if (!silent) {
          this.errorMsg = err?.message || 'Errore durante la creazione del link Alma.';
        }
        return false;
      } finally {
        this.setManualInstallmentSaving(order, idx, false);
      }
    },
    addLine() {
      if (!this.selectedProductId) return;
      const prod = this.selectedProductForPicker;
      if (!prod) return;

      const isCustomPt = this.isCustomPtProduct(prod);
      const isManualPrice = this.isManualPriceProduct(prod);
      const basePrice = isManualPrice ? Number(this.selectedManualPrice) : (Number(prod.price) || 0);
      if (isManualPrice && (!Number.isFinite(basePrice) || basePrice <= 0)) {
        this.errorMsg = 'Per INTEGRAZIONE SERVIZI inserisci un prezzo maggiore di 0 €.';
        return;
      }
      const applyVat22 = this.canUseVat22Flag && this.selectedAddVat22;
      const price = applyVat22 ? this.addVat22ToPrice(basePrice) : basePrice;
      const qty = isCustomPt ? this.clampCustomPtQty(this.selectedCustomPtQty) : 1;

      this.errorMsg = '';
      this.lines.push({
        key: `${prod.id}-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
        productId: prod.id,
        name: prod.name,
        sku: prod.sku || null,
        price,
        vat22Applied: applyVat22,
        netPriceBeforeVat: applyVat22 ? this.roundMoney(basePrice) : undefined,
        vatRate: applyVat22 ? VAT_22_RATE : undefined,
        quantity: qty,
        pt_quantity: isCustomPt ? 1 : undefined,
      });
      this.selectedProductId = '';
      this.selectedCustomPtQty = CUSTOM_PT_MIN_QTY;
      this.selectedManualPrice = '';
      this.selectedAddVat22 = false;
      this.recalcTotal();
    },
    removeLine(i) {
      this.lines.splice(i, 1);
      this.recalcTotal();
    },
    recalcTotal() {
      this.total = this.lines.reduce((s, l) => s + (Number(l.price)||0) * (Number(l.quantity)||0), 0);
    },
    roundMoney(value) {
      const num = Number(value);
      if (!Number.isFinite(num)) return 0;
      return Math.round((num + Number.EPSILON) * 100) / 100;
    },
    normalizeCreditMovement(movement = {}, index = 0) {
      const rawType = movement.type || movement.tipo || 'add';
      const type = rawType === 'subtract' || rawType === 'scala' ? 'subtract' : 'add';
      return {
        id: movement.id || `${movement.createdAt || movement.data || Date.now()}-${index}`,
        type,
        amount: this.roundMoney(Number(movement.amount ?? movement.valore) || 0),
        date: movement.date || movement.data || '',
        expiryDate: movement.expiryDate || movement.dataScadenza || '',
        notes: movement.notes || movement.note || '',
        createdAt: movement.createdAt || null,
        orderId: movement.orderId || null,
      };
    },
    serializeCreditMovement(movement = {}) {
      return {
        id: movement.id,
        tipo: movement.type === 'subtract' ? 'subtract' : 'add',
        valore: this.roundMoney(movement.amount),
        data: movement.date || '',
        dataScadenza: movement.expiryDate || '',
        note: movement.notes || '',
        createdAt: movement.createdAt || new Date().toISOString(),
        orderId: movement.orderId || null,
      };
    },
    calculateCreditTotal(movements = []) {
      return this.roundMoney((movements || []).reduce((sum, movement) => {
        const normalized = this.normalizeCreditMovement(movement);
        return normalized.type === 'subtract'
          ? sum - normalized.amount
          : sum + normalized.amount;
      }, 0));
    },
    normalizeCreditData(rawCredit) {
      const source = Array.isArray(rawCredit) ? { movimenti: rawCredit } : rawCredit || {};
      const rawMovements = source.movimenti || source.movements || [];
      const movements = Array.isArray(rawMovements)
        ? rawMovements.map((movement, index) => this.normalizeCreditMovement(movement, index))
          .filter((movement) => movement.amount > 0)
        : [];
      return {
        total: this.calculateCreditTotal(movements),
        movements,
      };
    },
    resetUserCredit(error = '') {
      this.userCredit = {
        loading: false,
        visible: false,
        uid: null,
        total: 0,
        movements: [],
        error,
      };
      if (this.form) this.form.creditApplied = 0;
    },
    setUserCreditFromUser(user = {}) {
      const uid = user.uid || user.id || null;
      const normalized = this.normalizeCreditData(user.credito);
      this.userCredit = {
        loading: false,
        visible: !!uid && normalized.total > 0,
        uid,
        total: normalized.total,
        movements: normalized.movements,
        error: '',
      };
      this.form.creditApplied = 0;
    },
    toggleUseCredit() {
      if (this.creditAppliedAmount > 0) {
        this.form.creditApplied = 0;
        if (this.form.paymentMethod === 'credito') {
          this.form.paymentMethod = '';
          this.handlePaymentMethodChange();
        }
        return;
      }
      this.applyUserCreditToCurrentOrder();
    },
    applyUserCreditToCurrentOrder() {
      if (!canManuallyManageCredit(auth.currentUser) || !this.canApplyCredit) return;
      const amount = this.roundMoney(Math.min(this.userCredit.total, this.totalAfterManualDiscount));
      this.form.creditApplied = amount;
      if (amount >= this.totalAfterManualDiscount && this.totalAfterManualDiscount > 0) {
        this.form.paymentMethod = 'credito';
        this.handlePaymentMethodChange();
      }
      return amount;
    },
    shouldPromptUnusedCredit() {
      return this.canApplyCredit && this.creditAppliedAmount <= 0;
    },
    confirmSaveWithoutCredit() {
      this.showCreditUsageConfirm = false;
      this.saveOrder({ skipCreditWarning: true });
    },
    confirmSaveWithCredit() {
      const applied = this.applyUserCreditToCurrentOrder();
      if (!applied) return;
      this.showCreditUsageConfirm = false;
      this.$nextTick(() => this.saveOrder({ skipCreditWarning: true }));
    },
    async saveOrderAndApplyCredit({ orderRef, userUid, orderId, payload, creditApplied, nowIso }) {
      const amount = this.roundMoney(creditApplied);
      if (!amount || amount <= 0) {
        await setDoc(orderRef, payload);
        return null;
      }
      if (!canManuallyManageCredit(auth.currentUser)) {
        throw new Error('L’utilizzo manuale del saldo sugli ordini è riservato a Valerio.');
      }
      if (!userUid) {
        throw new Error('Credito non applicabile: utente non agganciato.');
      }

      const userRef = doc(this.db, 'users', String(userUid));
      let nextCredit = null;
      await runTransaction(this.db, async (tx) => {
        const userSnap = await tx.get(userRef);
        if (!userSnap.exists()) {
          throw new Error('Utente non trovato per applicare il credito.');
        }
        const currentCredit = this.normalizeCreditData((userSnap.data() || {}).credito);
        if (currentCredit.total + 0.01 < amount) {
          throw new Error('Credito insufficiente: aggiorna la pagina e riprova.');
        }

        const movement = {
          id: `credit-order-${orderId}-${Date.now()}`,
          type: 'subtract',
          amount,
          date: toDateInput(new Date()),
          expiryDate: '',
          notes: `Usato su ordine ${orderId}`,
          createdAt: nowIso || new Date().toISOString(),
          orderId,
        };
        const movements = [...currentCredit.movements, movement];
        const total = this.calculateCreditTotal(movements);
        nextCredit = { total, movements };

        tx.update(userRef, {
          credito: {
            totale: total,
            movimenti: movements.map((item) => this.serializeCreditMovement(item)),
            updatedAt: nowIso || new Date().toISOString(),
          },
          updatedAt: nowIso || new Date().toISOString(),
        });
        tx.set(orderRef, payload);
      });

      return nextCredit;
    },
    addVat22ToPrice(value) {
      return this.roundMoney((Number(value) || 0) * (1 + VAT_22_RATE));
    },
    async handleEmailBlur() {
      const rawEmail = (this.form.userEmail || '').trim();
      const email = this.normalizeEmail(rawEmail);
      if (!email) {
        this.resetCsenLookup();
        return;
      }
      if (email !== rawEmail) {
        this.form.userEmail = email;
      }
      this.userLookup.loading = true;
      this.userLookup.checkedEmail = email;
      this.userLookup.existing = false;
      this.userLookup.uid = null;
      this.userLookup.displayName = '';
      this.resetUserCredit();
      try {
        const existing = await this.findUserByEmail(email);
        if (existing) {
          this.userLookup.existing = true;
          this.userLookup.uid = existing.uid || existing.id || null;
          this.userLookup.displayName = [existing.name, existing.surname].filter(Boolean).join(' ').trim();
          this.userLookup.phone = existing.phone || '';
          this.userLookup.codFiscale = existing.codFiscale || '';
          this.form.userName = existing.name || this.form.userName;
          this.form.userSurname = existing.surname || this.form.userSurname;
          this.form.userStudio = existing.studio || this.form.userStudio;
          this.form.userPhone = existing.phone || this.form.userPhone;
          this.form.userCodFiscale = existing.codFiscale || this.form.userCodFiscale;
          this.setUserCreditFromUser(existing);
        }
      } catch (err) {
        console.error('handleEmailBlur error:', err);
        this.resetUserCredit('Impossibile caricare il credito utente.');
      } finally {
        this.userLookup.loading = false;
      }
      await this.fetchCsenStatusForUser();
    },
    async findUserByEmail(email) {
      try {
        const trimmed = (email || '').trim();
        const normalized = this.normalizeEmail(trimmed);
        const attempts = [];
        const pushAttempt = (field, value) => {
          if (!field || !value) return;
          if (attempts.some((item) => item.field === field && item.value === value)) return;
          attempts.push({ field, value });
        };
        pushAttempt('emailLower', normalized);
        pushAttempt('email', trimmed);
        if (normalized && normalized !== trimmed) pushAttempt('email', normalized);

        for (const attempt of attempts) {
          const qs = await getDocs(
            query(collection(this.db, 'users'), where(attempt.field, '==', attempt.value), limit(1))
          );
          if (!qs.empty) {
            const docSnap = qs.docs[0];
            return { id: docSnap.id, ...docSnap.data() };
          }
        }

        return null;
      } catch (err) {
        console.error('findUserByEmail error:', err);
        return null;
      }
    },
    generateTempPassword() {
      // Allineato alla password temporanea comunicata nelle email automatiche
      return 'Fusco6202';
    },
    lookupProductFallback(line) {
      if (!line) return null;
      const candidates = [];
      if (line.id) candidates.push(String(line.id).trim());
      if (line.sku) candidates.push(line.sku.trim().toLowerCase());
      if (line.name) candidates.push(line.name.trim().toLowerCase());

      for (const key of candidates) {
        if (!key) continue;
        const match = PRODUCT_FALLBACKS[key];
        if (match) {
          return this.buildFallbackProductPayload(line, match, key);
        }
      }

      for (const [key, config] of Object.entries(PRODUCT_FALLBACKS)) {
        const aliases = Array.isArray(config.aliases)
          ? config.aliases.map(alias => (alias || '').trim().toLowerCase()).filter(Boolean)
          : [];
        if (!aliases.length) continue;
        if (aliases.some(alias => candidates.includes(alias))) {
          return this.buildFallbackProductPayload(line, config, key);
        }
      }
      return null;
    },
    buildFallbackProductPayload(line, config, key) {
      const normalized = config || {};
      const safeKey = key || normalized.id || null;
      return {
        id: normalized.id || line.id || safeKey || null,
        name: normalized.name || line.name || safeKey || '',
        sku: normalized.sku || line.sku || null,
        coaching_quantity: normalized.coaching_quantity ?? normalized.coachingQty ?? null,
        cons_tecniche: normalized.cons_tecniche ?? normalized.consTec ?? 0,
        cons_nutrizionali: normalized.cons_nutrizionali ?? normalized.consNutr ?? 0,
        pt_quantity: normalized.pt_quantity ?? normalized.ptQty ?? 0,
        duration_months: normalized.duration_months ?? normalized.durationMonths ?? 1,
      };
    },
    firstNonEmpty(values = []) {
      for (const raw of values || []) {
        if (raw === null || raw === undefined) continue;
        const str = String(raw).trim();
        if (str) return str;
      }
      return '';
    },
    normalizeAlmaPhone(raw = '') {
      const trimmed = String(raw || '').trim();
      if (!trimmed) return '';
      if (trimmed.startsWith('+')) {
        const digits = trimmed.replace(/\D/g, '');
        return digits ? `+${digits}` : '';
      }
      let digits = trimmed.replace(/\D/g, '');
      if (digits.startsWith('0039')) {
        digits = digits.slice(4);
      } else if (digits.startsWith('39') && digits.length > 10) {
        digits = digits.slice(2);
      }
      return digits;
    },
    splitFullName(fullName = '') {
      const trimmed = (fullName || '').trim();
      if (!trimmed) return { name: '', surname: '' };
      const parts = trimmed.split(/\s+/).filter(Boolean);
      if (!parts.length) return { name: '', surname: '' };
      if (parts.length === 1) return { name: parts[0], surname: '' };
      const name = parts.shift();
      return { name: name || '', surname: parts.join(' ') };
    },
    deriveUserDetailsFromOrder(order = {}) {
      const safe = order || {};
      const billing = safe.billing || {};
      const shipping = safe.shipping || {};
      const customer = safe.customer || {};

      const email = this.firstNonEmpty([
        safe.userEmail,
        customer.email,
        billing.email,
        shipping.email,
      ]);

      let name = this.firstNonEmpty([
        safe.customerName,
        safe.customerFirstName,
        safe.customer_first_name,
        customer.name,
        customer.firstName,
        customer.first_name,
        billing.first_name,
        billing.firstName,
        shipping.first_name,
        shipping.firstName,
      ]);

      let surname = this.firstNonEmpty([
        safe.customerSurname,
        safe.customerLastName,
        safe.customer_last_name,
        customer.surname,
        customer.lastName,
        customer.last_name,
        billing.last_name,
        billing.lastName,
        shipping.last_name,
        shipping.lastName,
      ]);

      if (!name || !surname) {
        const combined = this.firstNonEmpty([
          safe.customerFullName,
          safe.customerName,
          customer.fullName,
          customer.full_name,
          `${billing.first_name || billing.firstName || ''} ${billing.last_name || billing.lastName || ''}`,
          `${shipping.first_name || shipping.firstName || ''} ${shipping.last_name || shipping.lastName || ''}`,
        ]);
        if (combined) {
          const parts = this.splitFullName(combined);
          if (!name && parts.name) name = parts.name;
          if (!surname && parts.surname) surname = parts.surname;
        }
      }

      if ((!name || !surname) && email) {
        const local = email.split('@')[0] || '';
        const cleaned = local.replace(/[._-]+/g, ' ');
        const segments = cleaned.split(/\s+/).filter(Boolean);
        if (!name && segments.length) name = segments.shift();
        if (!surname && segments.length) surname = segments.join(' ');
      }

      const studio = this.firstNonEmpty([
        safe.customerStudio,
        safe.userStudio,
        customer.studio,
        billing.company,
      ]);

      const phone = this.firstNonEmpty([
        safe.customerPhone,
        safe.phone,
        safe.userPhone,
        customer.phone,
        billing.phone,
        shipping.phone,
      ]);

      const codFiscale = this.firstNonEmpty([
        safe.customerCodFiscale,
        safe.codFiscale,
        billing.codice_fiscale,
        billing.codiceFiscale,
        billing.cf,
        billing.vat,
        billing.tax_code,
        billing.taxCode,
      ]);

      return {
        email,
        name,
        surname,
        studio,
        phone,
        codFiscale,
      };
    },
  async ensureUserForOrder({ email, name, surname, studio, phone, codFiscale }, options = {}) {
    const updateFormState = options.updateFormState !== false;
    const trimmedEmail = (email || '').trim().toLowerCase();
    if (!trimmedEmail) {
      throw new Error('Email utente non valida');
    }

    const existing = await this.findUserByEmail(trimmedEmail);
    if (existing) {
      const currentPhone = (existing.phone || '').trim();
      const currentCod = (existing.codFiscale || '').trim();
      const trimmedPhone = (phone || '').trim();
      const trimmedCod = (codFiscale || '').trim();
      const userDocId = existing.id || existing.uid || null;
      const userDocUpdates = {};
      if (trimmedPhone && trimmedPhone !== currentPhone) userDocUpdates.phone = trimmedPhone;
      if (trimmedCod && trimmedCod !== currentCod) userDocUpdates.codFiscale = trimmedCod;
      if (Object.keys(userDocUpdates).length && userDocId) {
        userDocUpdates.updatedAt = new Date().toISOString();
        try {
          await updateDoc(doc(this.db, 'users', userDocId), userDocUpdates);
        } catch (err) {
          console.warn('Impossibile aggiornare dati utente:', err);
        }
      } else if (Object.keys(userDocUpdates).length && !userDocId) {
        console.warn('Impossibile aggiornare dati utente: ID non disponibile');
      }

      if (updateFormState) {
        this.userLookup = {
          loading: false,
          existing: true,
          checkedEmail: trimmedEmail,
          uid: existing.uid || existing.id || null,
          displayName: [existing.name, existing.surname].filter(Boolean).join(' ').trim(),
          phone: trimmedPhone || currentPhone,
          codFiscale: trimmedCod || currentCod,
        };
        if (!this.form.userName && existing.name) this.form.userName = existing.name;
        if (!this.form.userSurname && existing.surname) this.form.userSurname = existing.surname;
        if (!this.form.userStudio && existing.studio) this.form.userStudio = existing.studio;
        if (!this.form.userPhone && (trimmedPhone || currentPhone)) this.form.userPhone = trimmedPhone || currentPhone;
        if (!this.form.userCodFiscale && (trimmedCod || currentCod)) this.form.userCodFiscale = trimmedCod || currentCod;
      }
      return { uid: existing.uid || existing.id || null, existed: true };
    }

    const trimmedName = (name || '').trim();
    const trimmedSurname = (surname || '').trim();
      if (!trimmedName || !trimmedSurname) {
        throw new Error('Per creare un nuovo utente sono necessari nome e cognome.');
      }

      try {
        const functions = getFunctions();
        const createUserFn = httpsCallable(functions, 'createUser');
        const res = await createUserFn({
          email: trimmedEmail,
          password: this.generateTempPassword(),
          name: trimmedName,
          surname: trimmedSurname,
          studio: (studio || '').trim(),
          phone: (phone || '').trim(),
          codFiscale: (codFiscale || '').trim(),
        });
        const uid = res?.data?.uid || res?.data || null;
        if (updateFormState) {
          this.userLookup = {
            loading: false,
            existing: true,
            checkedEmail: trimmedEmail,
            uid,
            displayName: `${trimmedName} ${trimmedSurname}`.trim(),
            phone: (phone || '').trim(),
            codFiscale: (codFiscale || '').trim(),
          };
        }
        return { uid, existed: false };
      } catch (err) {
        console.error('ensureUserForOrder createUser error:', err);
        const msg = String(err?.message || '').toLowerCase();
        if (msg.includes('already') || msg.includes('già registrata') || msg.includes('already-exists')) {
          const existingAfter = await this.findUserByEmail(trimmedEmail);
          if (existingAfter) {
            return { uid: existingAfter.uid || existingAfter.id || null, existed: true };
          }
          throw new Error('Email già registrata ma profilo utente non trovato. Esegui la normalizzazione delle email (lowercase) sulla collection users.');
        }
        throw new Error('Errore durante la creazione del nuovo utente.');
      }
    },

    /* ===== Helpers: users/products/percorsi ===== */
    async resolveUserUidByEmail(email) {
      if (!email) return null;
      const trimmed = email.trim();
      const normalized = this.normalizeEmail(trimmed);
      if (normalized && Object.prototype.hasOwnProperty.call(this.emailUidCache, normalized)) {
        return this.emailUidCache[normalized];
      }
      const candidates = [];
      const pushCandidate = (field, value) => {
        if (!field || !value) return;
        if (candidates.some((item) => item.field === field && item.value === value)) return;
        candidates.push({ field, value });
      };
      pushCandidate('emailLower', normalized);
      pushCandidate('email', trimmed);
      if (normalized && normalized !== trimmed) pushCandidate('email', normalized);
      try {
        for (const candidate of candidates) {
          const qs = await getDocs(
            query(collection(this.db, 'users'), where(candidate.field, '==', candidate.value), limit(1))
          );
          if (!qs.empty) {
            const d = qs.docs[0];
            const data = d.data() || {};
            const uid = data.uid || d.id || null;
            if (normalized) this.emailUidCache[normalized] = uid;
            return uid;
          }
        }
      } catch (e) {
        console.warn('resolveUserUidByEmail error:', e);
      }
      if (normalized) this.emailUidCache[normalized] = null;
      return null;
    },
    defaultSteps() {
      return [
        { name: 'questionario',            done: false, doneAt: null, questionnaire: null },
        { name: 'consegna programmi',      done: false, doneAt: null },
        { name: 'feedback programmi',      done: false, doneAt: null, questionnaire: null },
        { name: 'scadenza / check finale', done: false, doneAt: null, questionnaire: null }
      ];
    },
    async hasPercorsiForOrder(orderId) {
      try {
        const qs = await getDocs(
          query(collection(this.db, 'percorsi'), where('orderRef', '==', String(orderId)), limit(1))
        );
        return !qs.empty;
      } catch (e) {
        console.warn('hasPercorsiForOrder error:', e);
        return false;
      }
    },
    async acquirePercorsiCreationLock(orderId) {
      if (!orderId) return { allowed: false, reason: 'missing-id' };
      const orderRef = doc(this.db, 'orders', String(orderId));
      const nowIso = new Date().toISOString();
      const nowMs = Date.now();
      let allowed = false;
      let reason = 'unknown';

      const toMs = (value) => {
        if (!value) return NaN;
        if (typeof value?.toDate === 'function') {
          const dt = value.toDate();
          return dt instanceof Date ? dt.getTime() : NaN;
        }
        const parsed = new Date(String(value)).getTime();
        return Number.isFinite(parsed) ? parsed : NaN;
      };

      try {
        await runTransaction(this.db, async (tx) => {
          const snap = await tx.get(orderRef);
          if (!snap.exists()) {
            reason = 'missing-order';
            return;
          }
          const data = snap.data() || {};
          if (data.percorsiCreatedAt) {
            reason = 'already-created';
            return;
          }

          const state = String(data.percorsiCreationState || '');
          if (state === 'created') {
            reason = 'already-created';
            return;
          }
          const lockMs = toMs(data.percorsiCreationAt);
          const lockActive = state === 'creating'
            && Number.isFinite(lockMs)
            && (nowMs - lockMs) < PERCORSI_LOCK_MAX_AGE_MS;
          if (lockActive) {
            reason = 'locked';
            return;
          }

          tx.update(orderRef, {
            percorsiCreationState: 'creating',
            percorsiCreationAt: nowIso,
            percorsiCreationBy: auth?.currentUser?.uid || null,
            percorsiCreationError: null,
          });
          allowed = true;
          reason = 'acquired';
        });
      } catch (err) {
        console.warn('acquirePercorsiCreationLock error:', err);
        reason = 'transaction-error';
      }

      return { allowed, reason };
    },
    async updatePercorsiCreationState(orderId, { state, error, clearCreated } = {}) {
      if (!orderId) return;
      const orderRef = doc(this.db, 'orders', String(orderId));
      const nowIso = new Date().toISOString();
      const updates = {};

      if (state) {
        updates.percorsiCreationState = state;
        updates.percorsiCreationAt = nowIso;
        if (state === 'created') {
          updates.percorsiCreatedAt = nowIso;
          updates.percorsiCreationError = null;
        } else if (state === 'error') {
          updates.percorsiCreationError = String(error?.message || error || 'Errore creazione percorsi');
        } else {
          updates.percorsiCreationError = null;
        }
      } else {
        updates.percorsiCreationState = null;
        updates.percorsiCreationAt = null;
        updates.percorsiCreationError = null;
      }

      if (clearCreated) {
        updates.percorsiCreatedAt = null;
      }

      try {
        await updateDoc(orderRef, updates);
      } catch (err) {
        console.warn('updatePercorsiCreationState error:', err);
      }
    },
    async createPtSessionsForLine({
      uid,
      orderId,
      productId,
      productName,
      sessionCount,
      orderSource,
      sessionMode = 'studio',
    }) {
      try {
        if (!uid) return;
        if (!Number.isFinite(sessionCount) || sessionCount <= 0) return;
        const exists = await this.hasPtSessionsForLine(orderId, productId);
        if (exists) return;

        const normalizedMode = String(sessionMode || '').toLowerCase() === 'online' ? 'online' : 'studio';
        const slotCome = normalizedMode === 'online' ? 'online' : 'instudio';
        const nowIso = new Date().toISOString();
        const slots = Array.from({ length: sessionCount }, () => ({
          dataCreazioneslot: nowIso,
          dataEffettuata: null,
          TrainerNome: '',
          note: '',
          status: 'Da contattare',
          come: slotCome,
        }));

        await addDoc(collection(this.db, 'sedutept'), {
          uid,
          creatorUid: auth?.currentUser?.uid || null,
          categoriaSeduta: normalizedMode,
          numeroSedute: sessionCount,
          slots,
          idSeduteGroup: `order_${orderId}_${productId || 'pt'}_${Date.now()}`,
          orderRef: String(orderId),
          orderProductId: productId ? String(productId) : null,
          orderSource: orderSource || null,
          productName: productName || null,
          createdAt: nowIso,
        });
      } catch (err) {
        console.error('createPtSessionsForLine error:', err);
      }
    },
    async removePtSessionsForOrder(orderOrId) {
      try {
        const orderReferences = this.orderReferenceCandidates(orderOrId);
        if (!orderReferences.length) return 0;
        const seduteCol = collection(this.db, 'sedutept');
        const snapshots = await Promise.all(
          orderReferences.map(orderRef => getDocs(query(seduteCol, where('orderRef', '==', orderRef))))
        );
        const toDelete = new Map();
        snapshots.forEach(snapshot => {
          snapshot.forEach(documentSnapshot => {
            toDelete.set(documentSnapshot.ref.path, documentSnapshot);
          });
        });
        await Promise.all(
          [...toDelete.values()].map(documentSnapshot => deleteDoc(documentSnapshot.ref))
        );
        return toDelete.size;
      } catch (err) {
        console.error('removePtSessionsForOrder error:', err);
        return null;
      }
    },
    async hasPtSessionsForLine(orderId, productId) {
      try {
        const constraints = [where('orderRef', '==', String(orderId))];
        if (productId) {
          constraints.push(where('orderProductId', '==', String(productId)));
        }
        const qs = await getDocs(
          query(collection(this.db, 'sedutept'), ...constraints, limit(1))
        );
        return !qs.empty;
      } catch (err) {
        console.warn('hasPtSessionsForLine error:', err);
        return false;
      }
    },
// Conta coaching_quantity SOLO per veri "programmi" (FC / Programmi).
// Evita consulenze & co. e gestisce naming tipo "FC 6 +4" (ritorna 6).
inferCoachingQty(name = '', sku = '') {
  const n = String(name || '').toLowerCase().trim();
  const s = String(sku || '').toLowerCase().trim();

  // denylist: se questi termini compaiono, NON generare percorsi
  const deny = ['consulenza', 'consulenze', 'assistenza', 'setup', 'call', 'telefonic', 'supporto'];
  if (deny.some(word => n.includes(word))) return 0;

  // mappa esplicita
  const table = [
    { when: n.includes('10 top solo allenamento') || s === '10topsoloallenamento', qty: 10 },
    { when: n.includes('fc 6 programmi') || s === 'fc6', qty: 6 },
    { when: n.includes('fc 5 programmi') || s === 'fc5', qty: 5 },
    { when: n.includes('fc 4 programmi') || s === 'fc4', qty: 4 },
    { when: n.includes('fc 3 programmi') || s === 'fc3', qty: 3 },
    { when: n.includes('fc 2 programmi') || s === 'fc2', qty: 2 },
    { when: n.includes('fc 1 programma') || s === 'fc1', qty: 1 },
  ];
  for (const r of table) if (r.when) return r.qty;

  // "FC 6 +4" -> prendi SOLO il primo numero (6)
  const combo = n.match(/fc\s*[-_ ]?(\d+)\s*\+\s*\d+/i);
  if (combo && Number(combo[1]) > 0) return Number(combo[1]);

  // SKU tipo FC-6 / FC6
  const mSku = s.match(/^fc\s*[-_ ]?(\d+)$/i);
  if (mSku && Number(mSku[1]) > 0) return Number(mSku[1]);

  // Nome generico "FC 6", "FC6 Basic", ecc.
  const generic = n.match(/fc\s*[-_ ]?(\d+)/i);
  if (generic && Number(generic[1]) > 0) return Number(generic[1]);

  // Nome "6 programmi" (richiede proprio la parola programmi/programma)
  const mName = n.match(/(\d+)\s*programmi?/i);
  if (mName && Number(mName[1]) > 0) return Number(mName[1]);

  return 0;
},

    // Deriva la sorgente dell’ordine
    deriveSource(order, docId) {
      const s = (order?.source || order?._source || '').toLowerCase();
      if (s === 'public_checkout') {
        return (order?.checkoutSource || order?.landingSource || 'fuscofit').toLowerCase();
      }
      if (s) return s;
      const id = String(docId || order?.orderId || '').toLowerCase();
      if (id.startsWith('export_')) return 'woocommerce';
      if (id.startsWith('legacy_')) return 'legacy';
      if (id.startsWith('manual_')) return 'manuale';
      return 'woocommerce'; // fallback per import Woo
    },



    isPaidOrProcessingStatus(status) {
      const normalized = String(status || '').toLowerCase();
      return ['pagato', 'rateizzato', 'wc-processing', 'wc-completed'].includes(normalized);
    },

  normalizeOrderTimestamp(order) {
    const stamp = order?.updatedAt || order?.importedAt || order?.orderDate;
    if (!stamp) return null;
    const parsed = new Date(String(stamp).replace(' ', 'T'));
    if (Number.isNaN(parsed.getTime())) return null;
    return parsed.toISOString();
  },

    isOrderRecent(order) {
      // Evita di toccare ordini molto vecchi quando vengono semplicemente riletti a schermo.
      const iso = this.normalizeOrderTimestamp(order);
      if (!iso) return true;
      const diff = Date.now() - new Date(iso).getTime();
      const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000; // 7 giorni
      return diff <= MAX_AGE_MS;
  },

  async confirmGiftUserCreation(order) {
    if (!order) return;
    if (this.isGiftCardOrder(order)) return;
    const key = this.docKey(order);
    if (!key) return;
    if (this.isGiftUserCreation(order)) return;

    try {
      if (this.$set) this.$set(this.giftUserCreation, key, true);
      else this.giftUserCreation[key] = true;

      const userDetails = this.deriveUserDetailsFromOrder(order);
      if (!userDetails.email) throw new Error('Email destinatario mancante.');
      const result = await this.ensureUserForOrder(userDetails, { updateFormState: false });
      if (result?.uid) {
        if (this.$set) this.$set(order, 'userUid', result.uid);
        else order.userUid = result.uid;
        try {
          await updateDoc(doc(this.db, 'orders', String(key)), {
            userUid: result.uid,
            updatedAt: new Date().toISOString(),
          });
        } catch (linkErr) {
          console.warn('Impossibile aggiornare ordine con userUid (gift):', linkErr);
        }

        const status = String(order.status || '').toLowerCase();
        const paid = this.isPaidOrProcessingStatus(status);
        if (paid) {
          await this.applyUserNewPurchaseState(order);
          await this.createPercorsiForOrder({ ...order, userUid: result.uid });
          await this.fetchPercorsiCount(key);
          try {
            await this.createOrderConfirmationTicket({
              orderId: key,
              orderPayload: { ...order, userUid: result.uid },
              ensureResult: result,
              newUserCreated: result.existed === false,
              force: true,
            });
          } catch (ticketErr) {
            console.warn('Ticket post creazione utente gift fallito:', ticketErr);
          }
        }

        this.successMsg = 'Utente gift creato/agganciato.';
      } else {
        this.errorMsg = 'Impossibile creare/agganciare utente gift.';
      }
    } catch (err) {
      console.error('confirmGiftUserCreation error:', err);
      this.errorMsg = err?.message || 'Errore creazione utente gift.';
    } finally {
      if (this.$set) this.$set(this.giftUserCreation, key, false);
      else this.giftUserCreation[key] = false;
    }
  },

    async applyUserNewPurchaseState(order) {
      if (this.isGiftCardOrder(order)) return;
      try {
        if (!this.isPaidOrProcessingStatus(order?.status)) return;
        if (!this.isOrderRecent(order)) return;

        const orderId = order?.orderId || order?._id;
        if (!orderId) return;

        const uid =
          order?.userUid ||
          order?.userId ||
          order?.uid ||
          (order?.userEmail ? await this.resolveUserUidByEmail(order.userEmail) : null);
        if (!uid) return;

        const userRef = doc(this.db, 'users', uid);
        const snap = await getDoc(userRef);
        if (!snap.exists()) return;

        const data = snap.data() || {};
        // Se stiamo già lavorando sull'ultimo ordine, non azzeriamo il contatore degli invii.
        if (data.lastOrderId === orderId) return;

        await updateDoc(userRef, {
          statoUtente: 'Nuovo Acquisto',
          lastOrderId: orderId,
          lastOrderAt: this.normalizeOrderTimestamp(order) || new Date().toISOString(),
          inviiCycleCount: 0,
          updatedAt: new Date().toISOString(),
        });
      } catch (err) {
        console.warn('applyUserNewPurchaseState error:', err);
      }
    },




// Solo se status ammesso; per Woo/Legacy limita a ordini "nuovi" (24h)
isOrderEligible(order, docId) {
  if (this.isGiftCardOrder(order)) return { ok: false, reason: 'giftcard' };
  // Stati consentiti (case-insensitive)
  const allowed = new Set(['wc-completed', 'wc-processing', 'pagato', 'rateizzato']);
  const st = String(order?.status || '').toLowerCase();
  if (!allowed.has(st)) return { ok:false, reason:'status' };

  // Recenza solo per import (Woo/Legacy), nessun limite per manuali
  const src = this.deriveSource(order, docId);
  if (src !== 'manuale') {
    const WOO_MAX_AGE_MS = 24 * 60 * 60 * 1000; // 24h
    const imp = new Date(order?.importedAt || order?.updatedAt || Date.now());
    const tooOld = isNaN(imp) || (Date.now() - imp.getTime()) > WOO_MAX_AGE_MS;
    if (tooOld) return { ok:false, reason:'age' };
  }
  return { ok:true, source: src };
},

// Per UI: “idoneo” solo se rientra negli allowed
isEligibleStatus(order) {
  if (this.isGiftCardOrder(order)) return false;
  const allowed = new Set(['wc-completed', 'wc-processing', 'pagato', 'rateizzato']);
  const st = String(order?.status || '').toLowerCase();
  return allowed.has(st);
},


// Contatore percorsi per feedback visivo
async fetchPercorsiCount(orderId) {
  if (!orderId) return;
  const key = String(orderId);

  try {
    this.$set ? this.$set(this.percorsiLoading, key, true) : (this.percorsiLoading[key] = true);

    // (1) conta percorsi con orderRef STRINGA
    let total = 0;
    const qStr = await getDocs(
      query(collection(this.db, 'percorsi'), where('orderRef', '==', String(orderId)))
    );
    total += qStr.size;

    // (2) fallback: prova anche orderRef NUMERICO (vecchi dati)
    const asNum = Number(orderId);
    if (total === 0 && Number.isFinite(asNum)) {
      const qNum = await getDocs(
        query(collection(this.db, 'percorsi'), where('orderRef', '==', asNum))
      );
      total += qNum.size;
    }

    this.$set ? this.$set(this.percorsiCount, key, total) : (this.percorsiCount[key] = total);
  } catch (e) {
    console.warn('fetchPercorsiCount error:', e);
    this.$set ? this.$set(this.percorsiCount, key, 0) : (this.percorsiCount[key] = 0);
  } finally {
    this.$set ? this.$set(this.percorsiLoading, key, false) : (this.percorsiLoading[key] = false);
  }
},



/* ===== Core: crea percorsi/consulenze da ordine ===== */
async createPercorsiForOrder(orderPayload) {
  if (this.isGiftCardOrder(orderPayload)) return;
  try {
    const orderId = orderPayload.orderId || orderPayload._id;
    const orderDocId = orderPayload._id || orderPayload.orderId;
    if (!orderId) return;

    // Stato + recenza
    const elig = this.isOrderEligible(orderPayload, orderId);
    if (!elig.ok) return;
    const src = elig.source;

    const lock = await this.acquirePercorsiCreationLock(orderDocId);
    if (!lock.allowed) return;

    const nowIso = new Date().toISOString();
    const plannedStartAt = this.resolvePercorsiStartAt(orderPayload);
    let createdPercorsi = false;
    const uidFromPayload = orderPayload.userUid || null;
    const uid = uidFromPayload || await this.resolveUserUidByEmail(orderPayload.userEmail);

    const already = await this.hasPercorsiForOrder(orderId);
    if (already) {
      createdPercorsi = true;
    } else {
      const orderLines = Array.isArray(orderPayload.products) ? orderPayload.products : [];
      const lineContexts = orderLines.map((line, originalIndex) => {
        const catalogProduct = this.products.find((p) => p.id === line.id);
        const fallbackProduct = catalogProduct ? null : this.lookupProductFallback(line);
        const effectiveProduct = catalogProduct || fallbackProduct || null;
        const isProtocollo25 = this.isProtocollo25Product(line)
          || this.isProtocollo25Product(effectiveProduct);
        let coachingQty = Number(effectiveProduct?.coaching_quantity ?? effectiveProduct?.coachingQty);
        if (!Number.isFinite(coachingQty) || coachingQty <= 0) {
          coachingQty = this.inferCoachingQty(line.name, line.sku);
        }
        const hasConsulenze = Number(effectiveProduct?.cons_nutrizionali ?? effectiveProduct?.consNutr ?? 0) > 0
          || Number(effectiveProduct?.cons_tecniche ?? effectiveProduct?.consTec ?? 0) > 0;
        const linePrice = Number(line.price) || 0;
        const createsPercorso = linePrice !== 0 && (coachingQty > 0 || hasConsulenze);
        return { line, originalIndex, effectiveProduct, isProtocollo25, createsPercorso };
      });
      const hasProtocollo25 = lineContexts.some((item) => item.isProtocollo25 && item.createsPercorso);
      const hasOtherProduct = lineContexts.some((item) => !item.isProtocollo25 && item.createsPercorso);
      const isMixedProtocollo25Order = hasProtocollo25 && hasOtherProduct;
      const baseStartAt = plannedStartAt || nowIso;
      const orderedLineContexts = [...lineContexts].sort((a, b) => {
        if (isMixedProtocollo25Order && a.isProtocollo25 !== b.isProtocollo25) {
          return a.isProtocollo25 ? -1 : 1;
        }
        return a.originalIndex - b.originalIndex;
      });

      // Ciclo prodotti dell’ordine
      for (const lineContext of orderedLineContexts) {
        const l = lineContext.line;
        // Dettaglio da catalogo (se presente in this.products)
        const effectiveProd = lineContext.effectiveProduct;

        // ===== 1) Qty "programmi" (coaching) =====
        let coachingBase = Number(effectiveProd?.coaching_quantity ?? effectiveProd?.coachingQty);
        if (!Number.isFinite(coachingBase) || coachingBase <= 0) {
          coachingBase = this.inferCoachingQty(l.name, l.sku); // fallback da nome/SKU
        }
        const lineQty = Number(l.quantity) || 1;

        // ===== 2) Qty consulenze dal catalogo =====
        const consNutr = Number(effectiveProd?.cons_nutrizionali ?? effectiveProd?.consNutr ?? 0);
        const consTech = Number(effectiveProd?.cons_tecniche ?? effectiveProd?.consTec ?? 0);
        const linePtQty = Number(l?.pt_quantity);
        const productPtQty = Number(effectiveProd?.pt_quantity ?? effectiveProd?.ptQty);
        let ptQtyBase = 0;
        if (Number.isFinite(linePtQty) && linePtQty > 0) {
          ptQtyBase = linePtQty;
        } else if (Number.isFinite(productPtQty) && productPtQty > 0) {
          ptQtyBase = productPtQty;
        }

        // ===== CREA PERCORSI/CONSULENZE =====
        const hasConsulenze = (consNutr > 0 || consTech > 0);
        const priceNum = Number(l.price) || 0;
        if (priceNum !== 0 && (coachingBase > 0 || hasConsulenze)) {
          const productForPercorsi = {
            id: effectiveProd?.id ?? l.id,
            name: effectiveProd?.name ?? l.name,
            sku: effectiveProd?.sku ?? l.sku ?? null,
            // 👇 fondamentale per calcolare expireAt nei percorsi
            duration_months: Number(effectiveProd?.duration_months ?? effectiveProd?.durationMonths ?? 1) || 1,
            // 👇 indispensabile per creare gli step consulenza
            cons_tecniche: consTech,
            cons_nutrizionali: consNutr,
          };

          const result = await createPercorsiForProduct({
            uid: uid || null,
            userEmail: orderPayload.userEmail,
            product: productForPercorsi,
            coachingQty: coachingBase > 0 ? coachingBase : 0,
            quantityMultiplier: lineQty,
            orderRef: orderId,
            orderSource: src,
            nowIso,
            plannedStartAt: isMixedProtocollo25Order && !lineContext.isProtocollo25
              ? this.addCalendarMonthsClampedIso(baseStartAt, 1)
              : baseStartAt,
            titleBase: (effectiveProd?.name || l.name || 'Prodotto'),
            getDefaultSteps: this.defaultSteps.bind(this),
            orderSequencePriority: lineContext.isProtocollo25 ? 0 : lineContext.originalIndex + 1,
            orderSequenceRole: lineContext.isProtocollo25 ? 'protocollo25' : 'standard',
            orderSequenceAnchor: nowIso,
          });
          if (result && (Number(result.totalPercorsi) > 0 || Number(result.attachedConsulenze) > 0)) {
            createdPercorsi = true;
          }
        }
        if (ptQtyBase > 0) {
          const totalSessions = ptQtyBase * lineQty;
          const sessionMode = this.resolvePtSessionModeForLine(l, effectiveProd);
          await this.createPtSessionsForLine({
            uid: uid || null,
            orderId,
            productId: effectiveProd?.id ?? l.id ?? null,
            productName: effectiveProd?.name ?? l.name ?? '',
            sessionCount: totalSessions,
            orderSource: src,
            sessionMode,
          });
        }
      }
    }
    await this.updatePercorsiCreationState(orderDocId, { state: createdPercorsi ? 'created' : null });
  } catch (e) {
    console.error('createPercorsiForOrder error:', e);
    const orderDocId = orderPayload?._id || orderPayload?.orderId;
    if (orderDocId) {
      await this.updatePercorsiCreationState(orderDocId, { state: 'error', error: e });
    }
  }
},

  async createOrderConfirmationTicket({ orderId, orderPayload, ensureResult, newUserCreated, force = false }) {
  if (this.isGiftCardOrder(orderPayload)) return;
  try {
    const payload = orderPayload || {};
    const isGift = !!payload.gift;
    const normalizedStatus = String(payload.status || '').trim().toLowerCase();
    const paidStatuses = ['pagato', 'rateizzato', 'completed', 'processing', 'wc-processing', 'wc-completed'];
    const source = this.deriveSource(payload, orderId);
    if (!force && source !== 'manuale') {
      const MAX_AGE_MS = 24 * 60 * 60 * 1000; // 24h, coerente con isOrderEligible
      const stamp = payload.importedAt || payload.updatedAt || payload.orderDate;
      const parsed = stamp ? new Date(String(stamp).replace(' ', 'T')) : null;
      const tooOld = !parsed || Number.isNaN(parsed.getTime()) || (Date.now() - parsed.getTime()) > MAX_AGE_MS;
      if (tooOld) {
        console.info(`Salto invio conferma ordine/questionario: ordine ${orderId} più vecchio di 24h.`);
        return;
      }
    }
    if (!force && !paidStatuses.includes(normalizedStatus)) {
      console.info(
        `Salto invio conferma ordine/questionario: stato "${payload.status ?? 'n/a'}" non è tra quelli pagati.`
      );
      return;
    }
    const recipients = await this.resolveOrderRecipients({ payload, orderId, ensureResult });
    const { payerUid, recipientUid } = recipients;
    const plannedStartAt = this.resolvePercorsiStartAt(payload);
    const shouldDelayQuestionario = this.isFutureIsoDate(plannedStartAt);

    let ticketCreated = false;

    if (isGift && payerUid) {
      const payerMsg = this.composeOrderTicketMessage({
        orderId,
        orderPayload: payload,
        newUserCreated,
      });
      if (payerMsg) {
        await appendTicketMessage({
          db: this.db,
          userUid: payerUid,
          message: payerMsg,
          title: `Pagamento regalo ${orderId}`,
          ticketId: `order-${orderId}-payer`,
          ticketExtra: {
            tipoTicket: 'Tecnico',
            orderRef: String(orderId),
            orderStatus: payload.status || null,
            orderSource: payload.source || 'manuale',
            manualOrder: true,
            gift: true,
            role: 'payer',
          },
          preserveOpenStatus: true,
          notifyUser: true,
        });
        ticketCreated = true;
      }
    }

    const targetUid = isGift ? recipientUid : (recipients.recipientUid || null);
    const hasQuestionarioEligibleProducts = this.orderHasQuestionarioEligibleProducts(payload);

    if (targetUid) {
      const skipQuestionnaireByProduct = !hasQuestionarioEligibleProducts;
      const skipQuestionnaire = skipQuestionnaireByProduct;

      if (!isGift) {
        const message = this.composeOrderTicketMessage({
          orderId,
          orderPayload: payload,
          newUserCreated,
        });
        if (message) {
          await appendTicketMessage({
            db: this.db,
            userUid: targetUid,
            message,
            title: `Conferma ordine ${orderId}`,
            ticketId: `order-${orderId}`,
            ticketExtra: {
              tipoTicket: 'Tecnico',
              orderRef: String(orderId),
              orderStatus: payload.status || null,
              orderSource: payload.source || 'manuale',
              manualOrder: true,
              gift: false,
              role: 'owner',
            },
            preserveOpenStatus: true,
            notifyUser: true,
          });
          ticketCreated = true;
        }
      }

      if (!skipQuestionnaire && !shouldDelayQuestionario) {
        const questionarioMeta = await this.fetchQuestionarioStepLink({
          userUid: targetUid,
          orderId,
        });
        const alreadySent =
          !!(questionarioMeta?.step?.ticketQuestionarioSentAt?.sentAt || questionarioMeta?.step?.ticketQuestionarioSentAt);
        if (!alreadySent) {
          const questionnairePayload = this.composeInitialQuestionnaireMessage(questionarioMeta?.link || null);
          if (questionnairePayload?.message) {
            await appendTicketMessage({
              db: this.db,
              userUid: targetUid,
              message: questionnairePayload.message,
              title: `Conferma ordine ${orderId}`,
              ticketId: `order-${orderId}`,
              ticketExtra: {
                stepKey: 'questionario',
                questionnaireLink: questionnairePayload.link,
                gift: isGift || false,
                role: isGift ? 'recipient' : 'owner',
              },
              preserveOpenStatus: true,
              notifyUser: true,
            });
          }
          if (questionarioMeta?.percorsoId && Number.isFinite(questionarioMeta.stepIndex)) {
            try {
              await this.markQuestionarioTicketSent(questionarioMeta);
            } catch (markErr) {
              console.warn('markQuestionarioTicketSent error:', markErr);
            }
          }
        } else {
          console.info(`Questionario già notificato per ordine ${orderId}.`);
        }
      } else {
        if (skipQuestionnaireByProduct) {
          console.info(`Questionario non inviato: ordine ${orderId} senza prodotti idonei.`);
        } else if (shouldDelayQuestionario) {
          console.info(`Questionario posticipato: invio programmato per ${plannedStartAt}.`);
        }
      }
    } else {
      console.warn('Salto creazione ticket conferma ordine: userUid destinatario non disponibile.');
    }

    if (isGift && !recipientUid) {
      console.warn('Gift order senza recipientUid: impossibile inviare messaggio al destinatario.');
    }

    if (ticketCreated) {
      const stamp = {
        orderConfirmationTicketAt: new Date().toISOString(),
        orderConfirmationTicketBy: auth?.currentUser?.uid || null,
      };
      try {
        await updateDoc(doc(this.db, 'orders', String(orderId)), stamp);
        if (orderPayload) Object.assign(orderPayload, stamp);
      } catch (stampErr) {
        console.warn('Impossibile salvare orderConfirmationTicketAt:', stampErr);
      }
    }
  } catch (err) {
    console.error('createOrderConfirmationTicket error:', err);
  }
},

async resolveOrderRecipients({ payload = {}, orderId, ensureResult }) {
  let recipientUid = payload.userUid || ensureResult?.uid || this.userLookup?.uid || null;
  if (!recipientUid && payload.userEmail) {
    recipientUid = await this.resolveUserUidByEmail(payload.userEmail);
    if (recipientUid && !payload.userUid && orderId) {
      try {
        await updateDoc(doc(this.db, 'orders', String(orderId)), { userUid: recipientUid });
      } catch (linkErr) {
        console.warn('Impossibile aggiornare l\'ordine con userUid:', linkErr);
      }
    }
  }

  let payerUid = null;
  const gift = payload.gift || {};
  const payerEmail = gift.fromEmail || gift.payerEmail || payload.payerEmail || null;
  if (gift.fromUid) payerUid = gift.fromUid;
  else if (payerEmail) {
    payerUid = await this.resolveUserUidByEmail(payerEmail);
  }

  return { recipientUid, payerUid };
},

composeOrderTicketMessage({ orderId, orderPayload }) {
  const payload = orderPayload || {};
  const statusLabel = this.formatStatus(payload.status);
  const totalFormatted = this.formatPrice(payload.totalPrice);
  const paymentLabel = this.formatLabel(payload.paymentMethod);
  const guideLink = 'https://www.metodofusco.it/tickets/#/come-funziona';
  const guideCta = `👉 Clicca qui per accedere alla guida completa: ${guideLink}`;
  const connectAppLinks = [
    'iOS – Fusco Fit Connect: https://apps.apple.com/it/app/fusco-fit/id6444216077',
    'Android – Fusco Fit Connect: https://play.google.com/store/apps/details?id=com.elev8ted.fuscofit',
  ].join(' · ');
  const nameParts = [payload.customerName, payload.customerSurname]
    .map(part => (part || '').trim())
    .filter(Boolean);
  const greeting = nameParts.length ? `Ciao ${nameParts.join(' ')},` : 'Ciao,';
  const lines = [greeting];

  lines.push(`ti confermo la registrazione dell'ordine ${orderId}.`);

  if (payload.orderDate) {
    lines.push(`Data ordine: ${this.formatDate(payload.orderDate)}.`);
  }

  if (totalFormatted && totalFormatted !== '—') {
    lines.push(`Totale ordine: ${totalFormatted}.`);
  }

  if (paymentLabel && paymentLabel !== '—') {
    lines.push(`Metodo di pagamento: ${paymentLabel}.`);
  }

  if (statusLabel && statusLabel !== '—') {
    lines.push(`Stato attuale: ${statusLabel}.`);
  }

  const products = Array.isArray(payload.products) ? payload.products : [];
  if (products.length) {
    lines.push('Prodotti inclusi:');
    products.forEach(prod => {
      const qty = Number(prod.quantity) || 1;
      const prodName = prod.name || 'Prodotto';
      lines.push(`- ${prodName} x${qty}`);
    });
  }

  lines.push('');
  lines.push('Siamo entusiasti di darti il benvenuto al tuo nuovo percorso personalizzato con Fusco Fit.');
  lines.push('Per aiutarti a iniziare, abbiamo preparato una semplice guida passo dopo passo.');
  lines.push(guideCta);
  lines.push('');
  lines.push(
    'Se hai domande, il nostro team di supporto è a disposizione per aiutarti. Contattaci su “Assistenza tecnica” nell’app Fusco Fit Connect (logo nero).'
  );
  lines.push(`Scarica la nostra app. ${connectAppLinks}`);
  lines.push('');
  lines.push(
    'Per ogni aspetto contrattuale e di servizio fanno fede i Termini e Condizioni e la Scheda Servizi pubblicati sul sito ufficiale: https://www.fusco.fit/termini-e-condizioni/ e https://www.fusco.fit/scheda-servizi/'
  );
  lines.push('');
  lines.push('Grazie per aver scelto Fusco Fit, non vediamo l’ora di supportarti nel tuo percorso verso il benessere!');
  lines.push('A presto,');
  lines.push('');
  lines.push('Il team Fusco Fit');

  return lines.join('\n').trim();
},

composeGiftPayerMessage({ orderId, orderPayload }) {
  const payload = orderPayload || {};
  const recipientEmail = payload.gift?.recipient?.email || payload.userEmail || 'il destinatario';
  const paymentLabel = this.formatLabel(payload.paymentMethod);
  const totalFormatted = this.formatPrice(payload.totalPrice);
  const statusLabel = this.formatStatus(payload.status);
  const lines = [
    'Ciao,',
    `ti confermiamo il pagamento del tuo regalo per ${recipientEmail}.`,
  ];
  if (totalFormatted && totalFormatted !== '—') lines.push(`Importo: ${totalFormatted}.`);
  if (paymentLabel && paymentLabel !== '—') lines.push(`Metodo di pagamento: ${paymentLabel}.`);
  if (statusLabel && statusLabel !== '—') lines.push(`Stato ordine: ${statusLabel}.`);
  lines.push(`ID ordine: ${orderId}.`);
  return lines.join('\n');
},

composeGiftRecipientMessage({ orderId, orderPayload }) {
  const payload = orderPayload || {};
  const fromEmail = payload.gift?.fromEmail || payload.gift?.payerEmail || 'un amico';
  const customMsg = (payload.gift?.message || '').trim();
  const lines = [
    'Hai ricevuto un regalo!',
    `Ti è stato regalato un percorso da ${fromEmail}.`,
    `ID ordine: ${orderId}.`,
  ];
  if (customMsg) {
    lines.push('');
    lines.push('Messaggio:');
    lines.push(customMsg);
  }
  return lines.join('\n');
},

async fetchQuestionarioStepLink({ userUid, orderId }) {
  if (!this.db || !userUid) return null;
  const percorsiCol = collection(this.db, 'percorsi');
  const orderRef = orderId ? String(orderId) : null;

  const extractLink = (docs = []) => {
    for (const docSnap of docs) {
      if (!docSnap?.exists?.()) continue;
      const data = docSnap.data() || {};
      if (data.uid && data.uid !== userUid) continue;
      const steps = Array.isArray(data.steps) ? data.steps : [];
      const idx = steps.findIndex((step) => stepKeyFromName(step?.name) === 'questionario');
      if (idx >= 0) {
        const step = steps[idx] || {};
        const docId =
          step.questionarioDocId ||
          step.questionnaire?.questionarioUid ||
          step.questionnaire?.questionarioKey ||
          null;
        const link = buildProgramStepLink({
          stepKey: 'questionario',
          userUid,
          percorsoId: docSnap.id,
          stepIndex: idx,
          questionarioDocId: docId,
          questionarioUid: docId,
        });
        return {
          link: link || null,
          percorsoId: docSnap.id,
          percorsoRef: docSnap.ref,
          stepIndex: idx,
          steps,
          step,
        };
      }
    }
    return null;
  };

  try {
    if (orderRef) {
      const snapByOrder = await getDocs(
        query(percorsiCol, where('orderRef', '==', orderRef), limit(10))
      );
      const meta = extractLink(snapByOrder.docs);
      if (meta) return meta;
    }

    const snapByUser = await getDocs(
      query(percorsiCol, where('uid', '==', userUid), limit(10))
    );
    return extractLink(snapByUser.docs);
  } catch (err) {
    console.warn('fetchQuestionarioStepLink error:', err);
    return null;
  }
},

async markQuestionarioTicketSent(meta = {}) {
  const stepIndex = Number.isFinite(meta.stepIndex) ? meta.stepIndex : null;
  if (stepIndex === null) return;
  const ref = meta.percorsoRef
    || (meta.percorsoId ? doc(this.db, 'percorsi', String(meta.percorsoId)) : null);
  if (!ref) return;

  let steps = Array.isArray(meta.steps) ? [...meta.steps] : null;
  if (!steps) {
    const snap = await getDoc(ref);
    if (!snap.exists()) return;
    const data = snap.data() || {};
    steps = Array.isArray(data.steps) ? [...data.steps] : [];
  }
  if (!steps[stepIndex]) return;

  const nowIso = new Date().toISOString();
  steps[stepIndex] = {
    ...steps[stepIndex],
    ticketQuestionarioSentAt: { sentAt: nowIso },
  };

  await updateDoc(ref, { steps });
},

  buildQuestionnaireLink() {
    return 'https://www.metodofusco.it/tickets/#/user-programmi?step=questionario';
  },

  composeInitialQuestionnaireMessage(preferredLink) {
    const link = preferredLink || this.buildQuestionnaireLink();
  if (!link) return null;
  const lines = ['Perfetto! Adesso puoi completare il questionario iniziale.'];
  lines.push(`👉 [Clicca qui per completarlo](${link})`);
  lines.push('Oppure accedi alla tua area personale, sezione "Programmi", e apri lo step "Questionario iniziale".');
  return {
    message: lines.join('\n\n').trim(),
    link,
  };
},

async hasActivePercorsi(userUid, { excludeOrderRef } = {}) {
  if (!userUid) return false;
  const canUseCache = !excludeOrderRef;
  if (canUseCache && Object.prototype.hasOwnProperty.call(this.activePercorsiCache, userUid)) {
    return !!this.activePercorsiCache[userUid];
  }

  const isConsulenzaStatusDone = (status) => {
    const normalized = (status || '').toString().trim().toLowerCase();
    return normalized === 'fatta' || normalized === 'rifiutata' || normalized === 'scalata' || normalized === 'scalato';
  };
  const isBlockingStep = (step = {}) => {
    const name = (step?.name || '').toLowerCase();
    if (!name) return true;
    return !name.includes('feedback');
  };
  const isStepDone = (step = {}) => {
    if (step?.done) return true;
    const name = (step?.name || '').toLowerCase();
    if (name.includes('consulenza')) {
      return isConsulenzaStatusDone(step?.consulenzaStatus);
    }
    return false;
  };
  const isCheckFinale = (step = {}) => {
    const name = (step?.name || '').toLowerCase();
    return name.includes('check') || name.includes('scadenza');
  };
  const isPercorsoComplete = (data = {}) => {
    if (data.historyLocked) return true;
    const steps = Array.isArray(data.steps) ? data.steps : [];
    if (!steps.length) return true;
    if (steps.some(isCheckFinale) && steps.some((s) => isCheckFinale(s) && isStepDone(s))) {
      return true;
    }
    const blocking = steps.filter(isBlockingStep);
    if (!blocking.length) return true;
    return blocking.every(isStepDone);
  };

  let active = false;
  try {
    const snap = await getDocs(
      query(collection(this.db, 'percorsi'), where('uid', '==', userUid), limit(20))
    );
    const now = Date.now();
    const excluded = excludeOrderRef ? String(excludeOrderRef) : null;
    for (const docSnap of snap.docs) {
      if (active) break;
      const data = docSnap.data() || {};
      const orderRef = String(data.orderRef || '');
      if (excluded && orderRef === excluded) continue;
      if (isPercorsoComplete(data)) continue;
      const expireMs = this.msFromValue(data.expireAt);
      if (Number.isFinite(expireMs) && expireMs < now) continue;
      const plannedMs = this.msFromValue(data.plannedStartAt || data.createdAt);
      if (Number.isFinite(plannedMs) && plannedMs > now) continue;

      if (orderRef) {
        const orderStatus = await this.fetchOrderStatus(orderRef);
        const isClosed =
          ['rimborsato', 'rimborsato parzialmente', 'cancellato', 'scaduto'].includes(
            (orderStatus || '').toLowerCase()
          );
        if (isClosed) continue;
      }

      active = true;
    }
  } catch (err) {
    console.warn('hasActivePercorsi error:', err);
  }

  if (canUseCache) {
    if (this.$set) this.$set(this.activePercorsiCache, userUid, active);
    else this.activePercorsiCache[userUid] = active;
  }
  return active;
},

async fetchOrderStatus(orderId) {
  const key = String(orderId || '');
  if (!key) return null;
  if (Object.prototype.hasOwnProperty.call(this.orderStatusCache, key)) {
    return this.orderStatusCache[key];
  }
  let status = null;
  try {
    const snap = await getDoc(doc(this.db, 'orders', key));
    if (snap.exists()) {
      const data = snap.data() || {};
      status = data.status || null;
    }
  } catch (err) {
    console.warn('fetchOrderStatus error:', err);
  }
  if (this.$set) this.$set(this.orderStatusCache, key, status);
  else this.orderStatusCache[key] = status;
  return status;
},



async saveOrder({ skipCreditWarning = false } = {}) {
  this.errorMsg = '';
  this.successMsg = '';

  if (!canManuallyManageCredit(auth.currentUser)
    && (Number(this.form.creditApplied) > 0 || this.form.paymentMethod === 'credito')) {
    this.errorMsg = 'L’utilizzo manuale del saldo sugli ordini è riservato a Valerio.';
    return;
  }

  if (this.lines.some(line => this.isGiftCardOrder({ products: [line] }))) {
    this.errorMsg = 'Per acquistare una gift card usa la pagina Gift: il saldo viene accreditato dopo la conferma del pagamento.';
    return;
  }

  const normalizedUserEmail = this.normalizeEmail(this.form.userEmail);
  if (normalizedUserEmail) {
    this.form.userEmail = normalizedUserEmail;
  }
  if (!normalizedUserEmail) {
    this.errorMsg = 'Inserisci l’email utente';
    return;
  }
  if (!this.form.orderDateLocal) {
    this.errorMsg = 'Seleziona la data ordine';
    return;
  }
  if (!this.lines.length) {
    this.errorMsg = 'Aggiungi almeno un prodotto';
    return;
  }
  const invalidManualPriceLine = this.lines.find((line) => this.hasInvalidManualPriceLine(line));
  if (invalidManualPriceLine) {
    this.errorMsg = `Inserisci un prezzo maggiore di 0 € per ${invalidManualPriceLine.name || 'INTEGRAZIONE SERVIZI'}`;
    return;
  }
  if (!this.form.userPhone?.trim()) {
    this.errorMsg = 'Inserisci il numero di telefono';
    return;
  }
  if (this.creditAppliedAmount > 0 && !this.userCredit.uid) {
    this.errorMsg = 'Credito non applicabile: utente non agganciato.';
    return;
  }
  if (!skipCreditWarning && this.shouldPromptUnusedCredit()) {
    this.showCreditUsageConfirm = true;
    return;
  }
  if (this.creditAppliedAmount > 0 && this.creditAppliedAmount >= this.totalAfterManualDiscount) {
    this.form.paymentMethod = 'credito';
  }
  if (!this.form.paymentMethod) {
    this.errorMsg = 'Seleziona il metodo di pagamento';
    return;
  }
  if (this.form.paymentMethod === 'credito' && this.computedDiscountTotal > 0.01) {
    this.errorMsg = 'Il credito non copre tutto l’ordine: seleziona un metodo di pagamento per la differenza.';
    return;
  }

  // Applico le regole automatiche in caso il watcher non sia scattato
  const m = this.form.paymentMethod;
  const instantPaidMethods = ['contanti', 'pos', 'welfare', 'credito'];
  const manualSplit = m === 'rate_manuali';
  let provider = '';
  if (m === 'paypal') provider = 'paypal';
  else if (m === 'alma') provider = 'alma';
  else if (m === 'klarna') provider = 'klarna';
  else if (m === 'welfare') provider = (this.form.welfareProvider || '').trim();
  if (m === 'welfare' && !provider) {
    this.errorMsg = 'Seleziona il circuito Welfare';
    return;
  }
  let status = this.form.status;
  if (instantPaidMethods.includes(m)) status = 'pagato';
  else if (m === 'bonifico' || m === 'paypal' || m === 'alma' || m === 'klarna') status = 'in attesa di pagamento';
  else if (manualSplit) status = 'in attesa di pagamento';

  const isPending = status === 'in attesa di pagamento';
  let paymentStatus = instantPaidMethods.includes(m) ? 'completed' : (isPending ? 'pending' : 'n/a');
  if (manualSplit) {
    paymentStatus = isPending ? 'pending' : 'completed';
  }

  const orderId = this.makeManualOrderId();
  const nowIso = new Date().toISOString();
  const orderDateStr = this.toMysqlDateTime(this.form.orderDateLocal);
  const creatorUid = auth?.currentUser?.uid || null;
  const creatorEmail = this.normalizeEmail(auth?.currentUser?.email || '') || null;
  const percorsiStartAt = this.normalizePercorsiStartDate(this.form.percorsiStartDate);
  const productsPayload = this.lines.map((l) => {
    const payloadLine = {
      id: l.productId,
      name: l.name,
      sku: l.sku || null,
      price: Number(l.price) || 0,
      quantity: Number(l.quantity) || 1,
    };
    if (l.vat22Applied) {
      payloadLine.vat22Applied = true;
      payloadLine.netPriceBeforeVat = Number(l.netPriceBeforeVat) || 0;
      payloadLine.vatRate = Number(l.vatRate) || VAT_22_RATE;
    }
    const ptQty = Number(l.pt_quantity);
    if (Number.isFinite(ptQty) && ptQty > 0) {
      payloadLine.pt_quantity = ptQty;
    }
    return payloadLine;
  });
  const hasTopProduct = orderHasTopProduct({ products: productsPayload });
  const originalStudio = (this.form.userStudio || '').trim() || null;
  const forcedStudio = hasTopProduct ? TOP_STUDIO_OVERRIDE : originalStudio;
  const creditApplied = this.roundMoney(this.creditAppliedAmount);
  const manualDiscount = this.roundMoney(this.manualDiscountAmount);
  const grossTotal = this.roundMoney(this.total);
  const payableTotal = this.roundMoney(this.computedDiscountTotal);

  const payload = {
    orderId,
    orderDate: orderDateStr,
    status,                                   // 'pagato' o 'in attesa di pagamento'
    totalPrice: payableTotal,
    grossTotal,
    discount: manualDiscount,
    creditApplied,
    paymentBreakdown: {
      grossTotal,
      discount: manualDiscount,
      creditApplied,
      payableTotal,
    },
    notes: (this.form.notes || '').trim(),
    paymentMethod: m,                         // contanti | pos | welfare | bonifico | paypal | alma | klarna | rate_manuali | ''
    paymentProvider: provider,                // paypal | alma | klarna | ''
    paymentStatus,                            // completed | pending | n/a
    products: productsPayload,
    userEmail: normalizedUserEmail,
    source: 'manuale',
    importedAt: nowIso,
    createdBy: creatorUid,
    createdByEmail: creatorEmail,
  };
  if (percorsiStartAt) {
    payload.percorsiStartAt = percorsiStartAt;
  }
  payload.manualInstallments = [];
  if (provider === 'alma') {
    const almaInstallments = Number(this.form.almaInstallments);
    if (!Number.isFinite(almaInstallments) || almaInstallments <= 0) {
      this.errorMsg = 'Numero rate Alma non valido.';
      return;
    }
    payload.almaInstallments = almaInstallments;
  } else if (manualSplit) {
    const plan = this.buildManualInstallmentsPayload(nowIso);
    if (!plan.length) {
      this.errorMsg = 'Configura almeno una rata manuale.';
      return;
    }
    for (let i = 0; i < plan.length; i += 1) {
      const entry = plan[i];
      if (!Number.isFinite(entry.amount) || entry.amount <= 0) {
        this.errorMsg = `Importo non valido per la rata ${i + 1}.`;
        return;
      }
      if (!entry.scheduledDate) {
        this.errorMsg = `Imposta la data per la rata ${i + 1}.`;
        return;
      }
      if (this.normalizeMethod(entry.method) === 'alma') {
        const almaCount = Number(entry.almaInstallments);
        const allowed = Array.isArray(this.almaInstallmentsOptionsForForm)
          ? this.almaInstallmentsOptionsForForm
          : this.almaInstallmentsOptions;
        if (!Number.isFinite(almaCount) || almaCount <= 0 || !allowed.includes(almaCount)) {
          this.errorMsg = `Seleziona il numero di rate Alma per la rata ${i + 1}.`;
          return;
        }
        entry.almaInstallments = almaCount;
      }
      if (!entry.status) entry.status = 'in attesa di pagamento';
      if (String(entry.status).toLowerCase() === 'pagato' && !entry.paidAt) {
        entry.paidAt = nowIso;
      }
    }
    const planTotal = plan.reduce((sum, entry) => sum + entry.amount, 0);
    if (Math.abs(planTotal - payload.totalPrice) > 0.01) {
      this.errorMsg = 'La somma delle rate manuali deve coincidere con il totale ordine.';
      return;
    }
    const hasAlmaInstallment = plan.some(inst => this.normalizeMethod(inst.method) === 'alma');
    if (hasAlmaInstallment) {
      provider = 'alma';
      payload.paymentProvider = 'alma';
    }
    const installmentsState = this.manualInstallmentsOrderState(plan);
    if (installmentsState.hasPaid) {
      payload.status = installmentsState.status;
      payload.paymentStatus = installmentsState.paymentStatus;
    }
    payload.manualInstallments = plan;
  }

  try {
    this.saving = true;

    let ensureResult;
    try {
      ensureResult = await this.ensureUserForOrder({
        email: this.form.userEmail,
        name: this.form.userName,
        surname: this.form.userSurname,
        studio: forcedStudio,
        phone: this.form.userPhone,
        codFiscale: this.form.userCodFiscale,
      });
    } catch (userErr) {
      this.errorMsg = userErr?.message || 'Errore nella creazione del profilo utente.';
      return;
    }

    const newUserCreated = ensureResult && ensureResult.existed === false;
    if (ensureResult?.uid) {
      payload.userUid = ensureResult.uid;
    }
    if (newUserCreated) {
      payload.newUserCreated = true;
    }
    payload.customerName = (this.form.userName || '').trim() || null;
    payload.customerSurname = (this.form.userSurname || '').trim() || null;
    payload.customerStudio = forcedStudio || null;
    if (hasTopProduct && originalStudio && originalStudio !== forcedStudio) {
      payload.customerStudioOriginal = originalStudio || null;
    }
    const normalizedPhone = (this.form.userPhone || '').trim() || null;
    payload.customerPhone = normalizedPhone;
    payload.phone = normalizedPhone;
    if (ensureResult?.uid && normalizedPhone) {
      try {
        await updateDoc(doc(this.db, 'users', ensureResult.uid), {
          phone: normalizedPhone,
          updatedAt: new Date().toISOString(),
        });
      } catch (err) {
        console.warn('Impossibile aggiornare il telefono utente:', err);
      }
    }
    payload.customerCodFiscale = (this.form.userCodFiscale || '').trim() || null;

    if (hasTopProduct && ensureResult?.uid) {
      await this.applyTopStudioOverride({
        userUid: ensureResult.uid,
        orderId,
        originalStudio,
        forcedStudio,
        payload,
      });
    }

    const topSkuFields = buildTopSkuFields(payload, { fallbackToNow: true });
    Object.assign(payload, topSkuFields);

    // 1) salvo ordine e, se richiesto, scarico il credito utente nella stessa transazione
    const ref = doc(collection(this.db, 'orders'), orderId);
    const creditUserUid = ensureResult?.uid || this.userCredit.uid || null;
    if (creditApplied > 0 && !creditUserUid) {
      throw new Error('Credito non applicabile: utente non agganciato.');
    }
    const updatedCredit = await this.saveOrderAndApplyCredit({
      orderRef: ref,
      userUid: creditUserUid,
      orderId,
      payload,
      creditApplied,
      nowIso,
    });
    if (updatedCredit && this.userCredit.uid === creditUserUid) {
      this.userCredit.total = updatedCredit.total;
      this.userCredit.movements = updatedCredit.movements;
      this.form.creditApplied = 0;
    }

    if (this.isPaidOrProcessingStatus(payload.status)) {
      await this.applyUserNewPurchaseState(payload);
    }

    // 2) link pagamento per provider esterni
    if (provider === 'paypal') {
      const CF_URL = getPayPalFunctionUrl('create');
      if (CF_URL) {
        try {
          const basePath = (process.env.BASE_URL || '/').replace(/\/?$/, '/');
          const appBaseUrl = window.location.origin + basePath;
          const returnUrl = `${appBaseUrl}#/paypal/return?orderId=${encodeURIComponent(orderId)}`;
          const cancelUrl = `${appBaseUrl}#/paypal/cancel?orderId=${encodeURIComponent(orderId)}`;

          const resp = await fetch(CF_URL, {
            method: 'POST',
            headers: await this.paypalRequestHeaders(),
            body: JSON.stringify({
              orderId,
              amount: Number(payload.totalPrice).toFixed(2),
              currency: 'EUR',
              userEmail: normalizedUserEmail,
              returnUrl,
              cancelUrl,
              items: productsPayload.map(p => ({ name: p.name, quantity: p.quantity, unit_amount: p.price })),
              metadata: {
                createdFrom: 'OrderComponentNew',
                creditApplied,
              }
            })
          });
          if (!resp.ok) throw new Error(await resp.text());
          const data = await resp.json(); // { paypalOrderId, approveLink }
          await updateDoc(ref, {
            paypalOrderId: data.paypalOrderId || null,
            paypalApproveLink: data.approveLink || null,
            paymentStatus: 'pending'
          });
        } catch (ppErr) {
          console.error('createPayPalOrder:', ppErr);
          this.errorMsg = 'Ordine creato, ma errore nella creazione del link PayPal.';
        }
      } else {
        console.warn('VITE_FN_CREATE_PAYPAL_ORDER non configurato');
      }
    } else if (provider === 'alma' && !manualSplit) {
      const CF_URL = getAlmaFunctionUrl('create');
      if (CF_URL) {
        try {
          const basePath = (process.env.BASE_URL || '/').replace(/\/?$/, '/');
          const appBaseUrl = window.location.origin + basePath;
          const configuredReturn = (getEnvVar('VITE_ALMA_RETURN_URL') || '').trim();
          const configuredCancel = (getEnvVar('VITE_ALMA_CANCEL_URL') || '').trim();
          const configuredFailure = (getEnvVar('VITE_ALMA_FAILURE_URL') || '').trim();
          const configuredCustomerUrl = (getEnvVar('VITE_ALMA_CUSTOMER_URL') || '').trim();
          const configuredMerchantUrl = (getEnvVar('VITE_ALMA_MERCHANT_URL') || '').trim();
          const captureMethodEnv = (getEnvVar('VITE_ALMA_CAPTURE_METHOD') || '').trim().toLowerCase();
          const expiresAfterEnv = parseInt((getEnvVar('VITE_ALMA_EXPIRES_AFTER_MINUTES') || '').trim(), 10);
          const almaReturnUrl = configuredReturn || `${appBaseUrl}#/orders-general`;
          const almaCancelUrl = configuredCancel || almaReturnUrl;
          const almaFailureUrl = configuredFailure || almaCancelUrl;
          const locale = (getEnvVar('VITE_ALMA_LOCALE') || 'it').trim() || 'it';
          const ipnUrl = (getEnvVar('VITE_ALMA_IPN_URL') || getEnvVar('VITE_ALMA_WEBHOOK_URL') || '').trim();

          const almaPayload = {
            orderId,
            amount: Number(payload.totalPrice).toFixed(2),
            installments: Number(this.form.almaInstallments) || 3,
            userEmail: normalizedUserEmail,
            customer: {
              firstName: (this.form.userName || '').trim(),
              lastName: (this.form.userSurname || '').trim(),
              phone: this.normalizeAlmaPhone(this.form.userPhone || ''),
              studio: (this.form.userStudio || '').trim(),
              isBusiness: false,
            },
            discount: manualDiscount,
            creditApplied,
            notes: (this.form.notes || '').trim(),
            returnUrl: almaReturnUrl,
            cancelUrl: almaCancelUrl,
            failureUrl: almaFailureUrl,
            customerUrl: configuredCustomerUrl || almaReturnUrl,
            merchantUrl: configuredMerchantUrl || '',
            locale,
            items: productsPayload.map(p => ({
              name: p.name,
              quantity: p.quantity,
              price: p.price,
              sku: p.sku || null,
            })),
            metadata: {
              createdFrom: 'OrderComponentNew',
              creditApplied,
            },
          };
          if (ipnUrl) {
            almaPayload.ipnCallbackUrl = ipnUrl;
          }
          if (captureMethodEnv === 'manual' || captureMethodEnv === 'automatic') {
            almaPayload.captureMethod = captureMethodEnv;
          }
          if (Number.isFinite(expiresAfterEnv) && expiresAfterEnv > 0) {
            almaPayload.expiresAfter = expiresAfterEnv;
          }

          const resp = await fetch(CF_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(almaPayload),
          });
          const text = await resp.text();
          if (!resp.ok) {
            throw new Error(text || 'Richiesta Alma non riuscita');
          }
          let almaResponse = null;
          if (text) {
            try {
              almaResponse = JSON.parse(text);
            } catch (parseErr) {
              console.warn('Risposta Alma non JSON:', parseErr);
            }
          }
          if (almaResponse?.paymentUrl) {
            this.successMsg = `Ordine ${orderId} creato. Link Alma: ${almaResponse.paymentUrl}`;
          }
        } catch (almaErr) {
          console.error('createAlmaPayment:', almaErr);
          this.errorMsg = 'Ordine creato, ma errore nella creazione del link Alma.';
        }
      } else {
        console.warn('VITE_FN_CREATE_ALMA_PAYMENT non configurato');
      }
    } else if (provider === 'klarna' && !manualSplit) {
      const CF_URL = getKlarnaFunctionUrl('create');
      if (CF_URL) {
        try {
          const basePath = (process.env.BASE_URL || '/').replace(/\/?$/, '/');
          const appBaseUrl = window.location.origin + basePath;
          const configuredReturn = (getEnvVar('VITE_KLARNA_RETURN_URL') || '').trim();
          const configuredCancel = (getEnvVar('VITE_KLARNA_CANCEL_URL') || '').trim();
          const configuredFailure = (getEnvVar('VITE_KLARNA_FAILURE_URL') || '').trim();
          const configuredCallback = (getEnvVar('VITE_KLARNA_STATUS_CALLBACK_URL') || getEnvVar('VITE_KLARNA_HPP_CALLBACK_URL') || '').trim();
          const placeOrderMode = (getEnvVar('VITE_KLARNA_PLACE_ORDER_MODE') || '').trim().toUpperCase();
          const klarnaReturnUrl = configuredReturn || `${appBaseUrl}#/orders-general`;
          const klarnaCancelUrl = configuredCancel || klarnaReturnUrl;
          const klarnaFailureUrl = configuredFailure || klarnaCancelUrl;
          const locale = (getEnvVar('VITE_KLARNA_LOCALE') || 'it-IT').trim() || 'it-IT';

          const klarnaPayload = {
            orderId,
            amount: Number(payload.totalPrice).toFixed(2),
            currency: 'EUR',
            userEmail: normalizedUserEmail,
            customer: {
              firstName: (this.form.userName || '').trim(),
              lastName: (this.form.userSurname || '').trim(),
              phone: this.normalizeAlmaPhone(this.form.userPhone || ''),
            },
            returnUrl: klarnaReturnUrl,
            cancelUrl: klarnaCancelUrl,
            failureUrl: klarnaFailureUrl,
            locale,
            items: productsPayload.map(p => ({
              id: p.id,
              name: p.name,
              quantity: p.quantity,
              price: p.price,
              sku: p.sku || null,
            })),
            metadata: {
              createdFrom: 'OrderComponentNew',
              creditApplied,
            },
          };
          if (configuredCallback) {
            klarnaPayload.statusCallbackUrl = configuredCallback;
          }
          if (['NONE', 'PLACE_ORDER', 'CAPTURE_ORDER'].includes(placeOrderMode)) {
            klarnaPayload.placeOrderMode = placeOrderMode;
          }

          const resp = await fetch(CF_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(klarnaPayload),
          });
          const text = await resp.text();
          if (!resp.ok) {
            throw new Error(text || 'Richiesta Klarna non riuscita');
          }
          let klarnaResponse = null;
          if (text) {
            try {
              klarnaResponse = JSON.parse(text);
            } catch (parseErr) {
              console.warn('Risposta Klarna non JSON:', parseErr);
            }
          }
          if (klarnaResponse?.paymentUrl) {
            this.successMsg = `Ordine ${orderId} creato. Link Klarna: ${klarnaResponse.paymentUrl}`;
          }
        } catch (klarnaErr) {
          console.error('createKlarnaPayment:', klarnaErr);
          this.errorMsg = 'Ordine creato, ma errore nella creazione del link Klarna.';
        }
      } else {
        console.warn('VITE_FN_CREATE_KLARNA_PAYMENT non configurato');
      }
    }

    // 3) se esiste almeno una rata incassata (o pagamento istantaneo) → crea percorsi subito
    const shouldCreatePercorsiNow =
      payload.status === 'pagato' ||
      (manualSplit && this.hasPaidManualInstallments(payload.manualInstallments));
    if (shouldCreatePercorsiNow) {
      await this.createPercorsiForOrder({ ...payload });
    }

    await this.createOrderConfirmationTicket({
      orderId,
      orderPayload: payload,
      ensureResult,
      newUserCreated,
    });

    if (!this.successMsg) {
      this.successMsg = `Ordine ${orderId} creato con successo!`;
    }
    await this.reload();
    this.closeCreate();
  } catch (e) {
    console.error(e);
    this.errorMsg = e?.message || 'Errore durante il salvataggio dell’ordine';
  } finally {
    this.saving = false;
  }
}

  },
};
</script>


<style scoped>
/* cards & layout */
.card-surface {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
  padding: 18px 20px;
  margin-top: 18px;
}

.toolbar-card {
  margin-top: 24px;
}

.filters-header {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.accordion-toggle {
  flex: 1 1 320px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #0f172a;
  cursor: pointer;
  transition: border 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.accordion-toggle:hover {
  background: #fff;
  border-color: #cbd5e1;
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);
}

.accordion-toggle .material-icons {
  font-size: 22px;
  color: #475569;
}

.toggle-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.toggle-title {
  font-weight: 700;
  font-size: 0.95rem;
}

.toggle-subtitle {
  font-size: 0.82rem;
  color: #64748b;
}

.accordion-panel {
  margin-top: 14px;
  padding: 14px 12px;
  border-radius: 14px;
  border: 1px solid #f1f5f9;
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.accordion-enter-active,
.accordion-leave-active {
  transition: all 0.18s ease;
}

.accordion-enter,
.accordion-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.orders-card {
  padding: 0;
  overflow: hidden;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
}

.toolbar-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 0 0 auto;
}

.toolbar-group--sm { width: 220px; }
.toolbar-group--lg { width: 220px; }
.toolbar-group--md { width: 200px; }
.toolbar-group--xs { width: auto; }

.toolbar-label {
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}
.date-range-input {
  width: 85%!important;
}

.checkbox-group {
  align-self: flex-start;
}

.checkbox-inline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #0f172a;
  cursor: pointer;
}

.checkbox-inline input {
  width: 18px;
  height: 18px;
  accent-color: #2563eb;
  cursor: pointer;
}

.toolbar-actions {
  display: flex;
  gap: 30px;
  flex: 0 0 auto;
}

.toolbar-spacer {
  flex: 1 1 auto;
}

.input {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #0f172a;
  transition: border 0.2s ease, box-shadow 0.2s ease;
}

.input:focus {
  border-color: #2563eb;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
  outline: none;
}

.input--multi-open {
  min-height: 200px;
}

/* buttons */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  text-decoration: none;
  border-radius: 12px;
  border: 1px solid transparent;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.12);
}

.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}

.btn.primary {
  background: linear-gradient(135deg, #2563eb, #4f46e5);
  color: #fff;
}

.btn.ghost {
  background: #f1f5f9;
  color: #1e293b;
  border-color: #e2e8f0;
}

.btn.warning {
  background: linear-gradient(135deg, #f97316, #ea580c);
  color: #fff;
}

.btn.danger {
  background: #dc2626;
  color: #fff;
}

.btn.tiny {
  font-size: 0.78rem;
  padding: 6px 10px;
}

/* table */
.table-wrap {
  overflow-x: auto;
}

.orders-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.orders-table thead th {
  text-align: left;
  padding: 14px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.82rem;
  font-weight: 700;
  color: #475569;
  position: sticky;
  top: 0;
  z-index: 2;
}

.orders-table tbody td {
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
  color: #0f172a;
  font-size: 0.92rem;
}

.orders-table tbody tr:last-child td {
  border-bottom: none;
}
.email-cell {
  max-width: 190px;
  width: 190px;
}

.email-cell__content {
  display: flex;
  align-items: center;
  gap: 6px;
}

.email-tooltip {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
}

.table-email {
  font-weight: 600;
  color: #1d4ed8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1 auto;
}

.email-tooltip__content {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.2);
  padding: 8px 12px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
  opacity: 0;
  transform: translateY(-6px);
  pointer-events: none;
  transition: opacity 0.18s ease, transform 0.18s ease;
  z-index: 35;
}

.email-tooltip:hover .email-tooltip__content {
  opacity: 1;
  transform: translateY(0);
}

.email-profile-btn {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: #e0e7ff;
  color: #1e3a8a;
  cursor: pointer;
  transition: background 0.18s ease, transform 0.18s ease;
}

.email-profile-btn:hover:not(:disabled) {
  background: #c7d2fe;
  transform: translateY(-1px);
}

.email-profile-btn:disabled {
  opacity: 0.5;
  cursor: default;
  transform: none;
}

.products-cell {
  max-width: 220px;
  width: 220px;
  font-size: 0.85rem;
  color: #0f172a;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.order-note-cell {
  max-width: 240px;
  width: 240px;
  vertical-align: top !important;
}

.order-note-input {
  display: block;
  width: 100%;
  min-width: 180px;
  height: 54px;
  min-height: 54px;
  margin: 0;
  padding: 8px 10px;
  box-sizing: border-box;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  color: #475569;
  font: inherit;
  font-size: 0.84rem;
  line-height: 1.35;
  resize: vertical;
  transition: border-color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;
}

.order-note-input:focus {
  border-color: #2563eb;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.14);
  outline: none;
}

.order-note-input:disabled {
  opacity: 0.65;
  cursor: wait;
}

.order-note-feedback {
  display: block;
  margin-top: 5px;
  color: #64748b;
  font-size: 0.7rem;
}

.order-note-feedback--error {
  color: #dc2626;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 0.68rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  background: #e2e8f0;
  color: #0f172a;
}

.status-badge__nearby-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: rgba(146, 64, 14, 0.16);
  color: #92400e;
  cursor: pointer;
  border: 1px solid transparent;
}

.status-badge__nearby-icon:focus-visible,
.status-badge__nearby-icon:hover {
  border-color: rgba(146, 64, 14, 0.45);
}

.status-badge__nearby-icon .material-icons {
  font-size: 10px;
  line-height: 1;
}

.status-badge--pagato,
.status-badge--wc-completed,
.status-badge--wc-processing { background: #dcfce7; color: #166534; }
.status-badge--rateizzato { background: #dbeafe; color: #1d4ed8; }
.status-badge--in-attesa-di-pagamento,
.status-badge--wc-pending { background: #fef3c7; color: #92400e; }
.status-badge--rimborsato { background: #cffafe; color: #0e7490; }
.status-badge--scaduto { background: #ffe4e6; color: #be123c; }
.status-badge--wc-cancelled {
  background: #fee2e2;
  color: #b91c1c;
}
.status-badge--cancellato {
  background: #fee2e2;
  color: #b91c1c;
}
.status-badge--unknown { background: #e2e8f0; color: #334155; }

.order-row {
  transition: background 0.2s ease;
}

.order-row:hover {
  background: rgba(37, 99, 235, 0.06);
}

.order-row--pagato,
.order-row--rateizzato,
.order-row--wc-completed,
.order-row--wc-processing,
.order-row--in-attesa-di-pagamento,
.order-row--wc-pending,
.order-row--wc-cancelled,
.order-row--unknown {
  background: transparent;
}

.details-row { background: transparent !important; }
.badge-src {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
}

.badge-src[data-src="woocommerce"] { background:#e0efff; color:#1d4ed8; }
.badge-src[data-src="legacy"] { background:#fff3dc; color:#9a3412; }
.badge-src[data-src="manuale"] { background:#dcfce7; color:#166534; }
.badge-src[data-src="fuscofit"] { background:#ffe4e6; color:#be123c; }
.badge-src[data-src="unknown"],
.badge-src:not([data-src]) { background:#e2e8f0; color:#475569; }

.payment-cell { position: relative; }

.payment-summary {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #f8fafc;
  border-radius: 18px;
  border: 1px solid #e2e8f0;
  padding: 8px 14px;
  cursor: default;
}

.payment-summary__icon {
  font-size: 18px;
  color: #94a3b8;
}

.payment-pill {
  display: inline-block;
  max-width: 200px;
  padding: 6px 12px;
  border-radius: 12px;
  background: #e0e7ff;
  color: #312e81;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 1.25;
  text-align: center;
  white-space: normal;
}

.payment-pill.small {
  background: #0f172a;
  color: #fff;
  font-size: 0.68rem;
}

.payment-tooltip {
  position: absolute;
  top: calc(100% + 12px);
  left: 50%;
  width: min(420px, calc(100vw - 32px));
  min-width: 240px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 22px 45px rgba(15, 23, 42, 0.22);
  padding: 14px 16px;
  display: grid;
  gap: 10px;
  opacity: 0;
  transform: translate(-50%, -8px);
  pointer-events: none;
  transition: opacity 0.18s ease, transform 0.18s ease;
  z-index: 40;
}

.payment-summary--manual:hover .payment-tooltip,
.payment-summary--manual:focus-within .payment-tooltip {
  opacity: 1;
  transform: translate(-50%, 0);
  pointer-events: auto;
}

.payment-tooltip__line {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.payment-label {
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
}

.payment-value {
  font-weight: 600;
  color: #0f172a;
  display: inline-flex;
  gap: 6px;
  align-items: center;
  flex-wrap: wrap;
}

.payment-tooltip__actions {
  display: flex;
  gap: 10px;
  margin-top: 4px;
}

.payment-note {
  color: #64748b;
  font-size: 0.72rem;
}

.btn.icon-btn {
  min-width: 32px;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn.icon-btn .material-icons {
  font-size: 18px;
  line-height: 1;
}

.actions-col {
  text-align: center;
  width: 70px;
}

.actions-cell {
  text-align: center;
}

.icon-toggle-btn {
  border: none;
  background: #e2e8f0;
  color: #0f172a;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}

.icon-toggle-btn:hover {
  background: #cbd5f5;
  transform: translateY(-2px);
}

.icon-toggle-btn .material-icons {
  font-size: 20px;
  line-height: 1;
}

.chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.74rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.chip.neutral { background:#e2e8f0; color:#475569; }
.chip.done { background:#dcfce7; color:#166534; }
.chip.warn { background:#fee2e2; color:#b91c1c; }

.details-cell {
  background: #f8fafc;
  padding: 0;
}

.details {
  padding: 18px 20px 20px;
  display: grid;
  gap: 18px;
}

.meta-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}

.kv {
  background: #fff;
  border-radius: 14px;
  padding: 14px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
  border: 1px solid #e2e8f0;
}

.k {
  display: block;
  font-size: 0.75rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 4px;
}

.v {
  font-weight: 700;
  color: #0f172a;
  word-break: break-all;
}

.products {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  padding: 16px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

.products-title {
  font-weight: 700;
  margin-bottom: 12px;
  color: #0f172a;
}

.products-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  max-height: 240px;
  overflow-y: auto;
}

.products-list li {
  background: #f8fafc;
  border-radius: 14px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.order-management {
  margin-top: 24px;
  display: grid;
  gap: 18px;
}

.management-section {
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  background: #f8fafc;
  padding: 16px 18px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.section-header h4 {
  margin: 0;
  font-size: 1rem;
  color: #0f172a;
}

.status-chip {
  padding: 4px 14px;
  border-radius: 999px;
  background: #e0e7ff;
  color: #312e81;
  font-size: 0.8rem;
  font-weight: 600;
}

.management-actions {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.hint-text {
  font-size: 0.82rem;
  color: #64748b;
}

.status-form-grid {
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
}

.status-file-info {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 0.85rem;
  color: #475569;
}

.status-file-info a {
  color: #2563eb;
  font-weight: 600;
}

.status-actions {
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.status-lock-hint {
  margin-top: 8px;
  color: #b91c1c;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.4;
}

.form-error {
  color: #dc2626;
  font-size: 0.85rem;
}

.product-name {
  font-weight: 600;
  color: #0f172a;
}

.product-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 0.8rem;
  color: #475569;
}

.pagination {
  padding: 16px 20px;
  display: flex;
  justify-content: center;
}

.empty-state {
  text-align: center;
  padding: 32px;
  color: #64748b;
  margin-top: 24px;
}

/* modal */
.modal {
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 24px;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(8px);
  z-index: 3000;
  overflow-y: auto;
}

.dialog {
  width: min(880px, 96vw);
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 32px;
  box-shadow: 0 50px 120px rgba(15, 23, 42, 0.25);
  padding: 34px 38px 32px;
  position: relative;
  max-height: calc(100vh - 120px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-form {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1 1 auto;
  min-height: 0;
}

.form-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding-right: 8px;
  padding-bottom: 16px;
  min-height: 0;
}

.modal-title h3 {
  margin: 0;
  font-size: 1.45rem;
  color: #0f172a;
}

.modal-title__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.modal-subtitle {
  margin: 6px 0 18px;
  color: #64748b;
  font-size: 0.9rem;
}

.inline-note {
  margin-top: 10px;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  color: #475569;
  font-size: 0.9rem;
}

.csen-field {
  grid-column: 1 / -1;
}

.csen-callout {
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.csen-callout__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.csen-callout__title {
  font-weight: 700;
  color: #0f172a;
}

.csen-callout__meta {
  font-size: 0.8rem;
  color: #64748b;
}

.csen-callout__badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #475569;
}

.csen-callout__badge .material-icons {
  font-size: 16px;
}

.csen-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid #e2e8f0;
  background: #f1f5f9;
  color: #475569;
  font-size: 0.72rem;
  font-weight: 600;
  white-space: nowrap;
}

.csen-badge .material-icons {
  font-size: 14px;
}

.csen-badge__text {
  line-height: 1;
}

.csen-callout__dates {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 0.85rem;
  color: #334155;
}

.csen-status--valid {
  border-color: #bbf7d0;
  background: #ecfdf3;
  color: #166534;
}

.csen-status--valid.csen-callout__badge,
.csen-status--valid .csen-callout__badge {
  background: #dcfce7;
  color: #166534;
}

.csen-status--warning {
  border-color: #fde68a;
  background: #fffbeb;
  color: #92400e;
}

.csen-status--warning.csen-callout__badge,
.csen-status--warning .csen-callout__badge {
  background: #fef3c7;
  color: #92400e;
}

.csen-status--expired {
  border-color: #fecaca;
  background: #fef2f2;
  color: #b91c1c;
}

.csen-status--expired.csen-callout__badge,
.csen-status--expired .csen-callout__badge {
  background: #fee2e2;
  color: #b91c1c;
}

.csen-status--missing {
  border-color: #e2e8f0;
  background: #f8fafc;
  color: #64748b;
}

.csen-status--missing.csen-callout__badge,
.csen-status--missing .csen-callout__badge {
  background: #e2e8f0;
  color: #64748b;
}


.grid {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field label {
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #475569;
}

.field input,
.field select {
  padding: 12px 16px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #0f172a;
  transition: border 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.input2 {
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #0f172a;
  transition: border 0.2s ease, box-shadow 0.2s ease;
}



.field input:focus,
.field select:focus {
  border-color: #2563eb;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
  outline: none;
}

.hint {
  color: #94a3b8;
  font-size: 0.78rem;
  line-height: 1.4;
}

.block {
  margin-top: 28px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.block-title {
  font-weight: 700;
  font-size: 1rem;
  color: #0f172a;
}

.picker {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.picker > .input:first-child {
  flex: 1 1 320px;
  min-width: 240px;
}

@media (max-width: 640px) {
  .picker {
    align-items: stretch;
  }
  .picker > .input,
  .picker > .btn,
  .vat-toggle {
    width: 100%;
  }
}

.qty {
  width: 120px;
}

.vat-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 42px;
  padding: 8px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: #f8fafc;
  color: #0f172a;
  font-size: 0.86rem;
  font-weight: 650;
  cursor: pointer;
}

.vat-toggle input {
  width: 16px;
  height: 16px;
}

.vat-toggle strong {
  color: #166534;
  white-space: nowrap;
}

.product-card {
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.12);
  padding: 18px 22px;
  border: 1px solid #e2e8f0;
}

.manual-installments {
  border-radius: 20px;
  background: #f8fafc;
  border: 1px dashed #cbd5f5;
  padding: 18px 20px;
  margin-top: 12px;
  grid-column: 1 / -1;
  overflow: hidden;
}

.installments-table table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;
  table-layout: fixed;
}

.installments-table th,
.installments-table td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.9rem;
  vertical-align: middle;
  word-break: break-word;
}

.installments-table td.right {
  text-align: right;
}

.installments-table tr:last-child td {
  border-bottom: none;
}

.installments-table th:nth-child(1),
.installments-table td:nth-child(1) {
  width: 48px;
}

.installments-table th:nth-child(2),
.installments-table td:nth-child(2) {
  width: 16%;
}

.installments-table th:nth-child(3),
.installments-table td:nth-child(3) {
  width: 16%;
}

.installments-table th:nth-child(4),
.installments-table td:nth-child(4) {
  width: 18%;
}

.installments-table th:nth-child(5),
.installments-table td:nth-child(5) {
  width: 14%;
}

.installments-table th:nth-child(6),
.installments-table td:nth-child(6) {
  width: 22%;
}

.installments-table th:nth-child(7),
.installments-table td:nth-child(7) {
  width: 40px;
}

.installments-table input,
.installments-table select {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.manual-note-input {
  max-width: 90%;
}

.installments-summary {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 0.85rem;
  color: #475569;
}

.installments-summary .warn {
  color: #b45309;
  font-weight: 600;
}

.installments-actions {
  margin-top: 12px;
}

.manual-plan-tooltip {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(148, 163, 184, 0.3);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.manual-plan-tooltip__row {
  display: grid;
  grid-template-columns: 40px 1fr 1fr 1.2fr 1.2fr;
  gap: 6px;
  font-size: 0.78rem;
  align-items: center;
}

.plan-status {
  padding: 2px 6px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
}

.plan-note {
  color: #475569;
  font-size: 0.76rem;
  font-style: italic;
  word-break: break-word;
}
.installments-table th.wide {
  width: 220px;
}
.installments-table th.actions-col,
.installments-table td.actions-col {
  width: 70px;
}
.note-cell input {
  width: 100%;
}

.plan-status--pagato {
  background: #dcfce7;
  color: #166534;
}

.plan-status--in-attesa-di-pagamento,
.plan-status--pending {
  background: #fef3c7;
  color: #92400e;
}

.plan-status--scaduta,
.status-chip--scaduta {
  background: #fee2e2;
  color: #991b1b;
}

.plan-status--annullata,
.status-chip--annullata {
  background: #e2e8f0;
  color: #475569;
}

@media (max-width: 900px) {
  .installments-table table,
  .installments-table thead,
  .installments-table tbody,
  .installments-table tr,
  .installments-table th,
  .installments-table td {
    display: block;
    width: 100%;
  }

  .installments-table thead {
    display: none;
  }

  .installments-table tbody {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .installments-table tbody tr {
    border: 1px solid #dbe4f3;
    border-radius: 16px;
    padding: 14px;
    box-shadow: none;
  }

  .installments-table tbody td {
    border-bottom: none;
    padding: 6px 0;
  }

  .installments-table tbody td::before {
    content: attr(data-label);
    display: block;
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #94a3b8;
    margin-bottom: 2px;
  }

  .installments-table tbody td.right {
    text-align: left;
  }
}

.manual-plan-details {
  margin-top: 24px;
}

.manual-plan-details__title {
  font-weight: 600;
  color: #0f172a;
  font-size: 1rem;
}

.manual-plan-details table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;
}

.manual-plan-details .inline-select {
  width: auto;
  min-width: 140px;
  padding: 6px 10px;
}

.manual-plan-details th,
.manual-plan-details td {
  padding: 10px;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
}

.manual-plan-details th {
  font-size: 0.82rem;
  text-transform: uppercase;
  color: #475569;
  letter-spacing: 0.03em;
}

.manual-plan-details tbody tr:last-child td {
  border-bottom: none;
}

.manual-plan-details tbody tr.manual-installment-row--overdue td {
  background: #fff7f7;
}

.hidden {
  display: none;
}

.manual-proof-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.alma-installments-select {
  margin-top: 6px;
}

.manual-proof-link {
  color: #2563eb;
  font-size: 0.78rem;
  text-decoration: none;
}

.manual-proof-link:hover {
  text-decoration: underline;
}

.installment-paid-note {
  font-size: 0.78rem;
  color: #15803d;
  font-weight: 600;
}

.manual-installment-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
}

.manual-alma-actions {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: center;
}

.lines table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
  border-radius: 18px;
  box-shadow: 0 14px 36px rgba(15, 23, 42, 0.08);
}

.lines thead th {
  background: #f8fafc;
  padding: 12px 14px;
  font-size: 0.82rem;
  color: #475569;
  border-bottom: 1px solid #e2e8f0;
}

.lines tbody td {
  padding: 12px 14px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

.lines tbody tr:last-child td {
  border-bottom: none;
}

.num { text-align: right; }

.qty-inline {
  width: 84px;
  padding: 6px 8px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
}

.total {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}

.modal-footer {
  position: sticky;
  bottom: 0;
  margin-top: 28px;
  padding: 16px 20px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  background: #dddddd;
  border-top: 1px solid rgba(148, 163, 184, 0.15);
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 14px;
}

.dialog .btn.primary {
  min-width: 160px;
}

.dialog .btn.ghost {
  min-width: 120px;
}

.credit-confirm-overlay {
  position: fixed;
  inset: 0;
  z-index: 4200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.62);
  backdrop-filter: blur(5px);
}

.credit-confirm-dialog {
  width: min(460px, 94vw);
  padding: 24px;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 28px 80px rgba(15, 23, 42, 0.35);
  color: #0f172a;
}

.credit-confirm-dialog h3 {
  margin: 0 0 10px;
  font-size: 1.35rem;
}

.credit-confirm-dialog p {
  margin: 0;
  color: #475569;
  line-height: 1.45;
}

.credit-confirm-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin: 18px 0;
  padding: 12px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: #f8fafc;
}

.credit-confirm-summary span {
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.credit-confirm-summary strong {
  color: #075985;
  font-size: 1.2rem;
}

.credit-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.credit-order-card {
  grid-column: 1 / -1;
  padding: 14px 16px;
  border: 1px solid rgba(14, 116, 144, 0.24);
  border-radius: 12px;
  background: #f8fafc;
}

.credit-order-card--applied {
  border-color: rgba(22, 163, 74, 0.38);
  background: #f0fdf4;
}

.credit-order-card__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
}

.credit-order-card__top label {
  margin: 0 0 4px;
}

.credit-order-card__top strong {
  display: block;
  font-size: 1.25rem;
  color: #075985;
}

.credit-order-card--applied .credit-order-card__top strong {
  color: #15803d;
}

.credit-order-card__error {
  color: #dc2626;
}

.footer-total {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.footer-total__label {
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.footer-total__value {
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a;
}

.footer-total__breakdown {
  color: #475569;
  font-size: 0.82rem;
}

.error-msg {
  color: #dc2626;
  margin-top: 12px;
  font-weight: 600;
}

.success-msg {
  color: #16a34a;
  margin-top: 12px;
  font-weight: 600;
}

/* ricevuta pdf */
.receipt-pdf {
  position: absolute;
  left: -9999px;
  top: 0;
  width: 160mm;
  max-width: 160mm;
  padding: 20px;
  box-sizing: border-box;
  background: #ffffff;
  color: #0f172a;
  font-size: 12px;
}

.receipt-pdf.questionario-print-target {
  position: static;
  left: auto;
  top: auto;
  margin: 0 auto;
}

.receipt-logo {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.receipt-logo img {
  height: 58px;
  width: auto;
  display: block;
}

.receipt-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
}

.receipt-title {
  font-size: 18px;
  font-weight: 700;
}

.receipt-subtitle {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
}

.receipt-section {
  margin-top: 16px;
}

.receipt-section-title {
  font-weight: 700;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #475569;
}

.receipt-kv {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 4px 0;
}

.receipt-kv span {
  color: #64748b;
}

.receipt-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px 16px;
}

.receipt-table {
  width: 100%;
  border-collapse: collapse;
}

.receipt-table th,
.receipt-table td {
  padding: 6px 4px;
  border-bottom: 1px solid #e2e8f0;
}

.receipt-table th {
  text-align: left;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
}

.receipt-table .num {
  text-align: right;
}

.receipt-total {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 10px;
  font-weight: 700;
}

.receipt-notes {
  white-space: pre-wrap;
  border: 1px solid #e2e8f0;
  padding: 10px 12px;
  border-radius: 10px;
}

@media (max-width: 768px) {
  .toolbar {
    grid-template-columns: 1fr;
  }

  .btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
.toolbar-group:first-child .input {
  max-width: 220px;
}

<style scoped src="../../assets/css/staff-editor-dialog.css"></style>
<style scoped src="../../assets/css/staff-order-create-dialog.css"></style>

<style scoped src="../../assets/css/staff-orders-mobile.css"></style>
<style scoped src="../../assets/css/staff-orders-mobile-details.css"></style>
